import { snakeCase } from 'snake-case';
import { getShoppingCartProducts, getShoppingCartTotal } from '@artisan-commerce/shopping-cart-core';
import { getProductTotals } from '@artisan-commerce/products';

var __defProp$41 = Object.defineProperty;
var __getOwnPropSymbols$41 = Object.getOwnPropertySymbols;
var __hasOwnProp$41 = Object.prototype.hasOwnProperty;
var __propIsEnum$41 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$41 = (obj, key, value) => key in obj ? __defProp$41(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$41 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$41.call(b, prop))
      __defNormalProp$41(a, prop, b[prop]);
  if (__getOwnPropSymbols$41)
    for (var prop of __getOwnPropSymbols$41(b)) {
      if (__propIsEnum$41.call(b, prop))
        __defNormalProp$41(a, prop, b[prop]);
    }
  return a;
};
const _State = class {
  constructor(state) {
    this._state = state;
    this._initialState = state;
  }
  static getInstance(initialState) {
    if (!_State._instance) {
      _State._instance = new _State(initialState);
    }
    return _State._instance;
  }
  setState(overrides) {
    this._state = __spreadValues$41(__spreadValues$41({}, this._state), overrides);
  }
  get state() {
    if (this._state === null) {
      throw new Error("The state has not been initialized, make sure to call State.init beforehand");
    }
    return this._state;
  }
  checkInit() {
    return !!this._state;
  }
  reset() {
    this._state = this._initialState;
  }
};
let State$1 = _State;
State$1._instance = null;

var name = "@artisan-commerce/analytics-web";
var description = "Artisn commerce analytics web library";
var version = "0.2.0-canary.108";
var type = "module";
var main = "./dist/bundle.cjs";
var module = "./dist/bundle.mjs";
var types = "./dist/bundle.d.ts";
var files = [
	"dist"
];
var sideEffects = false;
var scripts = {
	compile: "rollup -c && npx agadoo",
	dev: "yarn compile -w",
	clean: "rimraf dist",
	prebuild: "yarn clean",
	build: "yarn compile",
	test: "jest  --watchAll --runInBand",
	"test:all": "yarn test --watchAll=false --coverage",
	"test:ci": "cross-env CI=true jest --runInBand",
	"test:staged": "yarn test:ci",
	"check-types": "tsc --noEmit",
	lint: "eslint --ignore-path .gitignore --ignore-pattern !cypress/.eslintrc.cjs --ext .js,jsx,.ts,.tsx .",
	"lint:staged": "yarn lint --max-warnings=0",
	prettier: "prettier --ignore-path .gitignore \"**/*.+(js|jsx|ts|tsx|json|css|scss|html)\"",
	format: "yarn prettier --write",
	"check-format": "yarn prettier --list-different",
	validate: "cross-env CI=true npm-run-all --parallel test:ci check-types check-format lint build",
	"validate:ci": "npm-run-all --parallel check-types check-format lint"
};
var author = "Luis Eduardo Andrade";
var license = "MIT";
var dependencies = {
	"snake-case": "^3.0.4"
};
var devDependencies = {
	"@artisan-commerce/products": "0.9.0-canary.69",
	"@artisan-commerce/shopping-cart-core": "0.12.0-canary.102",
	"@artisan-commerce/state": "0.3.0-canary.18",
	"@artisan-commerce/types": "0.14.0-canary.46"
};
var peerDependencies = {
	"@artisan-commerce/products": "*",
	"@artisan-commerce/shopping-cart-core": "*",
	"@artisan-commerce/state": "*"
};
var nx = {
	targets: {
		build: {
			outputs: [
				"{projectRoot}/dist"
			]
		},
		compile: {
			outputs: [
				"{projectRoot}/dist"
			]
		},
		"test:all": {
			outputs: [
				"{projectRoot}/coverage"
			]
		}
	}
};
var packageJSON = {
	name: name,
	description: description,
	version: version,
	type: type,
	main: main,
	module: module,
	types: types,
	files: files,
	sideEffects: sideEffects,
	scripts: scripts,
	author: author,
	license: license,
	dependencies: dependencies,
	devDependencies: devDependencies,
	peerDependencies: peerDependencies,
	nx: nx
};

const initialState = {
  providers: [],
  activeVendor: void 0,
  vendors: void 0,
  shareArtisnAnalytics: false,
  debug: false,
  initialized: false,
  meta: {
    accountId: void 0,
    vendorId: void 0,
    vendorName: void 0,
    storeId: void 0,
    storeName: void 0,
    catalogueId: void 0,
    catalogueName: void 0,
    appName: void 0,
    platform: "web",
    versionApp: void 0,
    versionSDK: packageJSON.version
  }
};
const State = () => {
  return State$1.getInstance(initialState);
};

const CONSTANTS = {
  GLOBAL_TRACKING_ID: "G-JZ7R91ZNMB"
};

var __defProp$40 = Object.defineProperty;
var __defProps$2x = Object.defineProperties;
var __getOwnPropDescs$2x = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$40 = Object.getOwnPropertySymbols;
var __hasOwnProp$40 = Object.prototype.hasOwnProperty;
var __propIsEnum$40 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$40 = (obj, key, value) => key in obj ? __defProp$40(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$40 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$40.call(b, prop))
      __defNormalProp$40(a, prop, b[prop]);
  if (__getOwnPropSymbols$40)
    for (var prop of __getOwnPropSymbols$40(b)) {
      if (__propIsEnum$40.call(b, prop))
        __defNormalProp$40(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2x = (a, b) => __defProps$2x(a, __getOwnPropDescs$2x(b));
const logMessage = (message, type) => {
  const { debug } = State().state;
  const isProduction = process.env.NODE_ENV === "production";
  const baseMessage = "artisn/analytics";
  if (type === "debug" && isProduction) {
    return;
  }
  if (type === "log" && isProduction) {
    return;
  }
  if (type === "severe" && isProduction) {
    type = "error";
  }
  if (type === "debug" && !debug) {
    return;
  }
  switch (type) {
    case "debug":
      console.log(`%c(Debug) %c${baseMessage}:
${message}`, "font-weight: bold", "font-weight: normal");
      break;
    case "log":
      console.log(`%c(Log) %c${baseMessage}:
${message}`, "font-weight: bold", "font-weight: normal");
      break;
    case "warn":
      console.warn(`%c(Warning) %c${baseMessage}:
${message}`, "font-weight: bold", "font-weight: normal");
      break;
    case "error":
      console.error(`%c(Error) %c${baseMessage}:
${message}`, "font-weight: bold", "font-weight: normal");
      break;
    case "severe":
      throw new Error(`${baseMessage}: 
${message}`);
    default:
      throw new Error(`Log message ${message} of type ${type} is not a supported type.`);
  }
};
const noActiveVendor = () => {
  logMessage("No active vendor is set. Please make sure you configure an active vendor before trying to emit an event", "warn");
};
const vendorNotIncluded = (eventName, provider) => {
  const { activeVendor } = State().state;
  if (provider.trackingId === CONSTANTS.GLOBAL_TRACKING_ID) {
    return;
  }
  logMessage(`Skipping vendor ${activeVendor} for event ${eventName} of provider ${provider.name} as configured`, "debug");
};
const eventSent = (eventName, providers) => {
  const providerGroups = providers.reduce((acc, provider) => {
    var _a;
    if (provider.trackingId === CONSTANTS.GLOBAL_TRACKING_ID) {
      return acc;
    }
    const { name, type } = provider;
    const preProviders = (_a = acc[type]) != null ? _a : [];
    return __spreadProps$2x(__spreadValues$40({}, acc), {
      [type]: [...preProviders, name]
    });
  }, {});
  const providersCategoryMessage = Object.entries(providerGroups).reduce((acc, entry) => {
    const [type, categoryProviders] = entry;
    const typeMessage = type.charAt(0).toUpperCase() + type.slice(1);
    const providersMessage = categoryProviders.join(", ");
    return `${acc}${typeMessage}: ${providersMessage}
`;
  }, "");
  logMessage(`Event ${eventName} was successfully sent to the following providers ${providersCategoryMessage}`, "debug");
};
const logProvidersSDKNotLoaded = (providerType) => {
  logMessage(`${providerType} SDK not initialized. Please make sure the SDK is initialized before trying to emit an event`, "severe");
};
const logProviderConfigUpdated = (provider, config) => {
  if (provider.trackingId === CONSTANTS.GLOBAL_TRACKING_ID) {
    return;
  }
  const fields = Object.entries(config).reduce((acc, entry, index) => {
    const [key, value] = entry;
    if (index === 0)
      return `${key}: ${value}`;
    return `${acc}
${key}: ${value}`;
  }, "");
  logMessage(`${provider.name} config updated for the following fields.
 ${fields}`, "debug");
};

const _GlobalProvider = class {
  constructor() {
    this.initialized = false;
    this._type = "GOOGLE_ANALYTICS";
    this._name = "__GLOBAL_PROVIDER__";
    this._trackingId = CONSTANTS.GLOBAL_TRACKING_ID;
    this._sampleRate = 100;
    this._currency = "USD";
  }
  get type() {
    return this._type;
  }
  get name() {
    return this._name;
  }
  get trackingId() {
    return this._trackingId;
  }
  get sampleRate() {
    return this._sampleRate;
  }
  get userId() {
    return this._userId;
  }
  get language() {
    return this._language;
  }
  get currency() {
    return this._currency;
  }
  static get instance() {
    return _GlobalProvider._instance;
  }
  get vendors() {
    var _a;
    const { vendors: globalVendors } = State().state;
    return (_a = this._vendors) != null ? _a : globalVendors;
  }
  setVendors(vendors) {
    this._vendors = vendors;
  }
  init() {
    if (typeof window === "undefined") {
      return;
    }
    if (this.initialized) {
      return logMessage(`Provider ${this._name} was already initialized. Do not call init unless you know what you are doing.`, "severe");
    }
    this.initialized = true;
    const initTagSDK = document.createElement("script");
    initTagSDK.setAttribute("async", "true");
    initTagSDK.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${this._trackingId}`);
    const initTagEventQueue = document.createElement("script");
    initTagEventQueue.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${this._trackingId}', {'send_page_view': ${false}});gtag('event', 'page_view')`;
    document.body.appendChild(initTagSDK);
    document.body.appendChild(initTagEventQueue);
  }
  updateConfig(config = {}) {
    const filteredFields = Object.entries(config).filter((entry) => {
      return typeof entry[1] !== "undefined";
    });
    const filteredKeys = filteredFields.map((field) => field[0]);
    const { userId, currency, language } = config;
    if (filteredKeys.includes("userId"))
      this._userId = userId;
    if (filteredKeys.includes("currency"))
      this._currency = currency;
    if (filteredKeys.includes("language"))
      this._language = language;
    gtag("set", this._trackingId, config);
  }
};
let GlobalProvider = _GlobalProvider;
GlobalProvider._instance = new _GlobalProvider();

class AnalyticsProvider {
  constructor(config) {
    this.initialized = false;
    const { type, name, trackingId, vendors } = config;
    this.type = type;
    this.name = name;
    this.trackingId = trackingId;
    this._vendors = vendors;
  }
  get vendors() {
    var _a;
    const { vendors: globalVendors } = State().state;
    return (_a = this._vendors) != null ? _a : globalVendors;
  }
  init() {
    if (typeof window === "undefined") {
      return;
    }
    if (this.initialized) {
      return logMessage(`Provider ${this.name} was already initialized. Do not call init unless you know what you are doing.`, "severe");
    }
    this.initialized = true;
  }
  updateConfig(config) {
    logProviderConfigUpdated(this, config);
    GlobalProvider.instance.updateConfig(config);
  }
}

var __defProp$3$ = Object.defineProperty;
var __defProps$2w = Object.defineProperties;
var __getOwnPropDescs$2w = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3$ = Object.getOwnPropertySymbols;
var __hasOwnProp$3$ = Object.prototype.hasOwnProperty;
var __propIsEnum$3$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3$ = (obj, key, value) => key in obj ? __defProp$3$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3$.call(b, prop))
      __defNormalProp$3$(a, prop, b[prop]);
  if (__getOwnPropSymbols$3$)
    for (var prop of __getOwnPropSymbols$3$(b)) {
      if (__propIsEnum$3$.call(b, prop))
        __defNormalProp$3$(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2w = (a, b) => __defProps$2w(a, __getOwnPropDescs$2w(b));
class FacebookPixel extends AnalyticsProvider {
  constructor(config) {
    const { version, currency } = config;
    const { conversionsApiConfig } = config;
    const { isTrackingAllowed, withConversionsAPI } = config;
    super(__spreadProps$2w(__spreadValues$3$({}, config), { type: "FACEBOOK_PIXEL" }));
    this._version = version != null ? version : "10.0";
    this._currency = currency != null ? currency : "USD";
    this._isTrackingAllowed = isTrackingAllowed != null ? isTrackingAllowed : true;
    this.withConversionsAPI = withConversionsAPI != null ? withConversionsAPI : false;
    this._conversionsApiConfig = conversionsApiConfig;
  }
  get version() {
    return this._version;
  }
  get currency() {
    return this._currency;
  }
  get isTrackingAllowed() {
    return this._isTrackingAllowed;
  }
  get conversionsApiConfig() {
    return this._conversionsApiConfig;
  }
  init() {
    super.init();
    const linkTag = document.createElement("link");
    linkTag.setAttribute("rel", "preconnect");
    linkTag.setAttribute("href", "https://connect.facebook.net/en_US/fbevents.js");
    const initTag = document.createElement("script");
    initTag.setAttribute("async", "true");
    initTag.innerText = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='${this.version}';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '${this.trackingId}');fbq('trackSingle', '${this.trackingId}', 'PageView');`;
    const noScript = document.createElement("noscript");
    noScript.innerHTML = `
      <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id={${this.trackingId}}&noscript=1"/>
    `;
    document.head.appendChild(linkTag);
    document.head.appendChild(initTag);
    document.head.appendChild(noScript);
  }
  updateConfig(config = {}) {
    const filteredFields = Object.entries(config).filter((entry) => {
      return typeof entry[1] !== "undefined";
    });
    const filteredKeys = filteredFields.map((field) => field[0]);
    const { currency, isTrackingAllowed, conversionsApiConfig } = config;
    if (filteredKeys.includes("currency"))
      this._currency = currency;
    if (filteredKeys.includes("isTrackingAllowed")) {
      this._isTrackingAllowed = isTrackingAllowed;
    }
    if (filteredKeys.includes("conversionsApiConfig")) {
      this._conversionsApiConfig = conversionsApiConfig;
    }
    super.updateConfig(config);
  }
}

var __defProp$3_ = Object.defineProperty;
var __defProps$2v = Object.defineProperties;
var __getOwnPropDescs$2v = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3_ = Object.getOwnPropertySymbols;
var __hasOwnProp$3_ = Object.prototype.hasOwnProperty;
var __propIsEnum$3_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3_ = (obj, key, value) => key in obj ? __defProp$3_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3_.call(b, prop))
      __defNormalProp$3_(a, prop, b[prop]);
  if (__getOwnPropSymbols$3_)
    for (var prop of __getOwnPropSymbols$3_(b)) {
      if (__propIsEnum$3_.call(b, prop))
        __defNormalProp$3_(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2v = (a, b) => __defProps$2v(a, __getOwnPropDescs$2v(b));
class GoogleAnalytics extends AnalyticsProvider {
  constructor(config) {
    super(__spreadProps$2v(__spreadValues$3_({}, config), { type: "GOOGLE_ANALYTICS" }));
    const { userId, currency, language, sampleRate } = config;
    this._sampleRate = sampleRate;
    this._userId = userId;
    this._language = language;
    this._currency = currency != null ? currency : "USD";
  }
  get sampleRate() {
    return this._sampleRate;
  }
  get userId() {
    return this._userId;
  }
  get language() {
    return this._language;
  }
  get currency() {
    return this._currency;
  }
  init() {
    super.init();
    const linkTag = document.createElement("link");
    linkTag.setAttribute("rel", "preconnect");
    linkTag.setAttribute("href", `https://www.googletagmanager.com/gtag/js?id=${this.trackingId}`);
    const initTagSDK = document.createElement("script");
    initTagSDK.setAttribute("async", "true");
    initTagSDK.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${this.trackingId}`);
    const initTagEventQueue = document.createElement("script");
    initTagEventQueue.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${this.trackingId}', {'send_page_view': ${false}});gtag('event', 'page_view')`;
    document.head.appendChild(linkTag);
    document.head.appendChild(initTagSDK);
    document.head.appendChild(initTagEventQueue);
  }
  updateConfig(config = {}) {
    const filteredFields = Object.entries(config).filter((entry) => {
      return typeof entry[1] !== "undefined";
    });
    const filteredKeys = filteredFields.map((field) => field[0]);
    const { userId, currency, language } = config;
    if (filteredKeys.includes("userId"))
      this._userId = userId;
    if (filteredKeys.includes("currency"))
      this._currency = currency;
    if (filteredKeys.includes("language"))
      this._language = language;
    gtag("set", this.trackingId, config);
    super.updateConfig(config);
  }
}

var __defProp$3Z = Object.defineProperty;
var __defProps$2u = Object.defineProperties;
var __getOwnPropDescs$2u = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3Z = Object.getOwnPropertySymbols;
var __hasOwnProp$3Z = Object.prototype.hasOwnProperty;
var __propIsEnum$3Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3Z = (obj, key, value) => key in obj ? __defProp$3Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3Z.call(b, prop))
      __defNormalProp$3Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$3Z)
    for (var prop of __getOwnPropSymbols$3Z(b)) {
      if (__propIsEnum$3Z.call(b, prop))
        __defNormalProp$3Z(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2u = (a, b) => __defProps$2u(a, __getOwnPropDescs$2u(b));
class Segment extends AnalyticsProvider {
  constructor(config) {
    super(__spreadProps$2u(__spreadValues$3Z({}, config), { type: "SEGMENT" }));
    const { writeKey, currency } = config;
    this._writeKey = writeKey;
    this._currency = currency != null ? currency : "USD";
  }
  async init() {
    super.init();
    const initTag = document.createElement("script");
    initTag.setAttribute("async", "true");
    initTag.innerText = `
    !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${this._writeKey}";analytics.SNIPPET_VERSION="4.13.2";
    analytics.load("${this._writeKey}");
    analytics.page();
    }}();
    `;
    document.head.appendChild(initTag);
  }
  updateConfig(config = {}) {
    const filteredFields = Object.entries(config).filter((entry) => {
      return typeof entry[1] !== "undefined";
    });
    const filteredKeys = filteredFields.map((field) => field[0]);
    const { currency } = config;
    if (filteredKeys.includes("currency"))
      this._currency = currency;
    super.updateConfig(config);
  }
}

const Providers = {
  FacebookPixel,
  GoogleAnalytics,
  Segment
};

const checkUniqueProviderNames = (providers) => {
  const providersNames = providers.map((provider) => provider.name);
  const uniqueProviderNames = new Set(providersNames);
  return uniqueProviderNames.size === providersNames.length;
};
const checkUniqueProviderTrackerIds = (providers) => {
  const providersTrackerIds = providers.map((provider) => provider.trackingId);
  const uniqueProviderTrackerIds = new Set(providersTrackerIds);
  return uniqueProviderTrackerIds.size === providersTrackerIds.length;
};

var __defProp$3Y = Object.defineProperty;
var __defProps$2t = Object.defineProperties;
var __getOwnPropDescs$2t = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3Y = Object.getOwnPropertySymbols;
var __hasOwnProp$3Y = Object.prototype.hasOwnProperty;
var __propIsEnum$3Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3Y = (obj, key, value) => key in obj ? __defProp$3Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3Y.call(b, prop))
      __defNormalProp$3Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$3Y)
    for (var prop of __getOwnPropSymbols$3Y(b)) {
      if (__propIsEnum$3Y.call(b, prop))
        __defNormalProp$3Y(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2t = (a, b) => __defProps$2t(a, __getOwnPropDescs$2t(b));
var __objRest$3V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3Y)
    for (var prop of __getOwnPropSymbols$3Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const initAnalytics = (config) => {
  const isServer = typeof window === "undefined";
  if (isServer)
    return;
  const { initialized } = State().state;
  if (initialized) {
    logMessage("initAnalytics has been called more than once. This behaviour will very likely result in unexpected outcomes so its call was skipped. Please make sure initAnalytics is only called once.", "debug");
    return;
  }
  const { providers, shareArtisnAnalytics } = config;
  if (!providers.length) {
    return logMessage("At least one provider should be included but none were found", "severe");
  }
  if (!checkUniqueProviderNames(providers)) {
    return logMessage("Providers names must be unique, check that no provider names are repeated", "severe");
  }
  if (!checkUniqueProviderTrackerIds(providers)) {
    return logMessage("Providers trackerId must be unique, check that no provider trackerId are repeated", "severe");
  }
  const _a = config, { meta, onInit } = _a, rest = __objRest$3V(_a, ["meta", "onInit"]);
  const { platform = "web" } = meta;
  const enhancedProviders = shareArtisnAnalytics ? [GlobalProvider.instance, ...providers] : providers;
  const enhancedConfig = __spreadProps$2t(__spreadValues$3Y({}, rest), {
    providers: enhancedProviders,
    meta: __spreadProps$2t(__spreadValues$3Y({}, meta), {
      vendorId: rest.activeVendor,
      platform,
      versionSDK: packageJSON.version
    })
  });
  State().setState(enhancedConfig);
  providers.forEach((provider) => {
    const { vendors, name } = provider;
    if (!vendors) {
      logMessage(`The provider ${name} has no set vendors, as a result no events will be skipped for this provider`, "debug");
    }
  });
  let globalProviderConfig = {};
  enhancedProviders.forEach((provider) => {
    globalProviderConfig = __spreadValues$3Y(__spreadValues$3Y({}, globalProviderConfig), provider);
    provider.init();
  });
  let allVendors;
  allVendors = enhancedProviders.reduce((acc, provider) => {
    if (!provider.vendors) {
      return acc;
    }
    return [...acc, ...provider.vendors];
  }, []);
  allVendors = (allVendors == null ? void 0 : allVendors.length) ? allVendors : void 0;
  GlobalProvider.instance.updateConfig(globalProviderConfig);
  GlobalProvider.instance.setVendors(allVendors);
  State().setState({ initialized: true });
  onInit == null ? void 0 : onInit();
};

var __defProp$3X = Object.defineProperty;
var __defProps$2s = Object.defineProperties;
var __getOwnPropDescs$2s = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3X = Object.getOwnPropertySymbols;
var __hasOwnProp$3X = Object.prototype.hasOwnProperty;
var __propIsEnum$3X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3X = (obj, key, value) => key in obj ? __defProp$3X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3X.call(b, prop))
      __defNormalProp$3X(a, prop, b[prop]);
  if (__getOwnPropSymbols$3X)
    for (var prop of __getOwnPropSymbols$3X(b)) {
      if (__propIsEnum$3X.call(b, prop))
        __defNormalProp$3X(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2s = (a, b) => __defProps$2s(a, __getOwnPropDescs$2s(b));
const eventParamsToSnakeCase = (params) => {
  return Object.entries(params).reduce((acc, params2) => {
    const [key, value] = params2;
    const newKey = snakeCase(key);
    return __spreadProps$2s(__spreadValues$3X({}, acc), {
      [newKey]: value
    });
  }, {});
};
const checkInit = () => {
  try {
    return State().state.initialized;
  } catch (e) {
    return false;
  }
};

var __defProp$3W = Object.defineProperty;
var __defProps$2r = Object.defineProperties;
var __getOwnPropDescs$2r = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3W = Object.getOwnPropertySymbols;
var __hasOwnProp$3W = Object.prototype.hasOwnProperty;
var __propIsEnum$3W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3W = (obj, key, value) => key in obj ? __defProp$3W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3W.call(b, prop))
      __defNormalProp$3W(a, prop, b[prop]);
  if (__getOwnPropSymbols$3W)
    for (var prop of __getOwnPropSymbols$3W(b)) {
      if (__propIsEnum$3W.call(b, prop))
        __defNormalProp$3W(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2r = (a, b) => __defProps$2r(a, __getOwnPropDescs$2r(b));
var __objRest$3U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3W)
    for (var prop of __getOwnPropSymbols$3W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ChangePasswordAttempt = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3U(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2r(__spreadValues$3W({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "change_password_attempt", __spreadValues$3W(__spreadValues$3W({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

const skipVendor = (eventName, provider) => {
  const { vendors } = provider;
  const { activeVendor } = State().state;
  if (activeVendor === -1) {
    return false;
  }
  if (typeof vendors === "undefined") {
    return false;
  }
  if (activeVendor && vendors.includes(activeVendor)) {
    return false;
  }
  if (typeof activeVendor === "undefined") {
    noActiveVendor();
  } else {
    vendorNotIncluded(eventName, provider);
  }
  return true;
};
const getNotInitializedProvidersSDKs = (providers) => {
  const uniqueProviderTypes = new Set(providers.map((provider) => provider.type));
  const uniqueProviderTypesArray = Array.from(uniqueProviderTypes);
  return uniqueProviderTypesArray.reduce((acc, providerType) => {
    switch (providerType) {
      case "GOOGLE_ANALYTICS":
        if (typeof gtag === "undefined") {
          return [...acc, providerType];
        }
        break;
      case "FACEBOOK_PIXEL":
        if (typeof fbq === "undefined") {
          return [...acc, providerType];
        }
        break;
      case "SEGMENT":
        if (typeof analytics === "undefined") {
          return [...acc, providerType];
        }
        break;
      default:
        throw new Error(`Profiver of type ${providerType} is not supported`);
    }
    return acc;
  }, []);
};
const checkAnalyticsInitialized = (providers) => {
  if (!providers.length) {
    logMessage("No providers found, the initAnalytics probably hasn't been run yet", "severe");
    return false;
  }
  const providersSDKNotLoaded = getNotInitializedProvidersSDKs(providers);
  if (!providersSDKNotLoaded.length) {
    return true;
  }
  providersSDKNotLoaded.forEach((providerType) => {
    logProvidersSDKNotLoaded(providerType);
  });
  return false;
};

const postFacebookConversion = async (config) => {
  const { apiURL, eventName, customData, authToken } = config;
  const { eventSourceUrl, testCode } = config;
  const { countryISOCode, fbAccessToken, fbPixelId } = config;
  const { platform = "web" } = customData != null ? customData : {};
  const { debug } = State().state;
  const selectedHeaders = new Headers();
  selectedHeaders.set("Content-Type", "application/json");
  selectedHeaders.set("Platform", platform);
  selectedHeaders.set("Authorization", authToken);
  const url = `${apiURL}/api/fb-conversion-api/conversions-api`;
  const facebookConversionBody = {
    eventName,
    actionSource: "website",
    eventSourceUrl,
    countryISOCode,
    customData,
    fbAccessToken,
    fbPixelId,
    testCode
  };
  try {
    const data = await fetch(url, {
      method: "post",
      body: JSON.stringify(facebookConversionBody),
      headers: selectedHeaders
    }).then(async (data2) => {
      return await data2.json();
    });
    if (!debug)
      return data;
    const { status, message } = data;
    if (status !== "error")
      console.warn(message);
    if (status === "error")
      console.error(message);
    return data;
  } catch (e) {
    if (!debug)
      return;
    console.error(e.message);
  }
};

var __defProp$3V = Object.defineProperty;
var __defProps$2q = Object.defineProperties;
var __getOwnPropDescs$2q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3V = Object.getOwnPropertySymbols;
var __hasOwnProp$3V = Object.prototype.hasOwnProperty;
var __propIsEnum$3V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3V = (obj, key, value) => key in obj ? __defProp$3V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3V.call(b, prop))
      __defNormalProp$3V(a, prop, b[prop]);
  if (__getOwnPropSymbols$3V)
    for (var prop of __getOwnPropSymbols$3V(b)) {
      if (__propIsEnum$3V.call(b, prop))
        __defNormalProp$3V(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2q = (a, b) => __defProps$2q(a, __getOwnPropDescs$2q(b));
const triageEventToProviders = (eventName, params, providersHandlers) => {
  const { facebookPixelHandler, googleAnalyticsHandler } = providersHandlers;
  const { segmentHandler } = providersHandlers;
  const { providers } = State().state;
  if (!checkAnalyticsInitialized(providers)) {
    return;
  }
  const enhancedParams = __spreadProps$2q(__spreadValues$3V({}, params), { artisnEvent: eventName });
  const targetedProviders = providers.reduce((acc, provider) => {
    if (skipVendor(eventName, provider)) {
      return acc;
    }
    switch (provider.type) {
      case "FACEBOOK_PIXEL":
        facebookPixelHandler(provider, enhancedParams);
        break;
      case "GOOGLE_ANALYTICS":
        googleAnalyticsHandler(provider, enhancedParams);
        break;
      case "SEGMENT":
        segmentHandler(provider, enhancedParams);
        break;
      default:
        throw new Error(`Provider of type ${provider.type} is not supported`);
    }
    return [...acc, provider];
  }, []);
  eventSent(eventName, targetedProviders);
};
const getProductIdsFromShoppingCart = (shoppingCart) => {
  const products = getShoppingCartProducts(shoppingCart);
  return products.map((product) => product.productId);
};
const getProductContentFromShoppingCart = (shoppingCart) => {
  const products = getShoppingCartProducts(shoppingCart);
  return products.map((product) => getProductContent(product));
};
const getProductContent = (product) => {
  const totals = getProductTotals(product);
  return `${product.name}:${totals.netPrice}`;
};
const mapProductsToGoogleItems = (shoppingCart, currency) => {
  const products = getShoppingCartProducts(shoppingCart);
  return products.map((product) => mapProductToGoogleItem(product, currency));
};
const mapProductToGoogleItem = (product, currency) => {
  const totals = getProductTotals(product);
  const { productId, name, amount } = product;
  return {
    item_id: productId,
    item_name: name,
    quantity: amount,
    price: totals.netPrice,
    currency
  };
};
const transformArrayParam = (param) => {
  return param.join(",");
};
const mapProductToSegmentProduct = (product) => {
  const { productId, name } = product;
  const totals = getProductTotals(product);
  return {
    product_id: productId,
    name,
    price: totals.netPrice
  };
};
const mapProductsToSegmentProducts = (products) => {
  return products.map((product) => mapProductToSegmentProduct(product));
};
const mapProductToFacebookItem = (product) => {
  const { productId: id } = product;
  const totals = getProductTotals(product);
  const { netPrice } = totals;
  const facebookItem = { id, item_price: netPrice };
  return JSON.stringify(facebookItem);
};
const mapProductsToFacebookItems = (shoppingCart) => {
  const products = getShoppingCartProducts(shoppingCart);
  return products.map((product) => mapProductToFacebookItem(product));
};
const sendFacebookConversionEvent = (eventParams) => {
  const { withConversionsAPI, conversionsApiConfig } = eventParams;
  const { eventName, customData } = eventParams;
  if (!withConversionsAPI || !conversionsApiConfig)
    return;
  postFacebookConversion(__spreadProps$2q(__spreadValues$3V({}, conversionsApiConfig), {
    eventName,
    customData
  }));
};

var __defProp$3U = Object.defineProperty;
var __getOwnPropSymbols$3U = Object.getOwnPropertySymbols;
var __hasOwnProp$3U = Object.prototype.hasOwnProperty;
var __propIsEnum$3U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3U = (obj, key, value) => key in obj ? __defProp$3U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3U.call(b, prop))
      __defNormalProp$3U(a, prop, b[prop]);
  if (__getOwnPropSymbols$3U)
    for (var prop of __getOwnPropSymbols$3U(b)) {
      if (__propIsEnum$3U.call(b, prop))
        __defNormalProp$3U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3U)
    for (var prop of __getOwnPropSymbols$3U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changePasswordAttempt$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3T(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3U({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ChangePasswordAttempt";
  const customData = __spreadValues$3U(__spreadValues$3U({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3T = Object.defineProperty;
var __getOwnPropSymbols$3T = Object.getOwnPropertySymbols;
var __hasOwnProp$3T = Object.prototype.hasOwnProperty;
var __propIsEnum$3T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3T = (obj, key, value) => key in obj ? __defProp$3T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3T.call(b, prop))
      __defNormalProp$3T(a, prop, b[prop]);
  if (__getOwnPropSymbols$3T)
    for (var prop of __getOwnPropSymbols$3T(b)) {
      if (__propIsEnum$3T.call(b, prop))
        __defNormalProp$3T(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3T)
    for (var prop of __getOwnPropSymbols$3T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changePasswordAttempt = (provider, params) => {
  const rest = __objRest$3S(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3T({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Change Password Attempt", __spreadValues$3T(__spreadValues$3T({}, transformedParams), transformedMeta));
};

const logChangePasswordAttempt = (params) => {
  triageEventToProviders("changePasswordAttempt", params, {
    googleAnalyticsHandler: ChangePasswordAttempt,
    facebookPixelHandler: changePasswordAttempt$1,
    segmentHandler: changePasswordAttempt
  });
};

var __defProp$3S = Object.defineProperty;
var __defProps$2p = Object.defineProperties;
var __getOwnPropDescs$2p = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3S = Object.getOwnPropertySymbols;
var __hasOwnProp$3S = Object.prototype.hasOwnProperty;
var __propIsEnum$3S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3S = (obj, key, value) => key in obj ? __defProp$3S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3S.call(b, prop))
      __defNormalProp$3S(a, prop, b[prop]);
  if (__getOwnPropSymbols$3S)
    for (var prop of __getOwnPropSymbols$3S(b)) {
      if (__propIsEnum$3S.call(b, prop))
        __defNormalProp$3S(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2p = (a, b) => __defProps$2p(a, __getOwnPropDescs$2p(b));
var __objRest$3R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3S)
    for (var prop of __getOwnPropSymbols$3S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SignUpAttempt = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3R(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2p(__spreadValues$3S({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "sign_up_attempt", __spreadValues$3S(__spreadValues$3S({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3R = Object.defineProperty;
var __getOwnPropSymbols$3R = Object.getOwnPropertySymbols;
var __hasOwnProp$3R = Object.prototype.hasOwnProperty;
var __propIsEnum$3R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3R = (obj, key, value) => key in obj ? __defProp$3R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3R.call(b, prop))
      __defNormalProp$3R(a, prop, b[prop]);
  if (__getOwnPropSymbols$3R)
    for (var prop of __getOwnPropSymbols$3R(b)) {
      if (__propIsEnum$3R.call(b, prop))
        __defNormalProp$3R(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3R)
    for (var prop of __getOwnPropSymbols$3R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const signUpAttempt$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3Q(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3R({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SignUpAttempt";
  const customData = __spreadValues$3R(__spreadValues$3R({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3Q = Object.defineProperty;
var __getOwnPropSymbols$3Q = Object.getOwnPropertySymbols;
var __hasOwnProp$3Q = Object.prototype.hasOwnProperty;
var __propIsEnum$3Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3Q = (obj, key, value) => key in obj ? __defProp$3Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3Q.call(b, prop))
      __defNormalProp$3Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$3Q)
    for (var prop of __getOwnPropSymbols$3Q(b)) {
      if (__propIsEnum$3Q.call(b, prop))
        __defNormalProp$3Q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3Q)
    for (var prop of __getOwnPropSymbols$3Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const signUpAttempt = (provider, params) => {
  const rest = __objRest$3P(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3Q({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Sign Up Attempt", __spreadValues$3Q(__spreadValues$3Q({}, transformedParams), transformedMeta));
};

const logSignUpAttempt = (params) => {
  triageEventToProviders("signUpAttempt", params, {
    googleAnalyticsHandler: SignUpAttempt,
    facebookPixelHandler: signUpAttempt$1,
    segmentHandler: signUpAttempt
  });
};

var __defProp$3P = Object.defineProperty;
var __defProps$2o = Object.defineProperties;
var __getOwnPropDescs$2o = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3P = Object.getOwnPropertySymbols;
var __hasOwnProp$3P = Object.prototype.hasOwnProperty;
var __propIsEnum$3P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3P = (obj, key, value) => key in obj ? __defProp$3P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3P.call(b, prop))
      __defNormalProp$3P(a, prop, b[prop]);
  if (__getOwnPropSymbols$3P)
    for (var prop of __getOwnPropSymbols$3P(b)) {
      if (__propIsEnum$3P.call(b, prop))
        __defNormalProp$3P(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2o = (a, b) => __defProps$2o(a, __getOwnPropDescs$2o(b));
var __objRest$3O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3P)
    for (var prop of __getOwnPropSymbols$3P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ChangePasswordFail = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3O(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2o(__spreadValues$3P({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "change_password_fail", __spreadValues$3P(__spreadValues$3P({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3O = Object.defineProperty;
var __getOwnPropSymbols$3O = Object.getOwnPropertySymbols;
var __hasOwnProp$3O = Object.prototype.hasOwnProperty;
var __propIsEnum$3O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3O = (obj, key, value) => key in obj ? __defProp$3O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3O.call(b, prop))
      __defNormalProp$3O(a, prop, b[prop]);
  if (__getOwnPropSymbols$3O)
    for (var prop of __getOwnPropSymbols$3O(b)) {
      if (__propIsEnum$3O.call(b, prop))
        __defNormalProp$3O(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3O)
    for (var prop of __getOwnPropSymbols$3O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changePasswordFail$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3N(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3O({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ChangePasswordFail";
  const customData = __spreadValues$3O(__spreadValues$3O({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3N = Object.defineProperty;
var __getOwnPropSymbols$3N = Object.getOwnPropertySymbols;
var __hasOwnProp$3N = Object.prototype.hasOwnProperty;
var __propIsEnum$3N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3N = (obj, key, value) => key in obj ? __defProp$3N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3N.call(b, prop))
      __defNormalProp$3N(a, prop, b[prop]);
  if (__getOwnPropSymbols$3N)
    for (var prop of __getOwnPropSymbols$3N(b)) {
      if (__propIsEnum$3N.call(b, prop))
        __defNormalProp$3N(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3N)
    for (var prop of __getOwnPropSymbols$3N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changePasswordFail = (provider, params) => {
  const rest = __objRest$3M(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3N({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Change Password Fail", __spreadValues$3N(__spreadValues$3N({}, transformedParams), transformedMeta));
};

const logChangePasswordFail = (params) => {
  triageEventToProviders("changePasswordFail", params, {
    googleAnalyticsHandler: ChangePasswordFail,
    facebookPixelHandler: changePasswordFail$1,
    segmentHandler: changePasswordFail
  });
};

var __defProp$3M = Object.defineProperty;
var __defProps$2n = Object.defineProperties;
var __getOwnPropDescs$2n = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3M = Object.getOwnPropertySymbols;
var __hasOwnProp$3M = Object.prototype.hasOwnProperty;
var __propIsEnum$3M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3M = (obj, key, value) => key in obj ? __defProp$3M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3M.call(b, prop))
      __defNormalProp$3M(a, prop, b[prop]);
  if (__getOwnPropSymbols$3M)
    for (var prop of __getOwnPropSymbols$3M(b)) {
      if (__propIsEnum$3M.call(b, prop))
        __defNormalProp$3M(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2n = (a, b) => __defProps$2n(a, __getOwnPropDescs$2n(b));
var __objRest$3L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3M)
    for (var prop of __getOwnPropSymbols$3M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ChangePasswordSuccess = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3L(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2n(__spreadValues$3M({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "change_password_success", __spreadValues$3M(__spreadValues$3M({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3L = Object.defineProperty;
var __getOwnPropSymbols$3L = Object.getOwnPropertySymbols;
var __hasOwnProp$3L = Object.prototype.hasOwnProperty;
var __propIsEnum$3L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3L = (obj, key, value) => key in obj ? __defProp$3L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3L.call(b, prop))
      __defNormalProp$3L(a, prop, b[prop]);
  if (__getOwnPropSymbols$3L)
    for (var prop of __getOwnPropSymbols$3L(b)) {
      if (__propIsEnum$3L.call(b, prop))
        __defNormalProp$3L(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3L)
    for (var prop of __getOwnPropSymbols$3L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changePasswordSuccess$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3K(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3L({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ChangePasswordSuccess";
  const customData = __spreadValues$3L(__spreadValues$3L({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3K = Object.defineProperty;
var __getOwnPropSymbols$3K = Object.getOwnPropertySymbols;
var __hasOwnProp$3K = Object.prototype.hasOwnProperty;
var __propIsEnum$3K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3K = (obj, key, value) => key in obj ? __defProp$3K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3K.call(b, prop))
      __defNormalProp$3K(a, prop, b[prop]);
  if (__getOwnPropSymbols$3K)
    for (var prop of __getOwnPropSymbols$3K(b)) {
      if (__propIsEnum$3K.call(b, prop))
        __defNormalProp$3K(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3K)
    for (var prop of __getOwnPropSymbols$3K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changePasswordSuccess = (provider, params) => {
  const rest = __objRest$3J(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3K({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Change Password Success", __spreadValues$3K(__spreadValues$3K({}, transformedParams), transformedMeta));
};

const logChangePasswordSuccess = (params) => {
  triageEventToProviders("changePasswordSuccess", params, {
    googleAnalyticsHandler: ChangePasswordSuccess,
    facebookPixelHandler: changePasswordSuccess$1,
    segmentHandler: changePasswordSuccess
  });
};

var __defProp$3J = Object.defineProperty;
var __defProps$2m = Object.defineProperties;
var __getOwnPropDescs$2m = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3J = Object.getOwnPropertySymbols;
var __hasOwnProp$3J = Object.prototype.hasOwnProperty;
var __propIsEnum$3J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3J = (obj, key, value) => key in obj ? __defProp$3J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3J.call(b, prop))
      __defNormalProp$3J(a, prop, b[prop]);
  if (__getOwnPropSymbols$3J)
    for (var prop of __getOwnPropSymbols$3J(b)) {
      if (__propIsEnum$3J.call(b, prop))
        __defNormalProp$3J(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2m = (a, b) => __defProps$2m(a, __getOwnPropDescs$2m(b));
var __objRest$3I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3J)
    for (var prop of __getOwnPropSymbols$3J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SignIn = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3I(_a, ["callback", "userId"]);
  delete rest.identify;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2m(__spreadValues$3J({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "login", __spreadValues$3J(__spreadValues$3J({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3I = Object.defineProperty;
var __getOwnPropSymbols$3I = Object.getOwnPropertySymbols;
var __hasOwnProp$3I = Object.prototype.hasOwnProperty;
var __propIsEnum$3I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3I = (obj, key, value) => key in obj ? __defProp$3I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3I.call(b, prop))
      __defNormalProp$3I(a, prop, b[prop]);
  if (__getOwnPropSymbols$3I)
    for (var prop of __getOwnPropSymbols$3I(b)) {
      if (__propIsEnum$3I.call(b, prop))
        __defNormalProp$3I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3I)
    for (var prop of __getOwnPropSymbols$3I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const signIn$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3H(params, []);
  delete rest.userId;
  delete rest.identify;
  const enhancedParams = __spreadValues$3I({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SignIn";
  const customData = __spreadValues$3I(__spreadValues$3I({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3H = Object.defineProperty;
var __defProps$2l = Object.defineProperties;
var __getOwnPropDescs$2l = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3H = Object.getOwnPropertySymbols;
var __hasOwnProp$3H = Object.prototype.hasOwnProperty;
var __propIsEnum$3H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3H = (obj, key, value) => key in obj ? __defProp$3H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3H.call(b, prop))
      __defNormalProp$3H(a, prop, b[prop]);
  if (__getOwnPropSymbols$3H)
    for (var prop of __getOwnPropSymbols$3H(b)) {
      if (__propIsEnum$3H.call(b, prop))
        __defNormalProp$3H(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2l = (a, b) => __defProps$2l(a, __getOwnPropDescs$2l(b));
var __objRest$3G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3H)
    for (var prop of __getOwnPropSymbols$3H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const signIn = (provider, params) => {
  const _a = params, { name, identify } = _a, rest = __objRest$3G(_a, ["name", "identify"]);
  delete rest.userId;
  const enhancedParams = __spreadProps$2l(__spreadValues$3H({}, rest), { username: name });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Signed In", __spreadValues$3H(__spreadValues$3H({}, transformedParams), transformedMeta));
  if (!identify)
    return;
  const _b = identify, { name: nameTrait = name } = _b, traits = __objRest$3G(_b, ["name"]);
  analytics.identify(identify.id, __spreadValues$3H({
    name: nameTrait
  }, traits));
};

const logSignIn = (params) => {
  triageEventToProviders("signIn", params, {
    googleAnalyticsHandler: SignIn,
    facebookPixelHandler: signIn$1,
    segmentHandler: signIn
  });
};

var __defProp$3G = Object.defineProperty;
var __defProps$2k = Object.defineProperties;
var __getOwnPropDescs$2k = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3G = Object.getOwnPropertySymbols;
var __hasOwnProp$3G = Object.prototype.hasOwnProperty;
var __propIsEnum$3G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3G = (obj, key, value) => key in obj ? __defProp$3G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3G.call(b, prop))
      __defNormalProp$3G(a, prop, b[prop]);
  if (__getOwnPropSymbols$3G)
    for (var prop of __getOwnPropSymbols$3G(b)) {
      if (__propIsEnum$3G.call(b, prop))
        __defNormalProp$3G(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2k = (a, b) => __defProps$2k(a, __getOwnPropDescs$2k(b));
var __objRest$3F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3G)
    for (var prop of __getOwnPropSymbols$3G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SignOut = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3F(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2k(__spreadValues$3G({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "sign_out", __spreadValues$3G(__spreadValues$3G({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3F = Object.defineProperty;
var __getOwnPropSymbols$3F = Object.getOwnPropertySymbols;
var __hasOwnProp$3F = Object.prototype.hasOwnProperty;
var __propIsEnum$3F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3F = (obj, key, value) => key in obj ? __defProp$3F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3F.call(b, prop))
      __defNormalProp$3F(a, prop, b[prop]);
  if (__getOwnPropSymbols$3F)
    for (var prop of __getOwnPropSymbols$3F(b)) {
      if (__propIsEnum$3F.call(b, prop))
        __defNormalProp$3F(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3F)
    for (var prop of __getOwnPropSymbols$3F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const signOut$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3E(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3F({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SignOut";
  const customData = __spreadValues$3F(__spreadValues$3F({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3E = Object.defineProperty;
var __defProps$2j = Object.defineProperties;
var __getOwnPropDescs$2j = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3E = Object.getOwnPropertySymbols;
var __hasOwnProp$3E = Object.prototype.hasOwnProperty;
var __propIsEnum$3E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3E = (obj, key, value) => key in obj ? __defProp$3E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3E.call(b, prop))
      __defNormalProp$3E(a, prop, b[prop]);
  if (__getOwnPropSymbols$3E)
    for (var prop of __getOwnPropSymbols$3E(b)) {
      if (__propIsEnum$3E.call(b, prop))
        __defNormalProp$3E(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2j = (a, b) => __defProps$2j(a, __getOwnPropDescs$2j(b));
var __objRest$3D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3E)
    for (var prop of __getOwnPropSymbols$3E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const signOut = (provider, params) => {
  const _a = params, { name } = _a, rest = __objRest$3D(_a, ["name"]);
  delete rest.userId;
  const enhancedParams = __spreadProps$2j(__spreadValues$3E({}, rest), { username: name });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Signed Out", __spreadValues$3E(__spreadValues$3E({}, transformedParams), transformedMeta));
  analytics.reset();
};

const logSignOut = (params) => {
  triageEventToProviders("signOut", params, {
    googleAnalyticsHandler: SignOut,
    facebookPixelHandler: signOut$1,
    segmentHandler: signOut
  });
};

var __defProp$3D = Object.defineProperty;
var __defProps$2i = Object.defineProperties;
var __getOwnPropDescs$2i = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3D = Object.getOwnPropertySymbols;
var __hasOwnProp$3D = Object.prototype.hasOwnProperty;
var __propIsEnum$3D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3D = (obj, key, value) => key in obj ? __defProp$3D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3D.call(b, prop))
      __defNormalProp$3D(a, prop, b[prop]);
  if (__getOwnPropSymbols$3D)
    for (var prop of __getOwnPropSymbols$3D(b)) {
      if (__propIsEnum$3D.call(b, prop))
        __defNormalProp$3D(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2i = (a, b) => __defProps$2i(a, __getOwnPropDescs$2i(b));
var __objRest$3C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3D)
    for (var prop of __getOwnPropSymbols$3D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SignUp = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3C(_a, ["callback", "userId"]);
  delete rest.identify;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2i(__spreadValues$3D({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "sign_up", __spreadValues$3D(__spreadValues$3D({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3C = Object.defineProperty;
var __getOwnPropSymbols$3C = Object.getOwnPropertySymbols;
var __hasOwnProp$3C = Object.prototype.hasOwnProperty;
var __propIsEnum$3C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3C = (obj, key, value) => key in obj ? __defProp$3C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3C.call(b, prop))
      __defNormalProp$3C(a, prop, b[prop]);
  if (__getOwnPropSymbols$3C)
    for (var prop of __getOwnPropSymbols$3C(b)) {
      if (__propIsEnum$3C.call(b, prop))
        __defNormalProp$3C(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3C)
    for (var prop of __getOwnPropSymbols$3C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const signUp$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3B(params, []);
  delete rest.userId;
  delete rest.identify;
  const enhancedParams = __spreadValues$3C({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "CompleteRegistration";
  const customData = __spreadValues$3C(__spreadValues$3C({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3B = Object.defineProperty;
var __defProps$2h = Object.defineProperties;
var __getOwnPropDescs$2h = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3B = Object.getOwnPropertySymbols;
var __hasOwnProp$3B = Object.prototype.hasOwnProperty;
var __propIsEnum$3B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3B = (obj, key, value) => key in obj ? __defProp$3B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3B.call(b, prop))
      __defNormalProp$3B(a, prop, b[prop]);
  if (__getOwnPropSymbols$3B)
    for (var prop of __getOwnPropSymbols$3B(b)) {
      if (__propIsEnum$3B.call(b, prop))
        __defNormalProp$3B(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2h = (a, b) => __defProps$2h(a, __getOwnPropDescs$2h(b));
var __objRest$3A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3B)
    for (var prop of __getOwnPropSymbols$3B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const signUp = (provider, params) => {
  const _a = params, { name, method, identify } = _a, rest = __objRest$3A(_a, ["name", "method", "identify"]);
  delete rest.userId;
  const enhancedParams = __spreadProps$2h(__spreadValues$3B({}, rest), { username: name, type: method });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Signed Up", __spreadValues$3B(__spreadValues$3B({}, transformedParams), transformedMeta));
  if (!identify)
    return;
  const _b = identify, { name: nameTrait = name, email = rest.email } = _b, traits = __objRest$3A(_b, ["name", "email"]);
  analytics.identify(identify.id, __spreadValues$3B({
    name: nameTrait,
    email
  }, traits));
};

const logSignUp = (params) => {
  triageEventToProviders("signUp", params, {
    googleAnalyticsHandler: SignUp,
    facebookPixelHandler: signUp$1,
    segmentHandler: signUp
  });
};

const events$p = {
  logChangePasswordAttempt,
  logSignUpAttempt,
  logChangePasswordFail,
  logChangePasswordSuccess,
  logSignIn,
  logSignOut,
  logSignUp
};

var __defProp$3A = Object.defineProperty;
var __defProps$2g = Object.defineProperties;
var __getOwnPropDescs$2g = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3A = Object.getOwnPropertySymbols;
var __hasOwnProp$3A = Object.prototype.hasOwnProperty;
var __propIsEnum$3A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3A = (obj, key, value) => key in obj ? __defProp$3A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3A.call(b, prop))
      __defNormalProp$3A(a, prop, b[prop]);
  if (__getOwnPropSymbols$3A)
    for (var prop of __getOwnPropSymbols$3A(b)) {
      if (__propIsEnum$3A.call(b, prop))
        __defNormalProp$3A(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2g = (a, b) => __defProps$2g(a, __getOwnPropDescs$2g(b));
var __objRest$3z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3A)
    for (var prop of __getOwnPropSymbols$3A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const bannerImpression$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3z(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2g(__spreadValues$3A({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "banner_impression", __spreadValues$3A(__spreadValues$3A({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3z = Object.defineProperty;
var __getOwnPropSymbols$3z = Object.getOwnPropertySymbols;
var __hasOwnProp$3z = Object.prototype.hasOwnProperty;
var __propIsEnum$3z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3z = (obj, key, value) => key in obj ? __defProp$3z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3z.call(b, prop))
      __defNormalProp$3z(a, prop, b[prop]);
  if (__getOwnPropSymbols$3z)
    for (var prop of __getOwnPropSymbols$3z(b)) {
      if (__propIsEnum$3z.call(b, prop))
        __defNormalProp$3z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3z)
    for (var prop of __getOwnPropSymbols$3z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const bannerImpression$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3y(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3z({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "BannerImpression";
  const customData = __spreadValues$3z(__spreadValues$3z({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3y = Object.defineProperty;
var __getOwnPropSymbols$3y = Object.getOwnPropertySymbols;
var __hasOwnProp$3y = Object.prototype.hasOwnProperty;
var __propIsEnum$3y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3y = (obj, key, value) => key in obj ? __defProp$3y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3y.call(b, prop))
      __defNormalProp$3y(a, prop, b[prop]);
  if (__getOwnPropSymbols$3y)
    for (var prop of __getOwnPropSymbols$3y(b)) {
      if (__propIsEnum$3y.call(b, prop))
        __defNormalProp$3y(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3y)
    for (var prop of __getOwnPropSymbols$3y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const bannerImpression = (provider, params) => {
  const rest = __objRest$3x(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3y({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Banner Impression", __spreadValues$3y(__spreadValues$3y({}, transformedParams), transformedMeta));
};

const logBannerImpression = (params) => {
  triageEventToProviders("bannerImpression", params, {
    googleAnalyticsHandler: bannerImpression$2,
    facebookPixelHandler: bannerImpression$1,
    segmentHandler: bannerImpression
  });
};

var __defProp$3x = Object.defineProperty;
var __defProps$2f = Object.defineProperties;
var __getOwnPropDescs$2f = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3x = Object.getOwnPropertySymbols;
var __hasOwnProp$3x = Object.prototype.hasOwnProperty;
var __propIsEnum$3x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3x = (obj, key, value) => key in obj ? __defProp$3x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3x.call(b, prop))
      __defNormalProp$3x(a, prop, b[prop]);
  if (__getOwnPropSymbols$3x)
    for (var prop of __getOwnPropSymbols$3x(b)) {
      if (__propIsEnum$3x.call(b, prop))
        __defNormalProp$3x(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2f = (a, b) => __defProps$2f(a, __getOwnPropDescs$2f(b));
var __objRest$3w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3x)
    for (var prop of __getOwnPropSymbols$3x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectBanner$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3w(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2f(__spreadValues$3x({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "select_content", __spreadValues$3x(__spreadValues$3x({
    send_to: trackingId,
    event_callback: callback,
    content_type: "banner"
  }, transformedParams), transformedMeta));
};

var __defProp$3w = Object.defineProperty;
var __getOwnPropSymbols$3w = Object.getOwnPropertySymbols;
var __hasOwnProp$3w = Object.prototype.hasOwnProperty;
var __propIsEnum$3w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3w = (obj, key, value) => key in obj ? __defProp$3w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3w.call(b, prop))
      __defNormalProp$3w(a, prop, b[prop]);
  if (__getOwnPropSymbols$3w)
    for (var prop of __getOwnPropSymbols$3w(b)) {
      if (__propIsEnum$3w.call(b, prop))
        __defNormalProp$3w(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3w)
    for (var prop of __getOwnPropSymbols$3w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectBanner$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3v(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3w({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SelectBanner";
  const customData = __spreadValues$3w(__spreadValues$3w({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3v = Object.defineProperty;
var __getOwnPropSymbols$3v = Object.getOwnPropertySymbols;
var __hasOwnProp$3v = Object.prototype.hasOwnProperty;
var __propIsEnum$3v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3v = (obj, key, value) => key in obj ? __defProp$3v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3v.call(b, prop))
      __defNormalProp$3v(a, prop, b[prop]);
  if (__getOwnPropSymbols$3v)
    for (var prop of __getOwnPropSymbols$3v(b)) {
      if (__propIsEnum$3v.call(b, prop))
        __defNormalProp$3v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3v)
    for (var prop of __getOwnPropSymbols$3v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectBanner = (provider, params) => {
  const rest = __objRest$3u(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3v({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Select Banner", __spreadValues$3v(__spreadValues$3v({}, transformedParams), transformedMeta));
};

const logSelectBanner = (params) => {
  triageEventToProviders("selectBanner", params, {
    googleAnalyticsHandler: selectBanner$2,
    facebookPixelHandler: selectBanner$1,
    segmentHandler: selectBanner
  });
};

const events$o = { logBannerImpression, logSelectBanner };

var __defProp$3u = Object.defineProperty;
var __defProps$2e = Object.defineProperties;
var __getOwnPropDescs$2e = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3u = Object.getOwnPropertySymbols;
var __hasOwnProp$3u = Object.prototype.hasOwnProperty;
var __propIsEnum$3u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3u = (obj, key, value) => key in obj ? __defProp$3u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3u.call(b, prop))
      __defNormalProp$3u(a, prop, b[prop]);
  if (__getOwnPropSymbols$3u)
    for (var prop of __getOwnPropSymbols$3u(b)) {
      if (__propIsEnum$3u.call(b, prop))
        __defNormalProp$3u(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2e = (a, b) => __defProps$2e(a, __getOwnPropDescs$2e(b));
var __objRest$3t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3u)
    for (var prop of __getOwnPropSymbols$3u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addBillingInfo$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3t(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2e(__spreadValues$3u({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "add_billing_info", __spreadValues$3u(__spreadValues$3u({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3t = Object.defineProperty;
var __getOwnPropSymbols$3t = Object.getOwnPropertySymbols;
var __hasOwnProp$3t = Object.prototype.hasOwnProperty;
var __propIsEnum$3t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3t = (obj, key, value) => key in obj ? __defProp$3t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3t.call(b, prop))
      __defNormalProp$3t(a, prop, b[prop]);
  if (__getOwnPropSymbols$3t)
    for (var prop of __getOwnPropSymbols$3t(b)) {
      if (__propIsEnum$3t.call(b, prop))
        __defNormalProp$3t(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3t)
    for (var prop of __getOwnPropSymbols$3t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addBillingInfo$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3s(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3t({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "AddBillingInfo";
  const customData = __spreadValues$3t(__spreadValues$3t({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3s = Object.defineProperty;
var __getOwnPropSymbols$3s = Object.getOwnPropertySymbols;
var __hasOwnProp$3s = Object.prototype.hasOwnProperty;
var __propIsEnum$3s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3s = (obj, key, value) => key in obj ? __defProp$3s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3s.call(b, prop))
      __defNormalProp$3s(a, prop, b[prop]);
  if (__getOwnPropSymbols$3s)
    for (var prop of __getOwnPropSymbols$3s(b)) {
      if (__propIsEnum$3s.call(b, prop))
        __defNormalProp$3s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3s)
    for (var prop of __getOwnPropSymbols$3s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addBillingInfo = (provider, params) => {
  const rest = __objRest$3r(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3s({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Add Billing Info", __spreadValues$3s(__spreadValues$3s({}, transformedParams), transformedMeta));
};

const logAddBillingInfo = (params) => {
  triageEventToProviders("addBillingInfo", params, {
    googleAnalyticsHandler: addBillingInfo$2,
    facebookPixelHandler: addBillingInfo$1,
    segmentHandler: addBillingInfo
  });
};

var __defProp$3r = Object.defineProperty;
var __defProps$2d = Object.defineProperties;
var __getOwnPropDescs$2d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3r = Object.getOwnPropertySymbols;
var __hasOwnProp$3r = Object.prototype.hasOwnProperty;
var __propIsEnum$3r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3r = (obj, key, value) => key in obj ? __defProp$3r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3r.call(b, prop))
      __defNormalProp$3r(a, prop, b[prop]);
  if (__getOwnPropSymbols$3r)
    for (var prop of __getOwnPropSymbols$3r(b)) {
      if (__propIsEnum$3r.call(b, prop))
        __defNormalProp$3r(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2d = (a, b) => __defProps$2d(a, __getOwnPropDescs$2d(b));
var __objRest$3q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3r)
    for (var prop of __getOwnPropSymbols$3r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectBillingInfo$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3q(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2d(__spreadValues$3r({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "select_billing_info", __spreadValues$3r(__spreadValues$3r({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3q = Object.defineProperty;
var __getOwnPropSymbols$3q = Object.getOwnPropertySymbols;
var __hasOwnProp$3q = Object.prototype.hasOwnProperty;
var __propIsEnum$3q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3q = (obj, key, value) => key in obj ? __defProp$3q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3q.call(b, prop))
      __defNormalProp$3q(a, prop, b[prop]);
  if (__getOwnPropSymbols$3q)
    for (var prop of __getOwnPropSymbols$3q(b)) {
      if (__propIsEnum$3q.call(b, prop))
        __defNormalProp$3q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3q)
    for (var prop of __getOwnPropSymbols$3q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectBillingInfo$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3p(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3q({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SelectBillingInfo";
  const customData = __spreadValues$3q(__spreadValues$3q({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3p = Object.defineProperty;
var __getOwnPropSymbols$3p = Object.getOwnPropertySymbols;
var __hasOwnProp$3p = Object.prototype.hasOwnProperty;
var __propIsEnum$3p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3p = (obj, key, value) => key in obj ? __defProp$3p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3p.call(b, prop))
      __defNormalProp$3p(a, prop, b[prop]);
  if (__getOwnPropSymbols$3p)
    for (var prop of __getOwnPropSymbols$3p(b)) {
      if (__propIsEnum$3p.call(b, prop))
        __defNormalProp$3p(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3p)
    for (var prop of __getOwnPropSymbols$3p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectBillingInfo = (provider, params) => {
  const rest = __objRest$3o(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3p({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("SelectBilling Info", __spreadValues$3p(__spreadValues$3p({}, transformedParams), transformedMeta));
};

const logSelectBillingInfo = (params) => {
  triageEventToProviders("selectBillingInfo", params, {
    googleAnalyticsHandler: selectBillingInfo$2,
    facebookPixelHandler: selectBillingInfo$1,
    segmentHandler: selectBillingInfo
  });
};

var __defProp$3o = Object.defineProperty;
var __defProps$2c = Object.defineProperties;
var __getOwnPropDescs$2c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3o = Object.getOwnPropertySymbols;
var __hasOwnProp$3o = Object.prototype.hasOwnProperty;
var __propIsEnum$3o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3o = (obj, key, value) => key in obj ? __defProp$3o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3o.call(b, prop))
      __defNormalProp$3o(a, prop, b[prop]);
  if (__getOwnPropSymbols$3o)
    for (var prop of __getOwnPropSymbols$3o(b)) {
      if (__propIsEnum$3o.call(b, prop))
        __defNormalProp$3o(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2c = (a, b) => __defProps$2c(a, __getOwnPropDescs$2c(b));
var __objRest$3n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3o)
    for (var prop of __getOwnPropSymbols$3o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateBillingInfo$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3n(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2c(__spreadValues$3o({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "update_billing_info", __spreadValues$3o(__spreadValues$3o({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3n = Object.defineProperty;
var __getOwnPropSymbols$3n = Object.getOwnPropertySymbols;
var __hasOwnProp$3n = Object.prototype.hasOwnProperty;
var __propIsEnum$3n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3n = (obj, key, value) => key in obj ? __defProp$3n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3n.call(b, prop))
      __defNormalProp$3n(a, prop, b[prop]);
  if (__getOwnPropSymbols$3n)
    for (var prop of __getOwnPropSymbols$3n(b)) {
      if (__propIsEnum$3n.call(b, prop))
        __defNormalProp$3n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3n)
    for (var prop of __getOwnPropSymbols$3n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateBillingInfo$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3m(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3n({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "UpdateBillingInfo";
  const customData = __spreadValues$3n(__spreadValues$3n({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3m = Object.defineProperty;
var __defProps$2b = Object.defineProperties;
var __getOwnPropDescs$2b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3m = Object.getOwnPropertySymbols;
var __hasOwnProp$3m = Object.prototype.hasOwnProperty;
var __propIsEnum$3m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3m = (obj, key, value) => key in obj ? __defProp$3m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3m.call(b, prop))
      __defNormalProp$3m(a, prop, b[prop]);
  if (__getOwnPropSymbols$3m)
    for (var prop of __getOwnPropSymbols$3m(b)) {
      if (__propIsEnum$3m.call(b, prop))
        __defNormalProp$3m(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2b = (a, b) => __defProps$2b(a, __getOwnPropDescs$2b(b));
var __objRest$3l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3m)
    for (var prop of __getOwnPropSymbols$3m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateBillingInfo = (provider, params) => {
  const _a = params, { fields } = _a, rest = __objRest$3l(_a, ["fields"]);
  delete rest.userId;
  const enhancedParams = __spreadProps$2b(__spreadValues$3m({}, rest), { fields: transformArrayParam(fields) });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Update Billing Info", __spreadValues$3m(__spreadValues$3m({}, transformedParams), transformedMeta));
};

const logUpdateBillingInfo = (params) => {
  triageEventToProviders("updateBillingInfo", params, {
    googleAnalyticsHandler: updateBillingInfo$2,
    facebookPixelHandler: updateBillingInfo$1,
    segmentHandler: updateBillingInfo
  });
};

const events$n = {
  logAddBillingInfo,
  logSelectBillingInfo,
  logUpdateBillingInfo
};

var __defProp$3l = Object.defineProperty;
var __defProps$2a = Object.defineProperties;
var __getOwnPropDescs$2a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3l = Object.getOwnPropertySymbols;
var __hasOwnProp$3l = Object.prototype.hasOwnProperty;
var __propIsEnum$3l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3l = (obj, key, value) => key in obj ? __defProp$3l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3l.call(b, prop))
      __defNormalProp$3l(a, prop, b[prop]);
  if (__getOwnPropSymbols$3l)
    for (var prop of __getOwnPropSymbols$3l(b)) {
      if (__propIsEnum$3l.call(b, prop))
        __defNormalProp$3l(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2a = (a, b) => __defProps$2a(a, __getOwnPropDescs$2a(b));
var __objRest$3k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3l)
    for (var prop of __getOwnPropSymbols$3l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const bookAppointment$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$3k(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2a(__spreadValues$3l({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "book_appointment", __spreadValues$3l(__spreadValues$3l({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$3k = Object.defineProperty;
var __getOwnPropSymbols$3k = Object.getOwnPropertySymbols;
var __hasOwnProp$3k = Object.prototype.hasOwnProperty;
var __propIsEnum$3k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3k = (obj, key, value) => key in obj ? __defProp$3k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3k.call(b, prop))
      __defNormalProp$3k(a, prop, b[prop]);
  if (__getOwnPropSymbols$3k)
    for (var prop of __getOwnPropSymbols$3k(b)) {
      if (__propIsEnum$3k.call(b, prop))
        __defNormalProp$3k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3k)
    for (var prop of __getOwnPropSymbols$3k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const bookAppointment$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$3j(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3k({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "Schedule";
  const customData = __spreadValues$3k(__spreadValues$3k({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3j = Object.defineProperty;
var __getOwnPropSymbols$3j = Object.getOwnPropertySymbols;
var __hasOwnProp$3j = Object.prototype.hasOwnProperty;
var __propIsEnum$3j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3j = (obj, key, value) => key in obj ? __defProp$3j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3j.call(b, prop))
      __defNormalProp$3j(a, prop, b[prop]);
  if (__getOwnPropSymbols$3j)
    for (var prop of __getOwnPropSymbols$3j(b)) {
      if (__propIsEnum$3j.call(b, prop))
        __defNormalProp$3j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3j)
    for (var prop of __getOwnPropSymbols$3j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const bookAppointment = (provider, params) => {
  const rest = __objRest$3i(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3j({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Book Appointment", __spreadValues$3j(__spreadValues$3j({}, transformedParams), transformedMeta));
};

const logBookAppointment = (params) => {
  triageEventToProviders("bookAppointment", params, {
    googleAnalyticsHandler: bookAppointment$2,
    facebookPixelHandler: bookAppointment$1,
    segmentHandler: bookAppointment
  });
};

const events$m = { logBookAppointment };

var __defProp$3i = Object.defineProperty;
var __defProps$29 = Object.defineProperties;
var __getOwnPropDescs$29 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3i = Object.getOwnPropertySymbols;
var __hasOwnProp$3i = Object.prototype.hasOwnProperty;
var __propIsEnum$3i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3i = (obj, key, value) => key in obj ? __defProp$3i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3i.call(b, prop))
      __defNormalProp$3i(a, prop, b[prop]);
  if (__getOwnPropSymbols$3i)
    for (var prop of __getOwnPropSymbols$3i(b)) {
      if (__propIsEnum$3i.call(b, prop))
        __defNormalProp$3i(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$29 = (a, b) => __defProps$29(a, __getOwnPropDescs$29(b));
var __objRest$3h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3i)
    for (var prop of __getOwnPropSymbols$3i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const categoryImpression$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, category, list, itemBrand } = _a, rest = __objRest$3h(_a, ["callback", "userId", "category", "list", "itemBrand"]);
  const { position } = params;
  const { categoryId, name } = category;
  const items = [
    {
      item_brand: itemBrand,
      item_id: `${categoryId}`,
      item_list_name: list,
      item_name: name,
      index: position
    }
  ];
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$29(__spreadValues$3i({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_item_list", __spreadValues$3i(__spreadValues$3i({
    send_to: trackingId,
    event_callback: callback,
    item_list_name: list,
    items
  }, transformedParams), transformedMeta));
};

var __defProp$3h = Object.defineProperty;
var __defProps$28 = Object.defineProperties;
var __getOwnPropDescs$28 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3h = Object.getOwnPropertySymbols;
var __hasOwnProp$3h = Object.prototype.hasOwnProperty;
var __propIsEnum$3h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3h = (obj, key, value) => key in obj ? __defProp$3h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3h.call(b, prop))
      __defNormalProp$3h(a, prop, b[prop]);
  if (__getOwnPropSymbols$3h)
    for (var prop of __getOwnPropSymbols$3h(b)) {
      if (__propIsEnum$3h.call(b, prop))
        __defNormalProp$3h(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$28 = (a, b) => __defProps$28(a, __getOwnPropDescs$28(b));
var __objRest$3g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3h)
    for (var prop of __getOwnPropSymbols$3h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const categoryImpression$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { category } = _a, rest = __objRest$3g(_a, ["category"]);
  delete rest.userId;
  const { categoryId, name: categoryName } = category;
  const enhancedParams = __spreadProps$28(__spreadValues$3h({}, rest), { categoryId, categoryName });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "CategoryImpression";
  const customData = __spreadValues$3h(__spreadValues$3h({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3g = Object.defineProperty;
var __defProps$27 = Object.defineProperties;
var __getOwnPropDescs$27 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3g = Object.getOwnPropertySymbols;
var __hasOwnProp$3g = Object.prototype.hasOwnProperty;
var __propIsEnum$3g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3g = (obj, key, value) => key in obj ? __defProp$3g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3g.call(b, prop))
      __defNormalProp$3g(a, prop, b[prop]);
  if (__getOwnPropSymbols$3g)
    for (var prop of __getOwnPropSymbols$3g(b)) {
      if (__propIsEnum$3g.call(b, prop))
        __defNormalProp$3g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$27 = (a, b) => __defProps$27(a, __getOwnPropDescs$27(b));
var __objRest$3f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3g)
    for (var prop of __getOwnPropSymbols$3g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const categoryImpression = (provider, params) => {
  const _a = params, { category } = _a, rest = __objRest$3f(_a, ["category"]);
  delete rest.userId;
  const { categoryId, name: categoryName } = category;
  const enhancedParams = __spreadProps$27(__spreadValues$3g({}, rest), { categoryId, categoryName });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Category Impression", __spreadValues$3g(__spreadValues$3g({}, transformedParams), transformedMeta));
};

const logCategoryImpression = (params) => {
  triageEventToProviders("categoryImpression", params, {
    googleAnalyticsHandler: categoryImpression$2,
    facebookPixelHandler: categoryImpression$1,
    segmentHandler: categoryImpression
  });
};

var __defProp$3f = Object.defineProperty;
var __defProps$26 = Object.defineProperties;
var __getOwnPropDescs$26 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3f = Object.getOwnPropertySymbols;
var __hasOwnProp$3f = Object.prototype.hasOwnProperty;
var __propIsEnum$3f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3f = (obj, key, value) => key in obj ? __defProp$3f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3f.call(b, prop))
      __defNormalProp$3f(a, prop, b[prop]);
  if (__getOwnPropSymbols$3f)
    for (var prop of __getOwnPropSymbols$3f(b)) {
      if (__propIsEnum$3f.call(b, prop))
        __defNormalProp$3f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$26 = (a, b) => __defProps$26(a, __getOwnPropDescs$26(b));
var __objRest$3e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3f)
    for (var prop of __getOwnPropSymbols$3f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchCategoryAttempt$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, query } = _a, rest = __objRest$3e(_a, ["callback", "userId", "query"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$26(__spreadValues$3f({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "search", __spreadValues$3f(__spreadValues$3f({
    send_to: trackingId,
    event_callback: callback,
    search_term: query
  }, transformedParams), transformedMeta));
};

var __defProp$3e = Object.defineProperty;
var __getOwnPropSymbols$3e = Object.getOwnPropertySymbols;
var __hasOwnProp$3e = Object.prototype.hasOwnProperty;
var __propIsEnum$3e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3e = (obj, key, value) => key in obj ? __defProp$3e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3e.call(b, prop))
      __defNormalProp$3e(a, prop, b[prop]);
  if (__getOwnPropSymbols$3e)
    for (var prop of __getOwnPropSymbols$3e(b)) {
      if (__propIsEnum$3e.call(b, prop))
        __defNormalProp$3e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3e)
    for (var prop of __getOwnPropSymbols$3e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchCategoryAttempt$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { query } = _a, rest = __objRest$3d(_a, ["query"]);
  delete rest.userId;
  const enhancedParams = __spreadValues$3e({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "Search";
  const customData = __spreadValues$3e(__spreadValues$3e({
    search_string: query
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3d = Object.defineProperty;
var __getOwnPropSymbols$3d = Object.getOwnPropertySymbols;
var __hasOwnProp$3d = Object.prototype.hasOwnProperty;
var __propIsEnum$3d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3d = (obj, key, value) => key in obj ? __defProp$3d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3d.call(b, prop))
      __defNormalProp$3d(a, prop, b[prop]);
  if (__getOwnPropSymbols$3d)
    for (var prop of __getOwnPropSymbols$3d(b)) {
      if (__propIsEnum$3d.call(b, prop))
        __defNormalProp$3d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3d)
    for (var prop of __getOwnPropSymbols$3d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchCategoryAttempt = (provider, params) => {
  const rest = __objRest$3c(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$3d({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Search Category", __spreadValues$3d(__spreadValues$3d({}, transformedParams), transformedMeta));
};

const logSearchCategoryAttempt = (params) => {
  triageEventToProviders("searchCategoryAttempt", params, {
    googleAnalyticsHandler: searchCategoryAttempt$2,
    facebookPixelHandler: searchCategoryAttempt$1,
    segmentHandler: searchCategoryAttempt
  });
};

var __defProp$3c = Object.defineProperty;
var __defProps$25 = Object.defineProperties;
var __getOwnPropDescs$25 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3c = Object.getOwnPropertySymbols;
var __hasOwnProp$3c = Object.prototype.hasOwnProperty;
var __propIsEnum$3c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3c = (obj, key, value) => key in obj ? __defProp$3c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3c.call(b, prop))
      __defNormalProp$3c(a, prop, b[prop]);
  if (__getOwnPropSymbols$3c)
    for (var prop of __getOwnPropSymbols$3c(b)) {
      if (__propIsEnum$3c.call(b, prop))
        __defNormalProp$3c(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$25 = (a, b) => __defProps$25(a, __getOwnPropDescs$25(b));
var __objRest$3b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3c)
    for (var prop of __getOwnPropSymbols$3c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectCategory$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, category } = _a, rest = __objRest$3b(_a, ["callback", "userId", "category"]);
  if (rest.contentType) {
    delete rest.contentType;
  }
  const { categoryId, name: categoryName } = category;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$25(__spreadValues$3c({}, rest), {
    userId: selectedUserId,
    categoryId,
    categoryName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "select_content", __spreadValues$3c(__spreadValues$3c({
    send_to: trackingId,
    event_callback: callback,
    content_type: "category"
  }, transformedParams), transformedMeta));
};

var __defProp$3b = Object.defineProperty;
var __defProps$24 = Object.defineProperties;
var __getOwnPropDescs$24 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3b = Object.getOwnPropertySymbols;
var __hasOwnProp$3b = Object.prototype.hasOwnProperty;
var __propIsEnum$3b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3b = (obj, key, value) => key in obj ? __defProp$3b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3b.call(b, prop))
      __defNormalProp$3b(a, prop, b[prop]);
  if (__getOwnPropSymbols$3b)
    for (var prop of __getOwnPropSymbols$3b(b)) {
      if (__propIsEnum$3b.call(b, prop))
        __defNormalProp$3b(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$24 = (a, b) => __defProps$24(a, __getOwnPropDescs$24(b));
var __objRest$3a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3b)
    for (var prop of __getOwnPropSymbols$3b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectCategory$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { category } = _a, rest = __objRest$3a(_a, ["category"]);
  delete rest.userId;
  const { categoryId, name: categoryName } = category;
  const enhancedParams = __spreadProps$24(__spreadValues$3b({}, rest), { categoryId, categoryName });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SelectCategory";
  const customData = __spreadValues$3b(__spreadValues$3b({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$3a = Object.defineProperty;
var __defProps$23 = Object.defineProperties;
var __getOwnPropDescs$23 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3a = Object.getOwnPropertySymbols;
var __hasOwnProp$3a = Object.prototype.hasOwnProperty;
var __propIsEnum$3a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3a = (obj, key, value) => key in obj ? __defProp$3a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3a.call(b, prop))
      __defNormalProp$3a(a, prop, b[prop]);
  if (__getOwnPropSymbols$3a)
    for (var prop of __getOwnPropSymbols$3a(b)) {
      if (__propIsEnum$3a.call(b, prop))
        __defNormalProp$3a(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$23 = (a, b) => __defProps$23(a, __getOwnPropDescs$23(b));
var __objRest$39 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3a)
    for (var prop of __getOwnPropSymbols$3a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectCategory = (provider, params) => {
  const _a = params, { category } = _a, rest = __objRest$39(_a, ["category"]);
  delete rest.userId;
  const { categoryId, name: categoryName } = category;
  const enhancedParams = __spreadProps$23(__spreadValues$3a({}, rest), { categoryId, categoryName });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Select Category", __spreadValues$3a(__spreadValues$3a({}, transformedParams), transformedMeta));
};

const logSelectCategory = (params) => {
  triageEventToProviders("selectCategory", params, {
    googleAnalyticsHandler: selectCategory$2,
    facebookPixelHandler: selectCategory$1,
    segmentHandler: selectCategory
  });
};

var __defProp$39 = Object.defineProperty;
var __defProps$22 = Object.defineProperties;
var __getOwnPropDescs$22 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$39 = Object.getOwnPropertySymbols;
var __hasOwnProp$39 = Object.prototype.hasOwnProperty;
var __propIsEnum$39 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$39 = (obj, key, value) => key in obj ? __defProp$39(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$39 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$39.call(b, prop))
      __defNormalProp$39(a, prop, b[prop]);
  if (__getOwnPropSymbols$39)
    for (var prop of __getOwnPropSymbols$39(b)) {
      if (__propIsEnum$39.call(b, prop))
        __defNormalProp$39(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$22 = (a, b) => __defProps$22(a, __getOwnPropDescs$22(b));
var __objRest$38 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$39.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$39)
    for (var prop of __getOwnPropSymbols$39(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$39.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewCategory$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, category } = _a, rest = __objRest$38(_a, ["callback", "userId", "category"]);
  const { categoryId, name: categoryName } = category;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$22(__spreadValues$39({}, rest), {
    userId: selectedUserId,
    categoryId,
    categoryName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_category", __spreadValues$39(__spreadValues$39({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$38 = Object.defineProperty;
var __defProps$21 = Object.defineProperties;
var __getOwnPropDescs$21 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$38 = Object.getOwnPropertySymbols;
var __hasOwnProp$38 = Object.prototype.hasOwnProperty;
var __propIsEnum$38 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$38 = (obj, key, value) => key in obj ? __defProp$38(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$38 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$38.call(b, prop))
      __defNormalProp$38(a, prop, b[prop]);
  if (__getOwnPropSymbols$38)
    for (var prop of __getOwnPropSymbols$38(b)) {
      if (__propIsEnum$38.call(b, prop))
        __defNormalProp$38(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$21 = (a, b) => __defProps$21(a, __getOwnPropDescs$21(b));
var __objRest$37 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$38.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$38)
    for (var prop of __getOwnPropSymbols$38(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$38.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewCategory$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { category } = _a, rest = __objRest$37(_a, ["category"]);
  delete rest.userId;
  const { categoryId, name: categoryName } = category;
  const enhancedParams = __spreadProps$21(__spreadValues$38({}, rest), { categoryId, categoryName });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewCategory";
  const customData = __spreadValues$38(__spreadValues$38({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$37 = Object.defineProperty;
var __defProps$20 = Object.defineProperties;
var __getOwnPropDescs$20 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$37 = Object.getOwnPropertySymbols;
var __hasOwnProp$37 = Object.prototype.hasOwnProperty;
var __propIsEnum$37 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$37 = (obj, key, value) => key in obj ? __defProp$37(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$37 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$37.call(b, prop))
      __defNormalProp$37(a, prop, b[prop]);
  if (__getOwnPropSymbols$37)
    for (var prop of __getOwnPropSymbols$37(b)) {
      if (__propIsEnum$37.call(b, prop))
        __defNormalProp$37(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$20 = (a, b) => __defProps$20(a, __getOwnPropDescs$20(b));
var __objRest$36 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$37.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$37)
    for (var prop of __getOwnPropSymbols$37(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$37.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewCategory = (provider, params) => {
  const _a = params, { category, products } = _a, rest = __objRest$36(_a, ["category", "products"]);
  delete rest.userId;
  const { categoryId, name } = category;
  const enhancedParams = __spreadProps$20(__spreadValues$37({}, rest), { listId: categoryId, category: name });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Product List Viewed", __spreadValues$37(__spreadValues$37({
    products: mapProductsToSegmentProducts(products)
  }, transformedParams), transformedMeta));
};

const logViewCategory = (params) => {
  triageEventToProviders("viewCategory", params, {
    googleAnalyticsHandler: viewCategory$2,
    facebookPixelHandler: viewCategory$1,
    segmentHandler: viewCategory
  });
};

const events$l = {
  logCategoryImpression,
  logSearchCategoryAttempt,
  logSelectCategory,
  logViewCategory
};

var __defProp$36 = Object.defineProperty;
var __defProps$1$ = Object.defineProperties;
var __getOwnPropDescs$1$ = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$36 = Object.getOwnPropertySymbols;
var __hasOwnProp$36 = Object.prototype.hasOwnProperty;
var __propIsEnum$36 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$36 = (obj, key, value) => key in obj ? __defProp$36(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$36 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$36.call(b, prop))
      __defNormalProp$36(a, prop, b[prop]);
  if (__getOwnPropSymbols$36)
    for (var prop of __getOwnPropSymbols$36(b)) {
      if (__propIsEnum$36.call(b, prop))
        __defNormalProp$36(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1$ = (a, b) => __defProps$1$(a, __getOwnPropDescs$1$(b));
var __objRest$35 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$36.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$36)
    for (var prop of __getOwnPropSymbols$36(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$36.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const checkoutAction$2 = (provider, params) => {
  const { trackingId, userId: providerUserId, currency } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$35(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1$(__spreadValues$36({}, rest), { userId: selectedUserId, currency });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "checkout_action", __spreadValues$36(__spreadValues$36({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$35 = Object.defineProperty;
var __getOwnPropSymbols$35 = Object.getOwnPropertySymbols;
var __hasOwnProp$35 = Object.prototype.hasOwnProperty;
var __propIsEnum$35 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$35 = (obj, key, value) => key in obj ? __defProp$35(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$35 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$35.call(b, prop))
      __defNormalProp$35(a, prop, b[prop]);
  if (__getOwnPropSymbols$35)
    for (var prop of __getOwnPropSymbols$35(b)) {
      if (__propIsEnum$35.call(b, prop))
        __defNormalProp$35(a, prop, b[prop]);
    }
  return a;
};
var __objRest$34 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$35.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$35)
    for (var prop of __getOwnPropSymbols$35(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$35.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const checkoutAction$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$34(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$35({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "CheckoutAction";
  const customData = __spreadValues$35(__spreadValues$35({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$34 = Object.defineProperty;
var __getOwnPropSymbols$34 = Object.getOwnPropertySymbols;
var __hasOwnProp$34 = Object.prototype.hasOwnProperty;
var __propIsEnum$34 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$34 = (obj, key, value) => key in obj ? __defProp$34(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$34 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$34.call(b, prop))
      __defNormalProp$34(a, prop, b[prop]);
  if (__getOwnPropSymbols$34)
    for (var prop of __getOwnPropSymbols$34(b)) {
      if (__propIsEnum$34.call(b, prop))
        __defNormalProp$34(a, prop, b[prop]);
    }
  return a;
};
var __objRest$33 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$34.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$34)
    for (var prop of __getOwnPropSymbols$34(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$34.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const checkoutAction = (provider, params) => {
  const rest = __objRest$33(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$34({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Checkout Step Completed", __spreadValues$34(__spreadValues$34({}, transformedParams), transformedMeta));
};

const logCheckoutAction = (params) => {
  triageEventToProviders("checkoutAction", params, {
    googleAnalyticsHandler: checkoutAction$2,
    facebookPixelHandler: checkoutAction$1,
    segmentHandler: checkoutAction
  });
};

var __defProp$33 = Object.defineProperty;
var __defProps$1_ = Object.defineProperties;
var __getOwnPropDescs$1_ = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$33 = Object.getOwnPropertySymbols;
var __hasOwnProp$33 = Object.prototype.hasOwnProperty;
var __propIsEnum$33 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$33 = (obj, key, value) => key in obj ? __defProp$33(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$33 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$33.call(b, prop))
      __defNormalProp$33(a, prop, b[prop]);
  if (__getOwnPropSymbols$33)
    for (var prop of __getOwnPropSymbols$33(b)) {
      if (__propIsEnum$33.call(b, prop))
        __defNormalProp$33(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1_ = (a, b) => __defProps$1_(a, __getOwnPropDescs$1_(b));
var __objRest$32 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$33.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$33)
    for (var prop of __getOwnPropSymbols$33(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$33.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const initiateCheckout$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, shoppingCart, currency } = _a, rest = __objRest$32(_a, ["callback", "userId", "shoppingCart", "currency"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1_(__spreadValues$33({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { total, totalPoints } = getShoppingCartTotal(shoppingCart);
  gtag("event", "begin_checkout", __spreadValues$33(__spreadValues$33({
    send_to: trackingId,
    event_callback: callback,
    items: mapProductsToGoogleItems(shoppingCart, selectedCurrency),
    value: total,
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta));
};

var __defProp$32 = Object.defineProperty;
var __defProps$1Z = Object.defineProperties;
var __getOwnPropDescs$1Z = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$32 = Object.getOwnPropertySymbols;
var __hasOwnProp$32 = Object.prototype.hasOwnProperty;
var __propIsEnum$32 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$32 = (obj, key, value) => key in obj ? __defProp$32(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$32 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$32.call(b, prop))
      __defNormalProp$32(a, prop, b[prop]);
  if (__getOwnPropSymbols$32)
    for (var prop of __getOwnPropSymbols$32(b)) {
      if (__propIsEnum$32.call(b, prop))
        __defNormalProp$32(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1Z = (a, b) => __defProps$1Z(a, __getOwnPropDescs$1Z(b));
var __objRest$31 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$32.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$32)
    for (var prop of __getOwnPropSymbols$32(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$32.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const initiateCheckout$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { shoppingCart, currency } = _a, rest = __objRest$31(_a, ["shoppingCart", "currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1Z(__spreadValues$32({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const productsIds = getProductIdsFromShoppingCart(shoppingCart);
  const { total, totalPoints } = getShoppingCartTotal(shoppingCart);
  const eventName = "InitiateCheckout";
  const customData = __spreadValues$32(__spreadValues$32({
    content_ids: productsIds,
    contents: getProductContentFromShoppingCart(shoppingCart),
    num_items: productsIds.length,
    value: total,
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData: __spreadProps$1Z(__spreadValues$32({}, customData), {
      contents: mapProductsToFacebookItems(shoppingCart)
    })
  });
};

var __defProp$31 = Object.defineProperty;
var __defProps$1Y = Object.defineProperties;
var __getOwnPropDescs$1Y = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$31 = Object.getOwnPropertySymbols;
var __hasOwnProp$31 = Object.prototype.hasOwnProperty;
var __propIsEnum$31 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$31 = (obj, key, value) => key in obj ? __defProp$31(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$31 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$31.call(b, prop))
      __defNormalProp$31(a, prop, b[prop]);
  if (__getOwnPropSymbols$31)
    for (var prop of __getOwnPropSymbols$31(b)) {
      if (__propIsEnum$31.call(b, prop))
        __defNormalProp$31(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1Y = (a, b) => __defProps$1Y(a, __getOwnPropDescs$1Y(b));
var __objRest$30 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$31.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$31)
    for (var prop of __getOwnPropSymbols$31(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$31.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const initiateCheckout = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { shoppingCart, currency } = _a, rest = __objRest$30(_a, ["shoppingCart", "currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1Y(__spreadValues$31({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const products = getShoppingCartProducts(shoppingCart);
  const { total, totalTaxes, shippingCost, totalPoints } = getShoppingCartTotal(shoppingCart);
  analytics.track("Initiate Checkout", __spreadValues$31(__spreadValues$31({
    total,
    revenue: total - (totalTaxes != null ? totalTaxes : 0) - (shippingCost != null ? shippingCost : 0),
    shipping: shippingCost != null ? shippingCost : 0,
    tax: totalTaxes != null ? totalTaxes : 0,
    products: mapProductsToSegmentProducts(products),
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta));
};

const logInitiateCheckout = (params) => {
  triageEventToProviders("initiateCheckout", params, {
    googleAnalyticsHandler: initiateCheckout$2,
    facebookPixelHandler: initiateCheckout$1,
    segmentHandler: initiateCheckout
  });
};

const events$k = { logCheckoutAction, logInitiateCheckout };

var __defProp$30 = Object.defineProperty;
var __defProps$1X = Object.defineProperties;
var __getOwnPropDescs$1X = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$30 = Object.getOwnPropertySymbols;
var __hasOwnProp$30 = Object.prototype.hasOwnProperty;
var __propIsEnum$30 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$30 = (obj, key, value) => key in obj ? __defProp$30(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$30 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$30.call(b, prop))
      __defNormalProp$30(a, prop, b[prop]);
  if (__getOwnPropSymbols$30)
    for (var prop of __getOwnPropSymbols$30(b)) {
      if (__propIsEnum$30.call(b, prop))
        __defNormalProp$30(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1X = (a, b) => __defProps$1X(a, __getOwnPropDescs$1X(b));
var __objRest$2$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$30.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$30)
    for (var prop of __getOwnPropSymbols$30(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$30.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const applyBenefit$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency } = _a, rest = __objRest$2$(_a, ["callback", "userId", "currency"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1X(__spreadValues$30({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "apply_benefit", __spreadValues$30(__spreadValues$30({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2$ = Object.defineProperty;
var __defProps$1W = Object.defineProperties;
var __getOwnPropDescs$1W = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2$ = Object.getOwnPropertySymbols;
var __hasOwnProp$2$ = Object.prototype.hasOwnProperty;
var __propIsEnum$2$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2$ = (obj, key, value) => key in obj ? __defProp$2$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2$.call(b, prop))
      __defNormalProp$2$(a, prop, b[prop]);
  if (__getOwnPropSymbols$2$)
    for (var prop of __getOwnPropSymbols$2$(b)) {
      if (__propIsEnum$2$.call(b, prop))
        __defNormalProp$2$(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1W = (a, b) => __defProps$1W(a, __getOwnPropDescs$1W(b));
var __objRest$2_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2$)
    for (var prop of __getOwnPropSymbols$2$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const applyBenefit$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$2_(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1W(__spreadValues$2$({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ApplyBenefit";
  const customData = __spreadValues$2$(__spreadValues$2$({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2_ = Object.defineProperty;
var __defProps$1V = Object.defineProperties;
var __getOwnPropDescs$1V = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2_ = Object.getOwnPropertySymbols;
var __hasOwnProp$2_ = Object.prototype.hasOwnProperty;
var __propIsEnum$2_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2_ = (obj, key, value) => key in obj ? __defProp$2_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2_.call(b, prop))
      __defNormalProp$2_(a, prop, b[prop]);
  if (__getOwnPropSymbols$2_)
    for (var prop of __getOwnPropSymbols$2_(b)) {
      if (__propIsEnum$2_.call(b, prop))
        __defNormalProp$2_(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1V = (a, b) => __defProps$1V(a, __getOwnPropDescs$1V(b));
var __objRest$2Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2_)
    for (var prop of __getOwnPropSymbols$2_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const applyBenefit = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$2Z(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1V(__spreadValues$2_({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Apply Benefit", __spreadValues$2_(__spreadValues$2_({}, transformedParams), transformedMeta));
};

const logApplyBenefit = (params) => {
  triageEventToProviders("applyBenefit", params, {
    googleAnalyticsHandler: applyBenefit$2,
    facebookPixelHandler: applyBenefit$1,
    segmentHandler: applyBenefit
  });
};

var __defProp$2Z = Object.defineProperty;
var __defProps$1U = Object.defineProperties;
var __getOwnPropDescs$1U = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2Z = Object.getOwnPropertySymbols;
var __hasOwnProp$2Z = Object.prototype.hasOwnProperty;
var __propIsEnum$2Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2Z = (obj, key, value) => key in obj ? __defProp$2Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2Z.call(b, prop))
      __defNormalProp$2Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$2Z)
    for (var prop of __getOwnPropSymbols$2Z(b)) {
      if (__propIsEnum$2Z.call(b, prop))
        __defNormalProp$2Z(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1U = (a, b) => __defProps$1U(a, __getOwnPropDescs$1U(b));
var __objRest$2Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2Z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2Z)
    for (var prop of __getOwnPropSymbols$2Z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2Z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const couponCodeError$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency } = _a, rest = __objRest$2Y(_a, ["callback", "userId", "currency"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1U(__spreadValues$2Z({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "coupon_code_error", __spreadValues$2Z(__spreadValues$2Z({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2Y = Object.defineProperty;
var __defProps$1T = Object.defineProperties;
var __getOwnPropDescs$1T = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2Y = Object.getOwnPropertySymbols;
var __hasOwnProp$2Y = Object.prototype.hasOwnProperty;
var __propIsEnum$2Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2Y = (obj, key, value) => key in obj ? __defProp$2Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2Y.call(b, prop))
      __defNormalProp$2Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$2Y)
    for (var prop of __getOwnPropSymbols$2Y(b)) {
      if (__propIsEnum$2Y.call(b, prop))
        __defNormalProp$2Y(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1T = (a, b) => __defProps$1T(a, __getOwnPropDescs$1T(b));
var __objRest$2X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2Y)
    for (var prop of __getOwnPropSymbols$2Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const couponCodeError$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$2X(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1T(__spreadValues$2Y({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "CouponCodeError";
  const customData = __spreadValues$2Y(__spreadValues$2Y({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2X = Object.defineProperty;
var __defProps$1S = Object.defineProperties;
var __getOwnPropDescs$1S = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2X = Object.getOwnPropertySymbols;
var __hasOwnProp$2X = Object.prototype.hasOwnProperty;
var __propIsEnum$2X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2X = (obj, key, value) => key in obj ? __defProp$2X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2X.call(b, prop))
      __defNormalProp$2X(a, prop, b[prop]);
  if (__getOwnPropSymbols$2X)
    for (var prop of __getOwnPropSymbols$2X(b)) {
      if (__propIsEnum$2X.call(b, prop))
        __defNormalProp$2X(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1S = (a, b) => __defProps$1S(a, __getOwnPropDescs$1S(b));
var __objRest$2W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2X)
    for (var prop of __getOwnPropSymbols$2X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const couponCodeError = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$2W(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1S(__spreadValues$2X({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Coupon Code Error", __spreadValues$2X(__spreadValues$2X({}, transformedParams), transformedMeta));
};

const logCouponCodeError = (params) => {
  triageEventToProviders("couponCodeError", params, {
    googleAnalyticsHandler: couponCodeError$2,
    facebookPixelHandler: couponCodeError$1,
    segmentHandler: couponCodeError
  });
};

var __defProp$2W = Object.defineProperty;
var __defProps$1R = Object.defineProperties;
var __getOwnPropDescs$1R = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2W = Object.getOwnPropertySymbols;
var __hasOwnProp$2W = Object.prototype.hasOwnProperty;
var __propIsEnum$2W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2W = (obj, key, value) => key in obj ? __defProp$2W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2W.call(b, prop))
      __defNormalProp$2W(a, prop, b[prop]);
  if (__getOwnPropSymbols$2W)
    for (var prop of __getOwnPropSymbols$2W(b)) {
      if (__propIsEnum$2W.call(b, prop))
        __defNormalProp$2W(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1R = (a, b) => __defProps$1R(a, __getOwnPropDescs$1R(b));
var __objRest$2V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2W)
    for (var prop of __getOwnPropSymbols$2W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const redeemCouponCode$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2V(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1R(__spreadValues$2W({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "redeem_coupon_code", __spreadValues$2W(__spreadValues$2W({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2V = Object.defineProperty;
var __getOwnPropSymbols$2V = Object.getOwnPropertySymbols;
var __hasOwnProp$2V = Object.prototype.hasOwnProperty;
var __propIsEnum$2V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2V = (obj, key, value) => key in obj ? __defProp$2V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2V.call(b, prop))
      __defNormalProp$2V(a, prop, b[prop]);
  if (__getOwnPropSymbols$2V)
    for (var prop of __getOwnPropSymbols$2V(b)) {
      if (__propIsEnum$2V.call(b, prop))
        __defNormalProp$2V(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2V)
    for (var prop of __getOwnPropSymbols$2V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const redeemCouponCode$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2U(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2V({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "RedeemCouponCode";
  const customData = __spreadValues$2V(__spreadValues$2V({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2U = Object.defineProperty;
var __getOwnPropSymbols$2U = Object.getOwnPropertySymbols;
var __hasOwnProp$2U = Object.prototype.hasOwnProperty;
var __propIsEnum$2U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2U = (obj, key, value) => key in obj ? __defProp$2U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2U.call(b, prop))
      __defNormalProp$2U(a, prop, b[prop]);
  if (__getOwnPropSymbols$2U)
    for (var prop of __getOwnPropSymbols$2U(b)) {
      if (__propIsEnum$2U.call(b, prop))
        __defNormalProp$2U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2U)
    for (var prop of __getOwnPropSymbols$2U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const redeemCouponCode = (provider, params) => {
  const rest = __objRest$2T(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2U({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Redeem Coupon Code", __spreadValues$2U(__spreadValues$2U({}, transformedParams), transformedMeta));
};

const logRedeemCouponCode = (params) => {
  triageEventToProviders("redeemCouponCode", params, {
    googleAnalyticsHandler: redeemCouponCode$2,
    facebookPixelHandler: redeemCouponCode$1,
    segmentHandler: redeemCouponCode
  });
};

var __defProp$2T = Object.defineProperty;
var __defProps$1Q = Object.defineProperties;
var __getOwnPropDescs$1Q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2T = Object.getOwnPropertySymbols;
var __hasOwnProp$2T = Object.prototype.hasOwnProperty;
var __propIsEnum$2T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2T = (obj, key, value) => key in obj ? __defProp$2T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2T.call(b, prop))
      __defNormalProp$2T(a, prop, b[prop]);
  if (__getOwnPropSymbols$2T)
    for (var prop of __getOwnPropSymbols$2T(b)) {
      if (__propIsEnum$2T.call(b, prop))
        __defNormalProp$2T(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1Q = (a, b) => __defProps$1Q(a, __getOwnPropDescs$1Q(b));
var __objRest$2S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2T)
    for (var prop of __getOwnPropSymbols$2T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const removeBenefit$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency } = _a, rest = __objRest$2S(_a, ["callback", "userId", "currency"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1Q(__spreadValues$2T({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "remove_benefit", __spreadValues$2T(__spreadValues$2T({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2S = Object.defineProperty;
var __defProps$1P = Object.defineProperties;
var __getOwnPropDescs$1P = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2S = Object.getOwnPropertySymbols;
var __hasOwnProp$2S = Object.prototype.hasOwnProperty;
var __propIsEnum$2S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2S = (obj, key, value) => key in obj ? __defProp$2S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2S.call(b, prop))
      __defNormalProp$2S(a, prop, b[prop]);
  if (__getOwnPropSymbols$2S)
    for (var prop of __getOwnPropSymbols$2S(b)) {
      if (__propIsEnum$2S.call(b, prop))
        __defNormalProp$2S(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1P = (a, b) => __defProps$1P(a, __getOwnPropDescs$1P(b));
var __objRest$2R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2S)
    for (var prop of __getOwnPropSymbols$2S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const removeBenefit$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$2R(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1P(__spreadValues$2S({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "RemoveBenefit";
  const customData = __spreadValues$2S(__spreadValues$2S({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2R = Object.defineProperty;
var __defProps$1O = Object.defineProperties;
var __getOwnPropDescs$1O = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2R = Object.getOwnPropertySymbols;
var __hasOwnProp$2R = Object.prototype.hasOwnProperty;
var __propIsEnum$2R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2R = (obj, key, value) => key in obj ? __defProp$2R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2R.call(b, prop))
      __defNormalProp$2R(a, prop, b[prop]);
  if (__getOwnPropSymbols$2R)
    for (var prop of __getOwnPropSymbols$2R(b)) {
      if (__propIsEnum$2R.call(b, prop))
        __defNormalProp$2R(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1O = (a, b) => __defProps$1O(a, __getOwnPropDescs$1O(b));
var __objRest$2Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2R)
    for (var prop of __getOwnPropSymbols$2R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const removeBenefit = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$2Q(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1O(__spreadValues$2R({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Remove Benefit", __spreadValues$2R(__spreadValues$2R({}, transformedParams), transformedMeta));
};

const logRemoveBenefit = (params) => {
  triageEventToProviders("removeBenefit", params, {
    googleAnalyticsHandler: removeBenefit$2,
    facebookPixelHandler: removeBenefit$1,
    segmentHandler: removeBenefit
  });
};

var __defProp$2Q = Object.defineProperty;
var __defProps$1N = Object.defineProperties;
var __getOwnPropDescs$1N = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2Q = Object.getOwnPropertySymbols;
var __hasOwnProp$2Q = Object.prototype.hasOwnProperty;
var __propIsEnum$2Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2Q = (obj, key, value) => key in obj ? __defProp$2Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2Q.call(b, prop))
      __defNormalProp$2Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$2Q)
    for (var prop of __getOwnPropSymbols$2Q(b)) {
      if (__propIsEnum$2Q.call(b, prop))
        __defNormalProp$2Q(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1N = (a, b) => __defProps$1N(a, __getOwnPropDescs$1N(b));
var __objRest$2P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2Q)
    for (var prop of __getOwnPropSymbols$2Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewBenefitDetails$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency } = _a, rest = __objRest$2P(_a, ["callback", "userId", "currency"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1N(__spreadValues$2Q({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_benefit_details", __spreadValues$2Q(__spreadValues$2Q({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2P = Object.defineProperty;
var __defProps$1M = Object.defineProperties;
var __getOwnPropDescs$1M = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2P = Object.getOwnPropertySymbols;
var __hasOwnProp$2P = Object.prototype.hasOwnProperty;
var __propIsEnum$2P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2P = (obj, key, value) => key in obj ? __defProp$2P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2P.call(b, prop))
      __defNormalProp$2P(a, prop, b[prop]);
  if (__getOwnPropSymbols$2P)
    for (var prop of __getOwnPropSymbols$2P(b)) {
      if (__propIsEnum$2P.call(b, prop))
        __defNormalProp$2P(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1M = (a, b) => __defProps$1M(a, __getOwnPropDescs$1M(b));
var __objRest$2O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2P)
    for (var prop of __getOwnPropSymbols$2P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewBenefitDetails$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$2O(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1M(__spreadValues$2P({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewBenefitDetails";
  const customData = __spreadValues$2P(__spreadValues$2P({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2O = Object.defineProperty;
var __defProps$1L = Object.defineProperties;
var __getOwnPropDescs$1L = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2O = Object.getOwnPropertySymbols;
var __hasOwnProp$2O = Object.prototype.hasOwnProperty;
var __propIsEnum$2O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2O = (obj, key, value) => key in obj ? __defProp$2O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2O.call(b, prop))
      __defNormalProp$2O(a, prop, b[prop]);
  if (__getOwnPropSymbols$2O)
    for (var prop of __getOwnPropSymbols$2O(b)) {
      if (__propIsEnum$2O.call(b, prop))
        __defNormalProp$2O(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1L = (a, b) => __defProps$1L(a, __getOwnPropDescs$1L(b));
var __objRest$2N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2O)
    for (var prop of __getOwnPropSymbols$2O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewBenefitDetails = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$2N(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1L(__spreadValues$2O({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("View Benefit Details", __spreadValues$2O(__spreadValues$2O({}, transformedParams), transformedMeta));
};

const logViewBenefitDetails = (params) => {
  triageEventToProviders("viewBenefitDetails", params, {
    googleAnalyticsHandler: viewBenefitDetails$2,
    facebookPixelHandler: viewBenefitDetails$1,
    segmentHandler: viewBenefitDetails
  });
};

var __defProp$2N = Object.defineProperty;
var __defProps$1K = Object.defineProperties;
var __getOwnPropDescs$1K = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2N = Object.getOwnPropertySymbols;
var __hasOwnProp$2N = Object.prototype.hasOwnProperty;
var __propIsEnum$2N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2N = (obj, key, value) => key in obj ? __defProp$2N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2N.call(b, prop))
      __defNormalProp$2N(a, prop, b[prop]);
  if (__getOwnPropSymbols$2N)
    for (var prop of __getOwnPropSymbols$2N(b)) {
      if (__propIsEnum$2N.call(b, prop))
        __defNormalProp$2N(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1K = (a, b) => __defProps$1K(a, __getOwnPropDescs$1K(b));
var __objRest$2M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2N)
    for (var prop of __getOwnPropSymbols$2N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewBenefitsWallet$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2M(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1K(__spreadValues$2N({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_benefits_wallet", __spreadValues$2N(__spreadValues$2N({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2M = Object.defineProperty;
var __getOwnPropSymbols$2M = Object.getOwnPropertySymbols;
var __hasOwnProp$2M = Object.prototype.hasOwnProperty;
var __propIsEnum$2M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2M = (obj, key, value) => key in obj ? __defProp$2M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2M.call(b, prop))
      __defNormalProp$2M(a, prop, b[prop]);
  if (__getOwnPropSymbols$2M)
    for (var prop of __getOwnPropSymbols$2M(b)) {
      if (__propIsEnum$2M.call(b, prop))
        __defNormalProp$2M(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2M)
    for (var prop of __getOwnPropSymbols$2M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewBenefitsWallet$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2L(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2M({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewBenefitsWallet";
  const customData = __spreadValues$2M(__spreadValues$2M({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2L = Object.defineProperty;
var __getOwnPropSymbols$2L = Object.getOwnPropertySymbols;
var __hasOwnProp$2L = Object.prototype.hasOwnProperty;
var __propIsEnum$2L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2L = (obj, key, value) => key in obj ? __defProp$2L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2L.call(b, prop))
      __defNormalProp$2L(a, prop, b[prop]);
  if (__getOwnPropSymbols$2L)
    for (var prop of __getOwnPropSymbols$2L(b)) {
      if (__propIsEnum$2L.call(b, prop))
        __defNormalProp$2L(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2L)
    for (var prop of __getOwnPropSymbols$2L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewBenefitsWallet = (provider, params) => {
  const rest = __objRest$2K(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2L({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("View Benefits Wallet", __spreadValues$2L(__spreadValues$2L({}, transformedParams), transformedMeta));
};

const logViewBenefitsWallet = (params) => {
  triageEventToProviders("viewBenefitsWallet", params, {
    googleAnalyticsHandler: viewBenefitsWallet$2,
    facebookPixelHandler: viewBenefitsWallet$1,
    segmentHandler: viewBenefitsWallet
  });
};

var __defProp$2K = Object.defineProperty;
var __defProps$1J = Object.defineProperties;
var __getOwnPropDescs$1J = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2K = Object.getOwnPropertySymbols;
var __hasOwnProp$2K = Object.prototype.hasOwnProperty;
var __propIsEnum$2K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2K = (obj, key, value) => key in obj ? __defProp$2K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2K.call(b, prop))
      __defNormalProp$2K(a, prop, b[prop]);
  if (__getOwnPropSymbols$2K)
    for (var prop of __getOwnPropSymbols$2K(b)) {
      if (__propIsEnum$2K.call(b, prop))
        __defNormalProp$2K(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1J = (a, b) => __defProps$1J(a, __getOwnPropDescs$1J(b));
var __objRest$2J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2K)
    for (var prop of __getOwnPropSymbols$2K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewQRStoreCoupon$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2J(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1J(__spreadValues$2K({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_qr_store_coupon", __spreadValues$2K(__spreadValues$2K({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2J = Object.defineProperty;
var __getOwnPropSymbols$2J = Object.getOwnPropertySymbols;
var __hasOwnProp$2J = Object.prototype.hasOwnProperty;
var __propIsEnum$2J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2J = (obj, key, value) => key in obj ? __defProp$2J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2J.call(b, prop))
      __defNormalProp$2J(a, prop, b[prop]);
  if (__getOwnPropSymbols$2J)
    for (var prop of __getOwnPropSymbols$2J(b)) {
      if (__propIsEnum$2J.call(b, prop))
        __defNormalProp$2J(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2J)
    for (var prop of __getOwnPropSymbols$2J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewQRStoreCoupon$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2I(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2J({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewQRStoreCoupon";
  const customData = __spreadValues$2J(__spreadValues$2J({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2I = Object.defineProperty;
var __getOwnPropSymbols$2I = Object.getOwnPropertySymbols;
var __hasOwnProp$2I = Object.prototype.hasOwnProperty;
var __propIsEnum$2I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2I = (obj, key, value) => key in obj ? __defProp$2I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2I.call(b, prop))
      __defNormalProp$2I(a, prop, b[prop]);
  if (__getOwnPropSymbols$2I)
    for (var prop of __getOwnPropSymbols$2I(b)) {
      if (__propIsEnum$2I.call(b, prop))
        __defNormalProp$2I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2I)
    for (var prop of __getOwnPropSymbols$2I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewQRStoreCoupon = (provider, params) => {
  const rest = __objRest$2H(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2I({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("View QR Store Coupon", __spreadValues$2I(__spreadValues$2I({}, transformedParams), transformedMeta));
};

const logViewQRStoreCoupon = (params = {}) => {
  triageEventToProviders("viewQRStoreCoupon", params, {
    googleAnalyticsHandler: viewQRStoreCoupon$2,
    facebookPixelHandler: viewQRStoreCoupon$1,
    segmentHandler: viewQRStoreCoupon
  });
};

const events$j = {
  logApplyBenefit,
  logCouponCodeError,
  logRedeemCouponCode,
  logRemoveBenefit,
  logViewBenefitDetails,
  logViewBenefitsWallet,
  logViewQRStoreCoupon
};

var __defProp$2H = Object.defineProperty;
var __defProps$1I = Object.defineProperties;
var __getOwnPropDescs$1I = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2H = Object.getOwnPropertySymbols;
var __hasOwnProp$2H = Object.prototype.hasOwnProperty;
var __propIsEnum$2H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2H = (obj, key, value) => key in obj ? __defProp$2H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2H.call(b, prop))
      __defNormalProp$2H(a, prop, b[prop]);
  if (__getOwnPropSymbols$2H)
    for (var prop of __getOwnPropSymbols$2H(b)) {
      if (__propIsEnum$2H.call(b, prop))
        __defNormalProp$2H(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1I = (a, b) => __defProps$1I(a, __getOwnPropDescs$1I(b));
var __objRest$2G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2H)
    for (var prop of __getOwnPropSymbols$2H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addCredits$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency, amount } = _a, rest = __objRest$2G(_a, ["callback", "userId", "currency", "amount"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1I(__spreadValues$2H({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency,
    amount,
    value: amount
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "add_credits", __spreadValues$2H(__spreadValues$2H({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2G = Object.defineProperty;
var __defProps$1H = Object.defineProperties;
var __getOwnPropDescs$1H = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2G = Object.getOwnPropertySymbols;
var __hasOwnProp$2G = Object.prototype.hasOwnProperty;
var __propIsEnum$2G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2G = (obj, key, value) => key in obj ? __defProp$2G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2G.call(b, prop))
      __defNormalProp$2G(a, prop, b[prop]);
  if (__getOwnPropSymbols$2G)
    for (var prop of __getOwnPropSymbols$2G(b)) {
      if (__propIsEnum$2G.call(b, prop))
        __defNormalProp$2G(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1H = (a, b) => __defProps$1H(a, __getOwnPropDescs$1H(b));
var __objRest$2F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2G)
    for (var prop of __getOwnPropSymbols$2G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addCredits$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { amount, currency } = _a, rest = __objRest$2F(_a, ["amount", "currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1H(__spreadValues$2G({}, rest), {
    currency: selectedCurrency,
    amount,
    value: amount
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "AddCredits";
  const customData = __spreadValues$2G(__spreadValues$2G({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2F = Object.defineProperty;
var __defProps$1G = Object.defineProperties;
var __getOwnPropDescs$1G = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2F = Object.getOwnPropertySymbols;
var __hasOwnProp$2F = Object.prototype.hasOwnProperty;
var __propIsEnum$2F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2F = (obj, key, value) => key in obj ? __defProp$2F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2F.call(b, prop))
      __defNormalProp$2F(a, prop, b[prop]);
  if (__getOwnPropSymbols$2F)
    for (var prop of __getOwnPropSymbols$2F(b)) {
      if (__propIsEnum$2F.call(b, prop))
        __defNormalProp$2F(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1G = (a, b) => __defProps$1G(a, __getOwnPropDescs$1G(b));
var __objRest$2E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2F)
    for (var prop of __getOwnPropSymbols$2F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addCredits = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { amount, currency } = _a, rest = __objRest$2E(_a, ["amount", "currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1G(__spreadValues$2F({}, rest), {
    currency: selectedCurrency,
    amount,
    value: amount
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Add Credits", __spreadValues$2F(__spreadValues$2F({}, transformedParams), transformedMeta));
};

const logAddCredits = (params) => {
  triageEventToProviders("addCredits", params, {
    googleAnalyticsHandler: addCredits$2,
    facebookPixelHandler: addCredits$1,
    segmentHandler: addCredits
  });
};

var __defProp$2E = Object.defineProperty;
var __defProps$1F = Object.defineProperties;
var __getOwnPropDescs$1F = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2E = Object.getOwnPropertySymbols;
var __hasOwnProp$2E = Object.prototype.hasOwnProperty;
var __propIsEnum$2E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2E = (obj, key, value) => key in obj ? __defProp$2E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2E.call(b, prop))
      __defNormalProp$2E(a, prop, b[prop]);
  if (__getOwnPropSymbols$2E)
    for (var prop of __getOwnPropSymbols$2E(b)) {
      if (__propIsEnum$2E.call(b, prop))
        __defNormalProp$2E(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1F = (a, b) => __defProps$1F(a, __getOwnPropDescs$1F(b));
var __objRest$2D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2E)
    for (var prop of __getOwnPropSymbols$2E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const spendCredits$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency, amount } = _a, rest = __objRest$2D(_a, ["callback", "userId", "currency", "amount"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1F(__spreadValues$2E({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency,
    amount,
    value: amount
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "spend_credits", __spreadValues$2E(__spreadValues$2E({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2D = Object.defineProperty;
var __defProps$1E = Object.defineProperties;
var __getOwnPropDescs$1E = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2D = Object.getOwnPropertySymbols;
var __hasOwnProp$2D = Object.prototype.hasOwnProperty;
var __propIsEnum$2D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2D = (obj, key, value) => key in obj ? __defProp$2D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2D.call(b, prop))
      __defNormalProp$2D(a, prop, b[prop]);
  if (__getOwnPropSymbols$2D)
    for (var prop of __getOwnPropSymbols$2D(b)) {
      if (__propIsEnum$2D.call(b, prop))
        __defNormalProp$2D(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1E = (a, b) => __defProps$1E(a, __getOwnPropDescs$1E(b));
var __objRest$2C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2D)
    for (var prop of __getOwnPropSymbols$2D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const spendCredits$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, amount } = _a, rest = __objRest$2C(_a, ["currency", "amount"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1E(__spreadValues$2D({}, rest), {
    currency: selectedCurrency,
    amount,
    value: amount
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SpendCredits";
  const customData = __spreadValues$2D(__spreadValues$2D({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2C = Object.defineProperty;
var __defProps$1D = Object.defineProperties;
var __getOwnPropDescs$1D = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2C = Object.getOwnPropertySymbols;
var __hasOwnProp$2C = Object.prototype.hasOwnProperty;
var __propIsEnum$2C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2C = (obj, key, value) => key in obj ? __defProp$2C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2C.call(b, prop))
      __defNormalProp$2C(a, prop, b[prop]);
  if (__getOwnPropSymbols$2C)
    for (var prop of __getOwnPropSymbols$2C(b)) {
      if (__propIsEnum$2C.call(b, prop))
        __defNormalProp$2C(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1D = (a, b) => __defProps$1D(a, __getOwnPropDescs$1D(b));
var __objRest$2B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2C)
    for (var prop of __getOwnPropSymbols$2C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const spendCredits = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, amount } = _a, rest = __objRest$2B(_a, ["currency", "amount"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1D(__spreadValues$2C({}, rest), {
    currency: selectedCurrency,
    amount,
    value: amount
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Spend Credits", __spreadValues$2C(__spreadValues$2C({}, transformedParams), transformedMeta));
};

const logSpendCredits = (params) => {
  triageEventToProviders("spendCredits", params, {
    googleAnalyticsHandler: spendCredits$2,
    facebookPixelHandler: spendCredits$1,
    segmentHandler: spendCredits
  });
};

var __defProp$2B = Object.defineProperty;
var __defProps$1C = Object.defineProperties;
var __getOwnPropDescs$1C = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2B = Object.getOwnPropertySymbols;
var __hasOwnProp$2B = Object.prototype.hasOwnProperty;
var __propIsEnum$2B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2B = (obj, key, value) => key in obj ? __defProp$2B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2B.call(b, prop))
      __defNormalProp$2B(a, prop, b[prop]);
  if (__getOwnPropSymbols$2B)
    for (var prop of __getOwnPropSymbols$2B(b)) {
      if (__propIsEnum$2B.call(b, prop))
        __defNormalProp$2B(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1C = (a, b) => __defProps$1C(a, __getOwnPropDescs$1C(b));
var __objRest$2A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2B)
    for (var prop of __getOwnPropSymbols$2B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewCredits$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2A(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1C(__spreadValues$2B({}, rest), {
    userId: selectedUserId
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_credits", __spreadValues$2B(__spreadValues$2B({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2A = Object.defineProperty;
var __getOwnPropSymbols$2A = Object.getOwnPropertySymbols;
var __hasOwnProp$2A = Object.prototype.hasOwnProperty;
var __propIsEnum$2A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2A = (obj, key, value) => key in obj ? __defProp$2A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2A.call(b, prop))
      __defNormalProp$2A(a, prop, b[prop]);
  if (__getOwnPropSymbols$2A)
    for (var prop of __getOwnPropSymbols$2A(b)) {
      if (__propIsEnum$2A.call(b, prop))
        __defNormalProp$2A(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2A)
    for (var prop of __getOwnPropSymbols$2A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewCredits$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2z(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2A({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewCredits";
  const customData = __spreadValues$2A(__spreadValues$2A({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2z = Object.defineProperty;
var __getOwnPropSymbols$2z = Object.getOwnPropertySymbols;
var __hasOwnProp$2z = Object.prototype.hasOwnProperty;
var __propIsEnum$2z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2z = (obj, key, value) => key in obj ? __defProp$2z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2z.call(b, prop))
      __defNormalProp$2z(a, prop, b[prop]);
  if (__getOwnPropSymbols$2z)
    for (var prop of __getOwnPropSymbols$2z(b)) {
      if (__propIsEnum$2z.call(b, prop))
        __defNormalProp$2z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2z)
    for (var prop of __getOwnPropSymbols$2z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewCredits = (provider, params) => {
  const rest = __objRest$2y(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2z({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("View Credits", __spreadValues$2z(__spreadValues$2z({}, transformedParams), transformedMeta));
};

const logViewCredits = (params) => {
  triageEventToProviders("viewCredits", params, {
    googleAnalyticsHandler: viewCredits$2,
    facebookPixelHandler: viewCredits$1,
    segmentHandler: viewCredits
  });
};

const events$i = { logAddCredits, logSpendCredits, logViewCredits };

var __defProp$2y = Object.defineProperty;
var __defProps$1B = Object.defineProperties;
var __getOwnPropDescs$1B = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2y = Object.getOwnPropertySymbols;
var __hasOwnProp$2y = Object.prototype.hasOwnProperty;
var __propIsEnum$2y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2y = (obj, key, value) => key in obj ? __defProp$2y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2y.call(b, prop))
      __defNormalProp$2y(a, prop, b[prop]);
  if (__getOwnPropSymbols$2y)
    for (var prop of __getOwnPropSymbols$2y(b)) {
      if (__propIsEnum$2y.call(b, prop))
        __defNormalProp$2y(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1B = (a, b) => __defProps$1B(a, __getOwnPropDescs$1B(b));
var __objRest$2x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2y)
    for (var prop of __getOwnPropSymbols$2y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const customEvent$2 = (eventName, provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2x(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1B(__spreadValues$2y({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", eventName, __spreadValues$2y(__spreadProps$1B(__spreadValues$2y({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), {
    artisn_event: "custom_event"
  }), transformedMeta));
};

var __defProp$2x = Object.defineProperty;
var __defProps$1A = Object.defineProperties;
var __getOwnPropDescs$1A = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2x = Object.getOwnPropertySymbols;
var __hasOwnProp$2x = Object.prototype.hasOwnProperty;
var __propIsEnum$2x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2x = (obj, key, value) => key in obj ? __defProp$2x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2x.call(b, prop))
      __defNormalProp$2x(a, prop, b[prop]);
  if (__getOwnPropSymbols$2x)
    for (var prop of __getOwnPropSymbols$2x(b)) {
      if (__propIsEnum$2x.call(b, prop))
        __defNormalProp$2x(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1A = (a, b) => __defProps$1A(a, __getOwnPropDescs$1A(b));
var __objRest$2w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2x)
    for (var prop of __getOwnPropSymbols$2x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const customEvent$1 = (eventName, provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2w(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2x({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const customData = __spreadValues$2x(__spreadProps$1A(__spreadValues$2x({}, transformedParams), {
    artisn_event: "CustomEvent"
  }), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2w = Object.defineProperty;
var __defProps$1z = Object.defineProperties;
var __getOwnPropDescs$1z = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2w = Object.getOwnPropertySymbols;
var __hasOwnProp$2w = Object.prototype.hasOwnProperty;
var __propIsEnum$2w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2w = (obj, key, value) => key in obj ? __defProp$2w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2w.call(b, prop))
      __defNormalProp$2w(a, prop, b[prop]);
  if (__getOwnPropSymbols$2w)
    for (var prop of __getOwnPropSymbols$2w(b)) {
      if (__propIsEnum$2w.call(b, prop))
        __defNormalProp$2w(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1z = (a, b) => __defProps$1z(a, __getOwnPropDescs$1z(b));
var __objRest$2v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2w)
    for (var prop of __getOwnPropSymbols$2w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const customEvent = (eventName, provider, params) => {
  const rest = __objRest$2v(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2w({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track(eventName, __spreadValues$2w(__spreadProps$1z(__spreadValues$2w({}, transformedParams), {
    artisn_event: "Custom Event"
  }), transformedMeta));
};

const logCustomEvent = (eventName, params = {}) => {
  triageEventToProviders(eventName, params, {
    googleAnalyticsHandler: (provider, params2) => customEvent$2(eventName, provider, params2),
    facebookPixelHandler: (provider, params2) => customEvent$1(eventName, provider, params2),
    segmentHandler: (provider, params2) => customEvent(eventName, provider, params2)
  });
};

var __defProp$2v = Object.defineProperty;
var __defProps$1y = Object.defineProperties;
var __getOwnPropDescs$1y = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2v = Object.getOwnPropertySymbols;
var __hasOwnProp$2v = Object.prototype.hasOwnProperty;
var __propIsEnum$2v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2v = (obj, key, value) => key in obj ? __defProp$2v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2v.call(b, prop))
      __defNormalProp$2v(a, prop, b[prop]);
  if (__getOwnPropSymbols$2v)
    for (var prop of __getOwnPropSymbols$2v(b)) {
      if (__propIsEnum$2v.call(b, prop))
        __defNormalProp$2v(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1y = (a, b) => __defProps$1y(a, __getOwnPropDescs$1y(b));
var __objRest$2u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2v)
    for (var prop of __getOwnPropSymbols$2v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewFulfillmentStep$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2u(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1y(__spreadValues$2v({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_fulfillment_step", __spreadValues$2v(__spreadValues$2v({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2u = Object.defineProperty;
var __getOwnPropSymbols$2u = Object.getOwnPropertySymbols;
var __hasOwnProp$2u = Object.prototype.hasOwnProperty;
var __propIsEnum$2u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2u = (obj, key, value) => key in obj ? __defProp$2u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2u.call(b, prop))
      __defNormalProp$2u(a, prop, b[prop]);
  if (__getOwnPropSymbols$2u)
    for (var prop of __getOwnPropSymbols$2u(b)) {
      if (__propIsEnum$2u.call(b, prop))
        __defNormalProp$2u(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2u)
    for (var prop of __getOwnPropSymbols$2u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewFulfillmentStep$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2t(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2u({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewFulfillmentStep";
  const customData = __spreadValues$2u(__spreadValues$2u({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2t = Object.defineProperty;
var __getOwnPropSymbols$2t = Object.getOwnPropertySymbols;
var __hasOwnProp$2t = Object.prototype.hasOwnProperty;
var __propIsEnum$2t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2t = (obj, key, value) => key in obj ? __defProp$2t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2t.call(b, prop))
      __defNormalProp$2t(a, prop, b[prop]);
  if (__getOwnPropSymbols$2t)
    for (var prop of __getOwnPropSymbols$2t(b)) {
      if (__propIsEnum$2t.call(b, prop))
        __defNormalProp$2t(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2t)
    for (var prop of __getOwnPropSymbols$2t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewFulfillmentStep = (provider, params) => {
  const rest = __objRest$2s(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2t({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("View Fulfillment Step", __spreadValues$2t(__spreadValues$2t({}, transformedParams), transformedMeta));
};

const logViewFulfillmentStep = (params) => {
  triageEventToProviders("viewFulfillmentStep", params, {
    googleAnalyticsHandler: viewFulfillmentStep$2,
    facebookPixelHandler: viewFulfillmentStep$1,
    segmentHandler: viewFulfillmentStep
  });
};

var __defProp$2s = Object.defineProperty;
var __defProps$1x = Object.defineProperties;
var __getOwnPropDescs$1x = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2s = Object.getOwnPropertySymbols;
var __hasOwnProp$2s = Object.prototype.hasOwnProperty;
var __propIsEnum$2s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2s = (obj, key, value) => key in obj ? __defProp$2s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2s.call(b, prop))
      __defNormalProp$2s(a, prop, b[prop]);
  if (__getOwnPropSymbols$2s)
    for (var prop of __getOwnPropSymbols$2s(b)) {
      if (__propIsEnum$2s.call(b, prop))
        __defNormalProp$2s(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1x = (a, b) => __defProps$1x(a, __getOwnPropDescs$1x(b));
var __objRest$2r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2s)
    for (var prop of __getOwnPropSymbols$2s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewTracking$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2r(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1x(__spreadValues$2s({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_tracking", __spreadValues$2s(__spreadValues$2s({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2r = Object.defineProperty;
var __getOwnPropSymbols$2r = Object.getOwnPropertySymbols;
var __hasOwnProp$2r = Object.prototype.hasOwnProperty;
var __propIsEnum$2r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2r = (obj, key, value) => key in obj ? __defProp$2r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2r.call(b, prop))
      __defNormalProp$2r(a, prop, b[prop]);
  if (__getOwnPropSymbols$2r)
    for (var prop of __getOwnPropSymbols$2r(b)) {
      if (__propIsEnum$2r.call(b, prop))
        __defNormalProp$2r(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2r)
    for (var prop of __getOwnPropSymbols$2r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewTracking$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2q(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2r({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewTracking";
  const customData = __spreadValues$2r(__spreadValues$2r({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2q = Object.defineProperty;
var __getOwnPropSymbols$2q = Object.getOwnPropertySymbols;
var __hasOwnProp$2q = Object.prototype.hasOwnProperty;
var __propIsEnum$2q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2q = (obj, key, value) => key in obj ? __defProp$2q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2q.call(b, prop))
      __defNormalProp$2q(a, prop, b[prop]);
  if (__getOwnPropSymbols$2q)
    for (var prop of __getOwnPropSymbols$2q(b)) {
      if (__propIsEnum$2q.call(b, prop))
        __defNormalProp$2q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2q)
    for (var prop of __getOwnPropSymbols$2q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewTracking = (provider, params) => {
  const rest = __objRest$2p(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2q({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("View Tracking", __spreadValues$2q(__spreadValues$2q({}, transformedParams), transformedMeta));
};

const logViewTracking = (params) => {
  triageEventToProviders("viewTracking", params, {
    googleAnalyticsHandler: viewTracking$2,
    facebookPixelHandler: viewTracking$1,
    segmentHandler: viewTracking
  });
};

const events$h = { logViewFulfillmentStep, logViewTracking };

var __defProp$2p = Object.defineProperty;
var __defProps$1w = Object.defineProperties;
var __getOwnPropDescs$1w = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2p = Object.getOwnPropertySymbols;
var __hasOwnProp$2p = Object.prototype.hasOwnProperty;
var __propIsEnum$2p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2p = (obj, key, value) => key in obj ? __defProp$2p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2p.call(b, prop))
      __defNormalProp$2p(a, prop, b[prop]);
  if (__getOwnPropSymbols$2p)
    for (var prop of __getOwnPropSymbols$2p(b)) {
      if (__propIsEnum$2p.call(b, prop))
        __defNormalProp$2p(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1w = (a, b) => __defProps$1w(a, __getOwnPropDescs$1w(b));
var __objRest$2o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2p)
    for (var prop of __getOwnPropSymbols$2p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changeLocation$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2o(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1w(__spreadValues$2p({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "change_location", __spreadValues$2p(__spreadValues$2p({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2o = Object.defineProperty;
var __getOwnPropSymbols$2o = Object.getOwnPropertySymbols;
var __hasOwnProp$2o = Object.prototype.hasOwnProperty;
var __propIsEnum$2o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2o = (obj, key, value) => key in obj ? __defProp$2o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2o.call(b, prop))
      __defNormalProp$2o(a, prop, b[prop]);
  if (__getOwnPropSymbols$2o)
    for (var prop of __getOwnPropSymbols$2o(b)) {
      if (__propIsEnum$2o.call(b, prop))
        __defNormalProp$2o(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2o)
    for (var prop of __getOwnPropSymbols$2o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changeLocation$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2n(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2o({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ChangeLocation";
  const customData = __spreadValues$2o(__spreadValues$2o({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2n = Object.defineProperty;
var __getOwnPropSymbols$2n = Object.getOwnPropertySymbols;
var __hasOwnProp$2n = Object.prototype.hasOwnProperty;
var __propIsEnum$2n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2n = (obj, key, value) => key in obj ? __defProp$2n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2n.call(b, prop))
      __defNormalProp$2n(a, prop, b[prop]);
  if (__getOwnPropSymbols$2n)
    for (var prop of __getOwnPropSymbols$2n(b)) {
      if (__propIsEnum$2n.call(b, prop))
        __defNormalProp$2n(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2n)
    for (var prop of __getOwnPropSymbols$2n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changeLocation = (provider, params) => {
  const rest = __objRest$2m(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2n({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Change Location", __spreadValues$2n(__spreadValues$2n({}, transformedParams), transformedMeta));
};

const logChangeLocation = (params = {}) => {
  triageEventToProviders("changeLocation", params, {
    googleAnalyticsHandler: changeLocation$2,
    facebookPixelHandler: changeLocation$1,
    segmentHandler: changeLocation
  });
};

var __defProp$2m = Object.defineProperty;
var __defProps$1v = Object.defineProperties;
var __getOwnPropDescs$1v = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2m = Object.getOwnPropertySymbols;
var __hasOwnProp$2m = Object.prototype.hasOwnProperty;
var __propIsEnum$2m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2m = (obj, key, value) => key in obj ? __defProp$2m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2m.call(b, prop))
      __defNormalProp$2m(a, prop, b[prop]);
  if (__getOwnPropSymbols$2m)
    for (var prop of __getOwnPropSymbols$2m(b)) {
      if (__propIsEnum$2m.call(b, prop))
        __defNormalProp$2m(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1v = (a, b) => __defProps$1v(a, __getOwnPropDescs$1v(b));
var __objRest$2l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2m)
    for (var prop of __getOwnPropSymbols$2m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const findLocation$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2l(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1v(__spreadValues$2m({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "find_location", __spreadValues$2m(__spreadValues$2m({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2l = Object.defineProperty;
var __getOwnPropSymbols$2l = Object.getOwnPropertySymbols;
var __hasOwnProp$2l = Object.prototype.hasOwnProperty;
var __propIsEnum$2l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2l = (obj, key, value) => key in obj ? __defProp$2l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2l.call(b, prop))
      __defNormalProp$2l(a, prop, b[prop]);
  if (__getOwnPropSymbols$2l)
    for (var prop of __getOwnPropSymbols$2l(b)) {
      if (__propIsEnum$2l.call(b, prop))
        __defNormalProp$2l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2l)
    for (var prop of __getOwnPropSymbols$2l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const findLocation$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2k(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2l({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "FindLocation";
  const customData = __spreadValues$2l(__spreadValues$2l({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2k = Object.defineProperty;
var __getOwnPropSymbols$2k = Object.getOwnPropertySymbols;
var __hasOwnProp$2k = Object.prototype.hasOwnProperty;
var __propIsEnum$2k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2k = (obj, key, value) => key in obj ? __defProp$2k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2k.call(b, prop))
      __defNormalProp$2k(a, prop, b[prop]);
  if (__getOwnPropSymbols$2k)
    for (var prop of __getOwnPropSymbols$2k(b)) {
      if (__propIsEnum$2k.call(b, prop))
        __defNormalProp$2k(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2k)
    for (var prop of __getOwnPropSymbols$2k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const findLocation = (provider, params) => {
  const rest = __objRest$2j(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2k({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Find Location", __spreadValues$2k(__spreadValues$2k({}, transformedParams), transformedMeta));
};

const logFindLocation = (params = {}) => {
  triageEventToProviders("findLocation", params, {
    googleAnalyticsHandler: findLocation$2,
    facebookPixelHandler: findLocation$1,
    segmentHandler: findLocation
  });
};

var __defProp$2j = Object.defineProperty;
var __defProps$1u = Object.defineProperties;
var __getOwnPropDescs$1u = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2j = Object.getOwnPropertySymbols;
var __hasOwnProp$2j = Object.prototype.hasOwnProperty;
var __propIsEnum$2j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2j = (obj, key, value) => key in obj ? __defProp$2j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2j.call(b, prop))
      __defNormalProp$2j(a, prop, b[prop]);
  if (__getOwnPropSymbols$2j)
    for (var prop of __getOwnPropSymbols$2j(b)) {
      if (__propIsEnum$2j.call(b, prop))
        __defNormalProp$2j(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1u = (a, b) => __defProps$1u(a, __getOwnPropDescs$1u(b));
var __objRest$2i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2j)
    for (var prop of __getOwnPropSymbols$2j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const outOfCoverage$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2i(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1u(__spreadValues$2j({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "out_of_coverage", __spreadValues$2j(__spreadValues$2j({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2i = Object.defineProperty;
var __getOwnPropSymbols$2i = Object.getOwnPropertySymbols;
var __hasOwnProp$2i = Object.prototype.hasOwnProperty;
var __propIsEnum$2i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2i = (obj, key, value) => key in obj ? __defProp$2i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2i.call(b, prop))
      __defNormalProp$2i(a, prop, b[prop]);
  if (__getOwnPropSymbols$2i)
    for (var prop of __getOwnPropSymbols$2i(b)) {
      if (__propIsEnum$2i.call(b, prop))
        __defNormalProp$2i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2i)
    for (var prop of __getOwnPropSymbols$2i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const outOfCoverage$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2h(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2i({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "OutOfCoverage";
  const customData = __spreadValues$2i(__spreadValues$2i({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2h = Object.defineProperty;
var __getOwnPropSymbols$2h = Object.getOwnPropertySymbols;
var __hasOwnProp$2h = Object.prototype.hasOwnProperty;
var __propIsEnum$2h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2h = (obj, key, value) => key in obj ? __defProp$2h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2h.call(b, prop))
      __defNormalProp$2h(a, prop, b[prop]);
  if (__getOwnPropSymbols$2h)
    for (var prop of __getOwnPropSymbols$2h(b)) {
      if (__propIsEnum$2h.call(b, prop))
        __defNormalProp$2h(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2h)
    for (var prop of __getOwnPropSymbols$2h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const outOfCoverage = (provider, params) => {
  const rest = __objRest$2g(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2h({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Out Of Coverage", __spreadValues$2h(__spreadValues$2h({}, transformedParams), transformedMeta));
};

const logOutOfCoverage = (params = {}) => {
  triageEventToProviders("outOfCoverage", params, {
    googleAnalyticsHandler: outOfCoverage$2,
    facebookPixelHandler: outOfCoverage$1,
    segmentHandler: outOfCoverage
  });
};

var __defProp$2g = Object.defineProperty;
var __defProps$1t = Object.defineProperties;
var __getOwnPropDescs$1t = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2g = Object.getOwnPropertySymbols;
var __hasOwnProp$2g = Object.prototype.hasOwnProperty;
var __propIsEnum$2g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2g = (obj, key, value) => key in obj ? __defProp$2g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2g.call(b, prop))
      __defNormalProp$2g(a, prop, b[prop]);
  if (__getOwnPropSymbols$2g)
    for (var prop of __getOwnPropSymbols$2g(b)) {
      if (__propIsEnum$2g.call(b, prop))
        __defNormalProp$2g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1t = (a, b) => __defProps$1t(a, __getOwnPropDescs$1t(b));
var __objRest$2f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2g)
    for (var prop of __getOwnPropSymbols$2g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setLocation$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2f(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1t(__spreadValues$2g({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "set_location", __spreadValues$2g(__spreadValues$2g({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2f = Object.defineProperty;
var __getOwnPropSymbols$2f = Object.getOwnPropertySymbols;
var __hasOwnProp$2f = Object.prototype.hasOwnProperty;
var __propIsEnum$2f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2f = (obj, key, value) => key in obj ? __defProp$2f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2f.call(b, prop))
      __defNormalProp$2f(a, prop, b[prop]);
  if (__getOwnPropSymbols$2f)
    for (var prop of __getOwnPropSymbols$2f(b)) {
      if (__propIsEnum$2f.call(b, prop))
        __defNormalProp$2f(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2f)
    for (var prop of __getOwnPropSymbols$2f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setLocation$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2e(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2f({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SetLocation";
  const customData = __spreadValues$2f(__spreadValues$2f({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2e = Object.defineProperty;
var __defProps$1s = Object.defineProperties;
var __getOwnPropDescs$1s = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2e = Object.getOwnPropertySymbols;
var __hasOwnProp$2e = Object.prototype.hasOwnProperty;
var __propIsEnum$2e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2e = (obj, key, value) => key in obj ? __defProp$2e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2e.call(b, prop))
      __defNormalProp$2e(a, prop, b[prop]);
  if (__getOwnPropSymbols$2e)
    for (var prop of __getOwnPropSymbols$2e(b)) {
      if (__propIsEnum$2e.call(b, prop))
        __defNormalProp$2e(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1s = (a, b) => __defProps$1s(a, __getOwnPropDescs$1s(b));
var __objRest$2d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2e)
    for (var prop of __getOwnPropSymbols$2e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setLocation = (provider, params) => {
  const _a = params, { lat, lng } = _a, rest = __objRest$2d(_a, ["lat", "lng"]);
  delete rest.userId;
  const location = lat && lng ? `${lat}, ${lng}` : "Not available";
  const enhancedParams = __spreadProps$1s(__spreadValues$2e({}, rest), { location });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Set Location", __spreadValues$2e(__spreadValues$2e({}, transformedParams), transformedMeta));
};

const logSetLocation = (params = {}) => {
  triageEventToProviders("setLocation", params, {
    googleAnalyticsHandler: setLocation$2,
    facebookPixelHandler: setLocation$1,
    segmentHandler: setLocation
  });
};

const events$g = {
  logChangeLocation,
  logFindLocation,
  logOutOfCoverage,
  logSetLocation
};

var __defProp$2d = Object.defineProperty;
var __defProps$1r = Object.defineProperties;
var __getOwnPropDescs$1r = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2d = Object.getOwnPropertySymbols;
var __hasOwnProp$2d = Object.prototype.hasOwnProperty;
var __propIsEnum$2d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2d = (obj, key, value) => key in obj ? __defProp$2d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2d.call(b, prop))
      __defNormalProp$2d(a, prop, b[prop]);
  if (__getOwnPropSymbols$2d)
    for (var prop of __getOwnPropSymbols$2d(b)) {
      if (__propIsEnum$2d.call(b, prop))
        __defNormalProp$2d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1r = (a, b) => __defProps$1r(a, __getOwnPropDescs$1r(b));
var __objRest$2c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2d)
    for (var prop of __getOwnPropSymbols$2d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const requestAssistance$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2c(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1r(__spreadValues$2d({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "request_assistance", __spreadValues$2d(__spreadValues$2d({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2c = Object.defineProperty;
var __getOwnPropSymbols$2c = Object.getOwnPropertySymbols;
var __hasOwnProp$2c = Object.prototype.hasOwnProperty;
var __propIsEnum$2c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2c = (obj, key, value) => key in obj ? __defProp$2c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2c.call(b, prop))
      __defNormalProp$2c(a, prop, b[prop]);
  if (__getOwnPropSymbols$2c)
    for (var prop of __getOwnPropSymbols$2c(b)) {
      if (__propIsEnum$2c.call(b, prop))
        __defNormalProp$2c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2c)
    for (var prop of __getOwnPropSymbols$2c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const requestAssistance$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$2b(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2c({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "Contact";
  const customData = __spreadValues$2c(__spreadValues$2c({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$2b = Object.defineProperty;
var __getOwnPropSymbols$2b = Object.getOwnPropertySymbols;
var __hasOwnProp$2b = Object.prototype.hasOwnProperty;
var __propIsEnum$2b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2b = (obj, key, value) => key in obj ? __defProp$2b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2b.call(b, prop))
      __defNormalProp$2b(a, prop, b[prop]);
  if (__getOwnPropSymbols$2b)
    for (var prop of __getOwnPropSymbols$2b(b)) {
      if (__propIsEnum$2b.call(b, prop))
        __defNormalProp$2b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2b)
    for (var prop of __getOwnPropSymbols$2b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const requestAssistance = (provider, params) => {
  const rest = __objRest$2a(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2b({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Request Assistance", __spreadValues$2b(__spreadValues$2b({}, transformedParams), transformedMeta));
};

const logRequestAssistance = (params) => {
  triageEventToProviders("requestAssistance", params, {
    googleAnalyticsHandler: requestAssistance$2,
    facebookPixelHandler: requestAssistance$1,
    segmentHandler: requestAssistance
  });
};

const events$f = { logRequestAssistance };

var __defProp$2a = Object.defineProperty;
var __defProps$1q = Object.defineProperties;
var __getOwnPropDescs$1q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2a = Object.getOwnPropertySymbols;
var __hasOwnProp$2a = Object.prototype.hasOwnProperty;
var __propIsEnum$2a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2a = (obj, key, value) => key in obj ? __defProp$2a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2a.call(b, prop))
      __defNormalProp$2a(a, prop, b[prop]);
  if (__getOwnPropSymbols$2a)
    for (var prop of __getOwnPropSymbols$2a(b)) {
      if (__propIsEnum$2a.call(b, prop))
        __defNormalProp$2a(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1q = (a, b) => __defProps$1q(a, __getOwnPropDescs$1q(b));
var __objRest$29 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2a)
    for (var prop of __getOwnPropSymbols$2a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const earnPoints$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, currencyName, amount } = _a, rest = __objRest$29(_a, ["callback", "userId", "currencyName", "amount"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1q(__spreadValues$2a({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "earn_virtual_currency", __spreadValues$2a(__spreadValues$2a({
    send_to: trackingId,
    event_callback: callback,
    virtual_currency_name: currencyName,
    value: amount
  }, transformedParams), transformedMeta));
};

var __defProp$29 = Object.defineProperty;
var __getOwnPropSymbols$29 = Object.getOwnPropertySymbols;
var __hasOwnProp$29 = Object.prototype.hasOwnProperty;
var __propIsEnum$29 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$29 = (obj, key, value) => key in obj ? __defProp$29(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$29 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$29.call(b, prop))
      __defNormalProp$29(a, prop, b[prop]);
  if (__getOwnPropSymbols$29)
    for (var prop of __getOwnPropSymbols$29(b)) {
      if (__propIsEnum$29.call(b, prop))
        __defNormalProp$29(a, prop, b[prop]);
    }
  return a;
};
var __objRest$28 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$29.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$29)
    for (var prop of __getOwnPropSymbols$29(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$29.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const earnPoints$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$28(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$29({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "EarnPoints";
  const customData = __spreadValues$29(__spreadValues$29({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$28 = Object.defineProperty;
var __getOwnPropSymbols$28 = Object.getOwnPropertySymbols;
var __hasOwnProp$28 = Object.prototype.hasOwnProperty;
var __propIsEnum$28 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$28 = (obj, key, value) => key in obj ? __defProp$28(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$28 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$28.call(b, prop))
      __defNormalProp$28(a, prop, b[prop]);
  if (__getOwnPropSymbols$28)
    for (var prop of __getOwnPropSymbols$28(b)) {
      if (__propIsEnum$28.call(b, prop))
        __defNormalProp$28(a, prop, b[prop]);
    }
  return a;
};
var __objRest$27 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$28.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$28)
    for (var prop of __getOwnPropSymbols$28(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$28.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const earnPoints = (provider, params) => {
  const rest = __objRest$27(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$28({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Earn Points", __spreadValues$28(__spreadValues$28({}, transformedParams), transformedMeta));
};

const logEarnPoints = (params) => {
  triageEventToProviders("earnPoints", params, {
    googleAnalyticsHandler: earnPoints$2,
    facebookPixelHandler: earnPoints$1,
    segmentHandler: earnPoints
  });
};

var __defProp$27 = Object.defineProperty;
var __defProps$1p = Object.defineProperties;
var __getOwnPropDescs$1p = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$27 = Object.getOwnPropertySymbols;
var __hasOwnProp$27 = Object.prototype.hasOwnProperty;
var __propIsEnum$27 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$27 = (obj, key, value) => key in obj ? __defProp$27(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$27 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$27.call(b, prop))
      __defNormalProp$27(a, prop, b[prop]);
  if (__getOwnPropSymbols$27)
    for (var prop of __getOwnPropSymbols$27(b)) {
      if (__propIsEnum$27.call(b, prop))
        __defNormalProp$27(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1p = (a, b) => __defProps$1p(a, __getOwnPropDescs$1p(b));
var __objRest$26 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$27.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$27)
    for (var prop of __getOwnPropSymbols$27(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$27.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const sharePoints$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$26(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1p(__spreadValues$27({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "share_points", __spreadValues$27(__spreadValues$27({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$26 = Object.defineProperty;
var __getOwnPropSymbols$26 = Object.getOwnPropertySymbols;
var __hasOwnProp$26 = Object.prototype.hasOwnProperty;
var __propIsEnum$26 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$26 = (obj, key, value) => key in obj ? __defProp$26(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$26 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$26.call(b, prop))
      __defNormalProp$26(a, prop, b[prop]);
  if (__getOwnPropSymbols$26)
    for (var prop of __getOwnPropSymbols$26(b)) {
      if (__propIsEnum$26.call(b, prop))
        __defNormalProp$26(a, prop, b[prop]);
    }
  return a;
};
var __objRest$25 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$26.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$26)
    for (var prop of __getOwnPropSymbols$26(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$26.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const sharePoints$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$25(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$26({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SharePoints";
  const customData = __spreadValues$26(__spreadValues$26({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$25 = Object.defineProperty;
var __getOwnPropSymbols$25 = Object.getOwnPropertySymbols;
var __hasOwnProp$25 = Object.prototype.hasOwnProperty;
var __propIsEnum$25 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$25 = (obj, key, value) => key in obj ? __defProp$25(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$25 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$25.call(b, prop))
      __defNormalProp$25(a, prop, b[prop]);
  if (__getOwnPropSymbols$25)
    for (var prop of __getOwnPropSymbols$25(b)) {
      if (__propIsEnum$25.call(b, prop))
        __defNormalProp$25(a, prop, b[prop]);
    }
  return a;
};
var __objRest$24 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$25.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$25)
    for (var prop of __getOwnPropSymbols$25(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$25.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const sharePoints = (provider, params) => {
  const rest = __objRest$24(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$25({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Share Points", __spreadValues$25(__spreadValues$25({}, transformedParams), transformedMeta));
};

const logSharePoints = (params) => {
  triageEventToProviders("sharePoints", params, {
    googleAnalyticsHandler: sharePoints$2,
    facebookPixelHandler: sharePoints$1,
    segmentHandler: sharePoints
  });
};

var __defProp$24 = Object.defineProperty;
var __defProps$1o = Object.defineProperties;
var __getOwnPropDescs$1o = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$24 = Object.getOwnPropertySymbols;
var __hasOwnProp$24 = Object.prototype.hasOwnProperty;
var __propIsEnum$24 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$24 = (obj, key, value) => key in obj ? __defProp$24(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$24 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$24.call(b, prop))
      __defNormalProp$24(a, prop, b[prop]);
  if (__getOwnPropSymbols$24)
    for (var prop of __getOwnPropSymbols$24(b)) {
      if (__propIsEnum$24.call(b, prop))
        __defNormalProp$24(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1o = (a, b) => __defProps$1o(a, __getOwnPropDescs$1o(b));
var __objRest$23 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$24.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$24)
    for (var prop of __getOwnPropSymbols$24(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$24.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const spendPoints$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, currencyName, amount } = _a, rest = __objRest$23(_a, ["callback", "userId", "currencyName", "amount"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1o(__spreadValues$24({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "spend_virtual_currency", __spreadValues$24(__spreadValues$24({
    send_to: trackingId,
    event_callback: callback,
    virtual_currency_name: currencyName,
    value: amount
  }, transformedParams), transformedMeta));
};

var __defProp$23 = Object.defineProperty;
var __getOwnPropSymbols$23 = Object.getOwnPropertySymbols;
var __hasOwnProp$23 = Object.prototype.hasOwnProperty;
var __propIsEnum$23 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$23 = (obj, key, value) => key in obj ? __defProp$23(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$23 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$23.call(b, prop))
      __defNormalProp$23(a, prop, b[prop]);
  if (__getOwnPropSymbols$23)
    for (var prop of __getOwnPropSymbols$23(b)) {
      if (__propIsEnum$23.call(b, prop))
        __defNormalProp$23(a, prop, b[prop]);
    }
  return a;
};
var __objRest$22 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$23.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$23)
    for (var prop of __getOwnPropSymbols$23(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$23.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const spendPoints$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$22(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$23({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SpendPoints";
  const customData = __spreadValues$23(__spreadValues$23({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$22 = Object.defineProperty;
var __getOwnPropSymbols$22 = Object.getOwnPropertySymbols;
var __hasOwnProp$22 = Object.prototype.hasOwnProperty;
var __propIsEnum$22 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$22 = (obj, key, value) => key in obj ? __defProp$22(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$22 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$22.call(b, prop))
      __defNormalProp$22(a, prop, b[prop]);
  if (__getOwnPropSymbols$22)
    for (var prop of __getOwnPropSymbols$22(b)) {
      if (__propIsEnum$22.call(b, prop))
        __defNormalProp$22(a, prop, b[prop]);
    }
  return a;
};
var __objRest$21 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$22.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$22)
    for (var prop of __getOwnPropSymbols$22(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$22.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const spendPoints = (provider, params) => {
  const rest = __objRest$21(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$22({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Spend Points", __spreadValues$22(__spreadValues$22({}, transformedParams), transformedMeta));
};

const logSpendPoints = (params) => {
  triageEventToProviders("spendPoints", params, {
    googleAnalyticsHandler: spendPoints$2,
    facebookPixelHandler: spendPoints$1,
    segmentHandler: spendPoints
  });
};

var __defProp$21 = Object.defineProperty;
var __defProps$1n = Object.defineProperties;
var __getOwnPropDescs$1n = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$21 = Object.getOwnPropertySymbols;
var __hasOwnProp$21 = Object.prototype.hasOwnProperty;
var __propIsEnum$21 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$21 = (obj, key, value) => key in obj ? __defProp$21(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$21 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$21.call(b, prop))
      __defNormalProp$21(a, prop, b[prop]);
  if (__getOwnPropSymbols$21)
    for (var prop of __getOwnPropSymbols$21(b)) {
      if (__propIsEnum$21.call(b, prop))
        __defNormalProp$21(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1n = (a, b) => __defProps$1n(a, __getOwnPropDescs$1n(b));
var __objRest$20 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$21.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$21)
    for (var prop of __getOwnPropSymbols$21(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$21.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewLoyaltyLevel$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$20(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1n(__spreadValues$21({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_loyalty_level", __spreadValues$21(__spreadValues$21({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$20 = Object.defineProperty;
var __getOwnPropSymbols$20 = Object.getOwnPropertySymbols;
var __hasOwnProp$20 = Object.prototype.hasOwnProperty;
var __propIsEnum$20 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$20 = (obj, key, value) => key in obj ? __defProp$20(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$20 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$20.call(b, prop))
      __defNormalProp$20(a, prop, b[prop]);
  if (__getOwnPropSymbols$20)
    for (var prop of __getOwnPropSymbols$20(b)) {
      if (__propIsEnum$20.call(b, prop))
        __defNormalProp$20(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$20.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$20)
    for (var prop of __getOwnPropSymbols$20(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$20.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewLoyaltyLevel$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$1$(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$20({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewLoyaltyLevel";
  const customData = __spreadValues$20(__spreadValues$20({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1$ = Object.defineProperty;
var __getOwnPropSymbols$1$ = Object.getOwnPropertySymbols;
var __hasOwnProp$1$ = Object.prototype.hasOwnProperty;
var __propIsEnum$1$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1$ = (obj, key, value) => key in obj ? __defProp$1$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1$.call(b, prop))
      __defNormalProp$1$(a, prop, b[prop]);
  if (__getOwnPropSymbols$1$)
    for (var prop of __getOwnPropSymbols$1$(b)) {
      if (__propIsEnum$1$.call(b, prop))
        __defNormalProp$1$(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1$)
    for (var prop of __getOwnPropSymbols$1$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewLoyaltyLevel = (provider, params) => {
  const rest = __objRest$1_(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1$({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("View Loyalty Level", __spreadValues$1$(__spreadValues$1$({}, transformedParams), transformedMeta));
};

const logViewLoyaltyLevel = (params) => {
  triageEventToProviders("viewLoyaltyLevel", params, {
    googleAnalyticsHandler: viewLoyaltyLevel$2,
    facebookPixelHandler: viewLoyaltyLevel$1,
    segmentHandler: viewLoyaltyLevel
  });
};

const events$e = {
  logEarnPoints,
  logSharePoints,
  logSpendPoints,
  logViewLoyaltyLevel
};

var __defProp$1_ = Object.defineProperty;
var __defProps$1m = Object.defineProperties;
var __getOwnPropDescs$1m = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1_ = Object.getOwnPropertySymbols;
var __hasOwnProp$1_ = Object.prototype.hasOwnProperty;
var __propIsEnum$1_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1_ = (obj, key, value) => key in obj ? __defProp$1_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1_.call(b, prop))
      __defNormalProp$1_(a, prop, b[prop]);
  if (__getOwnPropSymbols$1_)
    for (var prop of __getOwnPropSymbols$1_(b)) {
      if (__propIsEnum$1_.call(b, prop))
        __defNormalProp$1_(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1m = (a, b) => __defProps$1m(a, __getOwnPropDescs$1m(b));
var __objRest$1Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1_)
    for (var prop of __getOwnPropSymbols$1_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const cancelOrder$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$1Z(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1m(__spreadValues$1_({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "cancel_order", __spreadValues$1_(__spreadValues$1_({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1Z = Object.defineProperty;
var __getOwnPropSymbols$1Z = Object.getOwnPropertySymbols;
var __hasOwnProp$1Z = Object.prototype.hasOwnProperty;
var __propIsEnum$1Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1Z = (obj, key, value) => key in obj ? __defProp$1Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1Z.call(b, prop))
      __defNormalProp$1Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$1Z)
    for (var prop of __getOwnPropSymbols$1Z(b)) {
      if (__propIsEnum$1Z.call(b, prop))
        __defNormalProp$1Z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1Z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1Z)
    for (var prop of __getOwnPropSymbols$1Z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1Z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const cancelOrder$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$1Y(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1Z({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "CancelOrder";
  const customData = __spreadValues$1Z(__spreadValues$1Z({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1Y = Object.defineProperty;
var __defProps$1l = Object.defineProperties;
var __getOwnPropDescs$1l = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1Y = Object.getOwnPropertySymbols;
var __hasOwnProp$1Y = Object.prototype.hasOwnProperty;
var __propIsEnum$1Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1Y = (obj, key, value) => key in obj ? __defProp$1Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1Y.call(b, prop))
      __defNormalProp$1Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$1Y)
    for (var prop of __getOwnPropSymbols$1Y(b)) {
      if (__propIsEnum$1Y.call(b, prop))
        __defNormalProp$1Y(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1l = (a, b) => __defProps$1l(a, __getOwnPropDescs$1l(b));
var __objRest$1X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1Y)
    for (var prop of __getOwnPropSymbols$1Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const cancelOrder = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, orderTotal, products } = _a, rest = __objRest$1X(_a, ["currency", "orderTotal", "products"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1l(__spreadValues$1Y({}, rest), {
    revenue: orderTotal,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Order Cancelled", __spreadValues$1Y(__spreadValues$1Y({
    products: mapProductsToSegmentProducts(products)
  }, transformedParams), transformedMeta));
};

const logCancelOrder = (params) => {
  triageEventToProviders("cancelOrder", params, {
    googleAnalyticsHandler: cancelOrder$2,
    facebookPixelHandler: cancelOrder$1,
    segmentHandler: cancelOrder
  });
};

var __defProp$1X = Object.defineProperty;
var __defProps$1k = Object.defineProperties;
var __getOwnPropDescs$1k = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1X = Object.getOwnPropertySymbols;
var __hasOwnProp$1X = Object.prototype.hasOwnProperty;
var __propIsEnum$1X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1X = (obj, key, value) => key in obj ? __defProp$1X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1X.call(b, prop))
      __defNormalProp$1X(a, prop, b[prop]);
  if (__getOwnPropSymbols$1X)
    for (var prop of __getOwnPropSymbols$1X(b)) {
      if (__propIsEnum$1X.call(b, prop))
        __defNormalProp$1X(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1k = (a, b) => __defProps$1k(a, __getOwnPropDescs$1k(b));
var __objRest$1W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1X)
    for (var prop of __getOwnPropSymbols$1X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const rateOrder$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$1W(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1k(__spreadValues$1X({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "rate_order", __spreadValues$1X(__spreadValues$1X({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1W = Object.defineProperty;
var __defProps$1j = Object.defineProperties;
var __getOwnPropDescs$1j = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1W = Object.getOwnPropertySymbols;
var __hasOwnProp$1W = Object.prototype.hasOwnProperty;
var __propIsEnum$1W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1W = (obj, key, value) => key in obj ? __defProp$1W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1W.call(b, prop))
      __defNormalProp$1W(a, prop, b[prop]);
  if (__getOwnPropSymbols$1W)
    for (var prop of __getOwnPropSymbols$1W(b)) {
      if (__propIsEnum$1W.call(b, prop))
        __defNormalProp$1W(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1j = (a, b) => __defProps$1j(a, __getOwnPropDescs$1j(b));
var __objRest$1V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1W)
    for (var prop of __getOwnPropSymbols$1W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const rateOrder$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { maxScore, score } = _a, rest = __objRest$1V(_a, ["maxScore", "score"]);
  delete rest.userId;
  const enhancedParams = __spreadProps$1j(__spreadValues$1W({}, rest), { maxScore, score });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "RateOrder";
  const customData = __spreadValues$1W(__spreadValues$1W({
    max_rating_value: maxScore,
    value: score
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1V = Object.defineProperty;
var __getOwnPropSymbols$1V = Object.getOwnPropertySymbols;
var __hasOwnProp$1V = Object.prototype.hasOwnProperty;
var __propIsEnum$1V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1V = (obj, key, value) => key in obj ? __defProp$1V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1V.call(b, prop))
      __defNormalProp$1V(a, prop, b[prop]);
  if (__getOwnPropSymbols$1V)
    for (var prop of __getOwnPropSymbols$1V(b)) {
      if (__propIsEnum$1V.call(b, prop))
        __defNormalProp$1V(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1V)
    for (var prop of __getOwnPropSymbols$1V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const rateOrder = (provider, params) => {
  const rest = __objRest$1U(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1V({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Rate Order", __spreadValues$1V(__spreadValues$1V({}, transformedParams), transformedMeta));
};

const logRateOrder = (params) => {
  triageEventToProviders("rateOrder", params, {
    googleAnalyticsHandler: rateOrder$2,
    facebookPixelHandler: rateOrder$1,
    segmentHandler: rateOrder
  });
};

var __defProp$1U = Object.defineProperty;
var __defProps$1i = Object.defineProperties;
var __getOwnPropDescs$1i = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1U = Object.getOwnPropertySymbols;
var __hasOwnProp$1U = Object.prototype.hasOwnProperty;
var __propIsEnum$1U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1U = (obj, key, value) => key in obj ? __defProp$1U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1U.call(b, prop))
      __defNormalProp$1U(a, prop, b[prop]);
  if (__getOwnPropSymbols$1U)
    for (var prop of __getOwnPropSymbols$1U(b)) {
      if (__propIsEnum$1U.call(b, prop))
        __defNormalProp$1U(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1i = (a, b) => __defProps$1i(a, __getOwnPropDescs$1i(b));
var __objRest$1T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1U)
    for (var prop of __getOwnPropSymbols$1U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const requestRefund$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency, orderId, orderTotal } = _a, rest = __objRest$1T(_a, ["callback", "userId", "currency", "orderId", "orderTotal"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1i(__spreadValues$1U({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "refund", __spreadValues$1U(__spreadValues$1U({
    send_to: trackingId,
    event_callback: callback,
    transaction_id: orderId,
    value: orderTotal
  }, transformedParams), transformedMeta));
};

var __defProp$1T = Object.defineProperty;
var __defProps$1h = Object.defineProperties;
var __getOwnPropDescs$1h = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1T = Object.getOwnPropertySymbols;
var __hasOwnProp$1T = Object.prototype.hasOwnProperty;
var __propIsEnum$1T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1T = (obj, key, value) => key in obj ? __defProp$1T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1T.call(b, prop))
      __defNormalProp$1T(a, prop, b[prop]);
  if (__getOwnPropSymbols$1T)
    for (var prop of __getOwnPropSymbols$1T(b)) {
      if (__propIsEnum$1T.call(b, prop))
        __defNormalProp$1T(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1h = (a, b) => __defProps$1h(a, __getOwnPropDescs$1h(b));
var __objRest$1S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1T)
    for (var prop of __getOwnPropSymbols$1T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const requestRefund$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, orderTotal } = _a, rest = __objRest$1S(_a, ["currency", "orderTotal"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1h(__spreadValues$1T({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "RequestRefund";
  const customData = __spreadValues$1T(__spreadValues$1T({
    value: orderTotal
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1S = Object.defineProperty;
var __defProps$1g = Object.defineProperties;
var __getOwnPropDescs$1g = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1S = Object.getOwnPropertySymbols;
var __hasOwnProp$1S = Object.prototype.hasOwnProperty;
var __propIsEnum$1S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1S = (obj, key, value) => key in obj ? __defProp$1S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1S.call(b, prop))
      __defNormalProp$1S(a, prop, b[prop]);
  if (__getOwnPropSymbols$1S)
    for (var prop of __getOwnPropSymbols$1S(b)) {
      if (__propIsEnum$1S.call(b, prop))
        __defNormalProp$1S(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1g = (a, b) => __defProps$1g(a, __getOwnPropDescs$1g(b));
var __objRest$1R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1S)
    for (var prop of __getOwnPropSymbols$1S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const requestRefund = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, orderTotal, products } = _a, rest = __objRest$1R(_a, ["currency", "orderTotal", "products"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1g(__spreadValues$1S({}, rest), {
    revenue: orderTotal,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Order Refunded", __spreadValues$1S(__spreadValues$1S({
    products: mapProductsToSegmentProducts(products)
  }, transformedParams), transformedMeta));
};

const logRequestRefund = (params) => {
  triageEventToProviders("requestRefund", params, {
    googleAnalyticsHandler: requestRefund$2,
    facebookPixelHandler: requestRefund$1,
    segmentHandler: requestRefund
  });
};

const events$d = { logCancelOrder, logRateOrder, logRequestRefund };

var __defProp$1R = Object.defineProperty;
var __defProps$1f = Object.defineProperties;
var __getOwnPropDescs$1f = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1R = Object.getOwnPropertySymbols;
var __hasOwnProp$1R = Object.prototype.hasOwnProperty;
var __propIsEnum$1R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1R = (obj, key, value) => key in obj ? __defProp$1R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1R.call(b, prop))
      __defNormalProp$1R(a, prop, b[prop]);
  if (__getOwnPropSymbols$1R)
    for (var prop of __getOwnPropSymbols$1R(b)) {
      if (__propIsEnum$1R.call(b, prop))
        __defNormalProp$1R(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1f = (a, b) => __defProps$1f(a, __getOwnPropDescs$1f(b));
var __objRest$1Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1R)
    for (var prop of __getOwnPropSymbols$1R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const generateLead$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$1Q(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1f(__spreadValues$1R({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "generate_lead", __spreadValues$1R(__spreadValues$1R({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1Q = Object.defineProperty;
var __getOwnPropSymbols$1Q = Object.getOwnPropertySymbols;
var __hasOwnProp$1Q = Object.prototype.hasOwnProperty;
var __propIsEnum$1Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1Q = (obj, key, value) => key in obj ? __defProp$1Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1Q.call(b, prop))
      __defNormalProp$1Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$1Q)
    for (var prop of __getOwnPropSymbols$1Q(b)) {
      if (__propIsEnum$1Q.call(b, prop))
        __defNormalProp$1Q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1Q)
    for (var prop of __getOwnPropSymbols$1Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const generateLead$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$1P(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1Q({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "Lead";
  const customData = __spreadValues$1Q(__spreadValues$1Q({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1P = Object.defineProperty;
var __getOwnPropSymbols$1P = Object.getOwnPropertySymbols;
var __hasOwnProp$1P = Object.prototype.hasOwnProperty;
var __propIsEnum$1P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1P = (obj, key, value) => key in obj ? __defProp$1P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1P.call(b, prop))
      __defNormalProp$1P(a, prop, b[prop]);
  if (__getOwnPropSymbols$1P)
    for (var prop of __getOwnPropSymbols$1P(b)) {
      if (__propIsEnum$1P.call(b, prop))
        __defNormalProp$1P(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1P)
    for (var prop of __getOwnPropSymbols$1P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const generateLead = (provider, params) => {
  const rest = __objRest$1O(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1P({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Generate Lead", __spreadValues$1P(__spreadValues$1P({}, transformedParams), transformedMeta));
};

const logGenerateLead = (params = {}) => {
  triageEventToProviders("generateLead", params, {
    googleAnalyticsHandler: generateLead$2,
    facebookPixelHandler: generateLead$1,
    segmentHandler: generateLead
  });
};

var __defProp$1O = Object.defineProperty;
var __getOwnPropSymbols$1O = Object.getOwnPropertySymbols;
var __hasOwnProp$1O = Object.prototype.hasOwnProperty;
var __propIsEnum$1O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1O = (obj, key, value) => key in obj ? __defProp$1O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1O.call(b, prop))
      __defNormalProp$1O(a, prop, b[prop]);
  if (__getOwnPropSymbols$1O)
    for (var prop of __getOwnPropSymbols$1O(b)) {
      if (__propIsEnum$1O.call(b, prop))
        __defNormalProp$1O(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1O)
    for (var prop of __getOwnPropSymbols$1O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const pageView$2 = (provider, params = {}) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$1N(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1O({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "PageView";
  const customData = __spreadValues$1O(__spreadValues$1O({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1N = Object.defineProperty;
var __defProps$1e = Object.defineProperties;
var __getOwnPropDescs$1e = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1N = Object.getOwnPropertySymbols;
var __hasOwnProp$1N = Object.prototype.hasOwnProperty;
var __propIsEnum$1N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1N = (obj, key, value) => key in obj ? __defProp$1N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1N.call(b, prop))
      __defNormalProp$1N(a, prop, b[prop]);
  if (__getOwnPropSymbols$1N)
    for (var prop of __getOwnPropSymbols$1N(b)) {
      if (__propIsEnum$1N.call(b, prop))
        __defNormalProp$1N(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1e = (a, b) => __defProps$1e(a, __getOwnPropDescs$1e(b));
var __objRest$1M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1N)
    for (var prop of __getOwnPropSymbols$1N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const pageView$1 = (provider, params = {}) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { pathname, name, callback, userId } = _a, rest = __objRest$1M(_a, ["pathname", "name", "callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1e(__spreadValues$1N({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "page_view", __spreadValues$1N(__spreadValues$1N({
    page_title: name,
    page_path: pathname,
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1M = Object.defineProperty;
var __getOwnPropSymbols$1M = Object.getOwnPropertySymbols;
var __hasOwnProp$1M = Object.prototype.hasOwnProperty;
var __propIsEnum$1M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1M = (obj, key, value) => key in obj ? __defProp$1M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1M.call(b, prop))
      __defNormalProp$1M(a, prop, b[prop]);
  if (__getOwnPropSymbols$1M)
    for (var prop of __getOwnPropSymbols$1M(b)) {
      if (__propIsEnum$1M.call(b, prop))
        __defNormalProp$1M(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1M)
    for (var prop of __getOwnPropSymbols$1M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const pageView = (provider, params) => {
  const _a = params, { name } = _a, rest = __objRest$1L(_a, ["name"]);
  const transformedParams = eventParamsToSnakeCase(rest);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.page(name, __spreadValues$1M(__spreadValues$1M({}, transformedParams), transformedMeta));
};

const logPageView = (params) => {
  triageEventToProviders("pageView", params, {
    googleAnalyticsHandler: pageView$1,
    facebookPixelHandler: pageView$2,
    segmentHandler: pageView
  });
};

var __defProp$1L = Object.defineProperty;
var __defProps$1d = Object.defineProperties;
var __getOwnPropDescs$1d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1L = Object.getOwnPropertySymbols;
var __hasOwnProp$1L = Object.prototype.hasOwnProperty;
var __propIsEnum$1L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1L = (obj, key, value) => key in obj ? __defProp$1L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1L.call(b, prop))
      __defNormalProp$1L(a, prop, b[prop]);
  if (__getOwnPropSymbols$1L)
    for (var prop of __getOwnPropSymbols$1L(b)) {
      if (__propIsEnum$1L.call(b, prop))
        __defNormalProp$1L(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1d = (a, b) => __defProps$1d(a, __getOwnPropDescs$1d(b));
var __objRest$1K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1L)
    for (var prop of __getOwnPropSymbols$1L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchPageContent$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, query } = _a, rest = __objRest$1K(_a, ["callback", "userId", "query"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1d(__spreadValues$1L({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "search", __spreadValues$1L(__spreadValues$1L({
    send_to: trackingId,
    event_callback: callback,
    search_term: query
  }, transformedParams), transformedMeta));
};

var __defProp$1K = Object.defineProperty;
var __getOwnPropSymbols$1K = Object.getOwnPropertySymbols;
var __hasOwnProp$1K = Object.prototype.hasOwnProperty;
var __propIsEnum$1K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1K = (obj, key, value) => key in obj ? __defProp$1K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1K.call(b, prop))
      __defNormalProp$1K(a, prop, b[prop]);
  if (__getOwnPropSymbols$1K)
    for (var prop of __getOwnPropSymbols$1K(b)) {
      if (__propIsEnum$1K.call(b, prop))
        __defNormalProp$1K(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1K)
    for (var prop of __getOwnPropSymbols$1K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchPageContent$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { query } = _a, rest = __objRest$1J(_a, ["query"]);
  delete rest.userId;
  const enhancedParams = __spreadValues$1K({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "Search";
  const customData = __spreadValues$1K(__spreadValues$1K({
    search_string: query
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1J = Object.defineProperty;
var __getOwnPropSymbols$1J = Object.getOwnPropertySymbols;
var __hasOwnProp$1J = Object.prototype.hasOwnProperty;
var __propIsEnum$1J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1J = (obj, key, value) => key in obj ? __defProp$1J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1J.call(b, prop))
      __defNormalProp$1J(a, prop, b[prop]);
  if (__getOwnPropSymbols$1J)
    for (var prop of __getOwnPropSymbols$1J(b)) {
      if (__propIsEnum$1J.call(b, prop))
        __defNormalProp$1J(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1J)
    for (var prop of __getOwnPropSymbols$1J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchPageContent = (provider, params) => {
  const rest = __objRest$1I(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1J({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Search Page Content", __spreadValues$1J(__spreadValues$1J({}, transformedParams), transformedMeta));
};

const logSearchPageContent = (params) => {
  triageEventToProviders("searchPageContent", params, {
    googleAnalyticsHandler: searchPageContent$2,
    facebookPixelHandler: searchPageContent$1,
    segmentHandler: searchPageContent
  });
};

const events$c = { logGenerateLead, logPageView, logSearchPageContent };

var __defProp$1I = Object.defineProperty;
var __defProps$1c = Object.defineProperties;
var __getOwnPropDescs$1c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1I = Object.getOwnPropertySymbols;
var __hasOwnProp$1I = Object.prototype.hasOwnProperty;
var __propIsEnum$1I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1I = (obj, key, value) => key in obj ? __defProp$1I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1I.call(b, prop))
      __defNormalProp$1I(a, prop, b[prop]);
  if (__getOwnPropSymbols$1I)
    for (var prop of __getOwnPropSymbols$1I(b)) {
      if (__propIsEnum$1I.call(b, prop))
        __defNormalProp$1I(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1c = (a, b) => __defProps$1c(a, __getOwnPropDescs$1c(b));
var __objRest$1H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1I)
    for (var prop of __getOwnPropSymbols$1I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changePaymentType$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency } = _a, rest = __objRest$1H(_a, ["callback", "userId", "currency"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1c(__spreadValues$1I({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "change_payment_type", __spreadValues$1I(__spreadValues$1I({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1H = Object.defineProperty;
var __defProps$1b = Object.defineProperties;
var __getOwnPropDescs$1b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1H = Object.getOwnPropertySymbols;
var __hasOwnProp$1H = Object.prototype.hasOwnProperty;
var __propIsEnum$1H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1H = (obj, key, value) => key in obj ? __defProp$1H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1H.call(b, prop))
      __defNormalProp$1H(a, prop, b[prop]);
  if (__getOwnPropSymbols$1H)
    for (var prop of __getOwnPropSymbols$1H(b)) {
      if (__propIsEnum$1H.call(b, prop))
        __defNormalProp$1H(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1b = (a, b) => __defProps$1b(a, __getOwnPropDescs$1b(b));
var __objRest$1G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1H)
    for (var prop of __getOwnPropSymbols$1H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changePaymentType$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$1G(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1b(__spreadValues$1H({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ChangePaymentType";
  const customData = __spreadValues$1H(__spreadValues$1H({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1G = Object.defineProperty;
var __defProps$1a = Object.defineProperties;
var __getOwnPropDescs$1a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1G = Object.getOwnPropertySymbols;
var __hasOwnProp$1G = Object.prototype.hasOwnProperty;
var __propIsEnum$1G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1G = (obj, key, value) => key in obj ? __defProp$1G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1G.call(b, prop))
      __defNormalProp$1G(a, prop, b[prop]);
  if (__getOwnPropSymbols$1G)
    for (var prop of __getOwnPropSymbols$1G(b)) {
      if (__propIsEnum$1G.call(b, prop))
        __defNormalProp$1G(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1a = (a, b) => __defProps$1a(a, __getOwnPropDescs$1a(b));
var __objRest$1F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1G)
    for (var prop of __getOwnPropSymbols$1G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changePaymentType = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$1F(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$1a(__spreadValues$1G({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Change Payment Type", __spreadValues$1G(__spreadValues$1G({}, transformedParams), transformedMeta));
};

const logChangePaymentType = (params) => {
  triageEventToProviders("changePaymentType", params, {
    googleAnalyticsHandler: changePaymentType$2,
    facebookPixelHandler: changePaymentType$1,
    segmentHandler: changePaymentType
  });
};

var __defProp$1F = Object.defineProperty;
var __defProps$19 = Object.defineProperties;
var __getOwnPropDescs$19 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1F = Object.getOwnPropertySymbols;
var __hasOwnProp$1F = Object.prototype.hasOwnProperty;
var __propIsEnum$1F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1F = (obj, key, value) => key in obj ? __defProp$1F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1F.call(b, prop))
      __defNormalProp$1F(a, prop, b[prop]);
  if (__getOwnPropSymbols$1F)
    for (var prop of __getOwnPropSymbols$1F(b)) {
      if (__propIsEnum$1F.call(b, prop))
        __defNormalProp$1F(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$19 = (a, b) => __defProps$19(a, __getOwnPropDescs$19(b));
var __objRest$1E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1F)
    for (var prop of __getOwnPropSymbols$1F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectPaymentType$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency } = _a, rest = __objRest$1E(_a, ["callback", "userId", "currency"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$19(__spreadValues$1F({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "select_payment_type", __spreadValues$1F(__spreadValues$1F({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1E = Object.defineProperty;
var __defProps$18 = Object.defineProperties;
var __getOwnPropDescs$18 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1E = Object.getOwnPropertySymbols;
var __hasOwnProp$1E = Object.prototype.hasOwnProperty;
var __propIsEnum$1E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1E = (obj, key, value) => key in obj ? __defProp$1E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1E.call(b, prop))
      __defNormalProp$1E(a, prop, b[prop]);
  if (__getOwnPropSymbols$1E)
    for (var prop of __getOwnPropSymbols$1E(b)) {
      if (__propIsEnum$1E.call(b, prop))
        __defNormalProp$1E(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$18 = (a, b) => __defProps$18(a, __getOwnPropDescs$18(b));
var __objRest$1D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1E)
    for (var prop of __getOwnPropSymbols$1E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectPaymentType$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$1D(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$18(__spreadValues$1E({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SelectPaymentType";
  const customData = __spreadValues$1E(__spreadValues$1E({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1D = Object.defineProperty;
var __defProps$17 = Object.defineProperties;
var __getOwnPropDescs$17 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1D = Object.getOwnPropertySymbols;
var __hasOwnProp$1D = Object.prototype.hasOwnProperty;
var __propIsEnum$1D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1D = (obj, key, value) => key in obj ? __defProp$1D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1D.call(b, prop))
      __defNormalProp$1D(a, prop, b[prop]);
  if (__getOwnPropSymbols$1D)
    for (var prop of __getOwnPropSymbols$1D(b)) {
      if (__propIsEnum$1D.call(b, prop))
        __defNormalProp$1D(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$17 = (a, b) => __defProps$17(a, __getOwnPropDescs$17(b));
var __objRest$1C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1D)
    for (var prop of __getOwnPropSymbols$1D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectPaymentType = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$1C(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$17(__spreadValues$1D({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Select Payment Type", __spreadValues$1D(__spreadValues$1D({}, transformedParams), transformedMeta));
};

const logSelectPaymentType = (params) => {
  triageEventToProviders("selectPaymentType", params, {
    googleAnalyticsHandler: selectPaymentType$2,
    facebookPixelHandler: selectPaymentType$1,
    segmentHandler: selectPaymentType
  });
};

var __defProp$1C = Object.defineProperty;
var __defProps$16 = Object.defineProperties;
var __getOwnPropDescs$16 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1C = Object.getOwnPropertySymbols;
var __hasOwnProp$1C = Object.prototype.hasOwnProperty;
var __propIsEnum$1C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1C = (obj, key, value) => key in obj ? __defProp$1C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1C.call(b, prop))
      __defNormalProp$1C(a, prop, b[prop]);
  if (__getOwnPropSymbols$1C)
    for (var prop of __getOwnPropSymbols$1C(b)) {
      if (__propIsEnum$1C.call(b, prop))
        __defNormalProp$1C(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$16 = (a, b) => __defProps$16(a, __getOwnPropDescs$16(b));
var __objRest$1B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1C)
    for (var prop of __getOwnPropSymbols$1C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setPaymentInfo$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency } = _a, rest = __objRest$1B(_a, ["callback", "userId", "currency"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$16(__spreadValues$1C({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "add_payment_info", __spreadValues$1C(__spreadValues$1C({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1B = Object.defineProperty;
var __defProps$15 = Object.defineProperties;
var __getOwnPropDescs$15 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1B = Object.getOwnPropertySymbols;
var __hasOwnProp$1B = Object.prototype.hasOwnProperty;
var __propIsEnum$1B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1B = (obj, key, value) => key in obj ? __defProp$1B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1B.call(b, prop))
      __defNormalProp$1B(a, prop, b[prop]);
  if (__getOwnPropSymbols$1B)
    for (var prop of __getOwnPropSymbols$1B(b)) {
      if (__propIsEnum$1B.call(b, prop))
        __defNormalProp$1B(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$15 = (a, b) => __defProps$15(a, __getOwnPropDescs$15(b));
var __objRest$1A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1B)
    for (var prop of __getOwnPropSymbols$1B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setPaymentInfo$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$1A(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$15(__spreadValues$1B({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "AddPaymentInfo";
  const customData = __spreadValues$1B(__spreadValues$1B({
    success: 1
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1A = Object.defineProperty;
var __defProps$14 = Object.defineProperties;
var __getOwnPropDescs$14 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1A = Object.getOwnPropertySymbols;
var __hasOwnProp$1A = Object.prototype.hasOwnProperty;
var __propIsEnum$1A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1A = (obj, key, value) => key in obj ? __defProp$1A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1A.call(b, prop))
      __defNormalProp$1A(a, prop, b[prop]);
  if (__getOwnPropSymbols$1A)
    for (var prop of __getOwnPropSymbols$1A(b)) {
      if (__propIsEnum$1A.call(b, prop))
        __defNormalProp$1A(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$14 = (a, b) => __defProps$14(a, __getOwnPropDescs$14(b));
var __objRest$1z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1A)
    for (var prop of __getOwnPropSymbols$1A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setPaymentInfo = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency } = _a, rest = __objRest$1z(_a, ["currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$14(__spreadValues$1A({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Set Payment Info", __spreadValues$1A(__spreadValues$1A({}, transformedParams), transformedMeta));
};

const logSetPaymentInfo = (params) => {
  triageEventToProviders("setPaymentInfo", params, {
    googleAnalyticsHandler: setPaymentInfo$2,
    facebookPixelHandler: setPaymentInfo$1,
    segmentHandler: setPaymentInfo
  });
};

const events$b = {
  logChangePaymentType,
  logSelectPaymentType,
  logSetPaymentInfo
};

var __defProp$1z = Object.defineProperty;
var __defProps$13 = Object.defineProperties;
var __getOwnPropDescs$13 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1z = Object.getOwnPropertySymbols;
var __hasOwnProp$1z = Object.prototype.hasOwnProperty;
var __propIsEnum$1z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1z = (obj, key, value) => key in obj ? __defProp$1z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1z.call(b, prop))
      __defNormalProp$1z(a, prop, b[prop]);
  if (__getOwnPropSymbols$1z)
    for (var prop of __getOwnPropSymbols$1z(b)) {
      if (__propIsEnum$1z.call(b, prop))
        __defNormalProp$1z(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$13 = (a, b) => __defProps$13(a, __getOwnPropDescs$13(b));
var __objRest$1y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1z)
    for (var prop of __getOwnPropSymbols$1z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const customizeProduct$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, product } = _a, rest = __objRest$1y(_a, ["callback", "userId", "product"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const { productId, name: productName } = product;
  const enhancedParams = __spreadProps$13(__spreadValues$1z({}, rest), {
    userId: selectedUserId,
    productId,
    productName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "customize_product", __spreadValues$1z(__spreadValues$1z({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1y = Object.defineProperty;
var __defProps$12 = Object.defineProperties;
var __getOwnPropDescs$12 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1y = Object.getOwnPropertySymbols;
var __hasOwnProp$1y = Object.prototype.hasOwnProperty;
var __propIsEnum$1y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1y = (obj, key, value) => key in obj ? __defProp$1y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1y.call(b, prop))
      __defNormalProp$1y(a, prop, b[prop]);
  if (__getOwnPropSymbols$1y)
    for (var prop of __getOwnPropSymbols$1y(b)) {
      if (__propIsEnum$1y.call(b, prop))
        __defNormalProp$1y(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$12 = (a, b) => __defProps$12(a, __getOwnPropDescs$12(b));
var __objRest$1x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1y)
    for (var prop of __getOwnPropSymbols$1y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const customizeProduct$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { product } = _a, rest = __objRest$1x(_a, ["product"]);
  delete rest.userId;
  const { productId, name: productName } = product;
  const enhancedParams = __spreadProps$12(__spreadValues$1y({}, rest), {
    productId,
    productName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "CustomizeProduct";
  const customData = __spreadValues$1y(__spreadValues$1y({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1x = Object.defineProperty;
var __defProps$11 = Object.defineProperties;
var __getOwnPropDescs$11 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1x = Object.getOwnPropertySymbols;
var __hasOwnProp$1x = Object.prototype.hasOwnProperty;
var __propIsEnum$1x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1x = (obj, key, value) => key in obj ? __defProp$1x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1x.call(b, prop))
      __defNormalProp$1x(a, prop, b[prop]);
  if (__getOwnPropSymbols$1x)
    for (var prop of __getOwnPropSymbols$1x(b)) {
      if (__propIsEnum$1x.call(b, prop))
        __defNormalProp$1x(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$11 = (a, b) => __defProps$11(a, __getOwnPropDescs$11(b));
var __objRest$1w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1x)
    for (var prop of __getOwnPropSymbols$1x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const customizeProduct = (provider, params) => {
  const _a = params, { product } = _a, rest = __objRest$1w(_a, ["product"]);
  delete rest.userId;
  const { productId, name: productName } = product;
  const enhancedParams = __spreadProps$11(__spreadValues$1x({}, rest), {
    productId,
    productName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Customize Product", __spreadValues$1x(__spreadValues$1x({}, transformedParams), transformedMeta));
};

const logCustomizeProduct = (params) => {
  triageEventToProviders("customizeProduct", params, {
    googleAnalyticsHandler: customizeProduct$2,
    facebookPixelHandler: customizeProduct$1,
    segmentHandler: customizeProduct
  });
};

var __defProp$1w = Object.defineProperty;
var __defProps$10 = Object.defineProperties;
var __getOwnPropDescs$10 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1w = Object.getOwnPropertySymbols;
var __hasOwnProp$1w = Object.prototype.hasOwnProperty;
var __propIsEnum$1w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1w = (obj, key, value) => key in obj ? __defProp$1w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1w.call(b, prop))
      __defNormalProp$1w(a, prop, b[prop]);
  if (__getOwnPropSymbols$1w)
    for (var prop of __getOwnPropSymbols$1w(b)) {
      if (__propIsEnum$1w.call(b, prop))
        __defNormalProp$1w(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$10 = (a, b) => __defProps$10(a, __getOwnPropDescs$10(b));
var __objRest$1v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1w)
    for (var prop of __getOwnPropSymbols$1w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const filterProducts$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$1v(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$10(__spreadValues$1w({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "filter_products", __spreadValues$1w(__spreadValues$1w({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1v = Object.defineProperty;
var __getOwnPropSymbols$1v = Object.getOwnPropertySymbols;
var __hasOwnProp$1v = Object.prototype.hasOwnProperty;
var __propIsEnum$1v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1v = (obj, key, value) => key in obj ? __defProp$1v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1v.call(b, prop))
      __defNormalProp$1v(a, prop, b[prop]);
  if (__getOwnPropSymbols$1v)
    for (var prop of __getOwnPropSymbols$1v(b)) {
      if (__propIsEnum$1v.call(b, prop))
        __defNormalProp$1v(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1v)
    for (var prop of __getOwnPropSymbols$1v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const filterProducts$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$1u(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1v({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "FilterProducts";
  const customData = __spreadValues$1v(__spreadValues$1v({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1u = Object.defineProperty;
var __defProps$$ = Object.defineProperties;
var __getOwnPropDescs$$ = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1u = Object.getOwnPropertySymbols;
var __hasOwnProp$1u = Object.prototype.hasOwnProperty;
var __propIsEnum$1u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1u = (obj, key, value) => key in obj ? __defProp$1u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1u.call(b, prop))
      __defNormalProp$1u(a, prop, b[prop]);
  if (__getOwnPropSymbols$1u)
    for (var prop of __getOwnPropSymbols$1u(b)) {
      if (__propIsEnum$1u.call(b, prop))
        __defNormalProp$1u(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$$ = (a, b) => __defProps$$(a, __getOwnPropDescs$$(b));
var __objRest$1t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1u)
    for (var prop of __getOwnPropSymbols$1u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const filterProducts = (provider, params) => {
  const _a = params, { filterBy } = _a, rest = __objRest$1t(_a, ["filterBy"]);
  delete rest.userId;
  const enhancedParams = __spreadProps$$(__spreadValues$1u({}, rest), { filterBy: transformArrayParam(filterBy) });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Filter Products", __spreadValues$1u(__spreadValues$1u({}, transformedParams), transformedMeta));
};

const logFilterProducts = (params) => {
  triageEventToProviders("filterProducts", params, {
    googleAnalyticsHandler: filterProducts$2,
    facebookPixelHandler: filterProducts$1,
    segmentHandler: filterProducts
  });
};

var __defProp$1t = Object.defineProperty;
var __defProps$_ = Object.defineProperties;
var __getOwnPropDescs$_ = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1t = Object.getOwnPropertySymbols;
var __hasOwnProp$1t = Object.prototype.hasOwnProperty;
var __propIsEnum$1t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1t = (obj, key, value) => key in obj ? __defProp$1t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1t.call(b, prop))
      __defNormalProp$1t(a, prop, b[prop]);
  if (__getOwnPropSymbols$1t)
    for (var prop of __getOwnPropSymbols$1t(b)) {
      if (__propIsEnum$1t.call(b, prop))
        __defNormalProp$1t(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$_ = (a, b) => __defProps$_(a, __getOwnPropDescs$_(b));
var __objRest$1s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1t)
    for (var prop of __getOwnPropSymbols$1t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const productImpression$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, product, currency } = _a, rest = __objRest$1s(_a, ["callback", "userId", "product", "currency"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name: productName } = product;
  const enhancedParams = __spreadProps$_(__spreadValues$1t({}, rest), {
    userId: selectedUserId,
    productId,
    productName,
    currency: selectedCurrency
  });
  const total = getProductTotals(product);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "product_impression", __spreadValues$1t(__spreadValues$1t({
    send_to: trackingId,
    event_callback: callback,
    value: total.netPrice
  }, transformedParams), transformedMeta));
};

var __defProp$1s = Object.defineProperty;
var __defProps$Z = Object.defineProperties;
var __getOwnPropDescs$Z = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1s = Object.getOwnPropertySymbols;
var __hasOwnProp$1s = Object.prototype.hasOwnProperty;
var __propIsEnum$1s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1s = (obj, key, value) => key in obj ? __defProp$1s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1s.call(b, prop))
      __defNormalProp$1s(a, prop, b[prop]);
  if (__getOwnPropSymbols$1s)
    for (var prop of __getOwnPropSymbols$1s(b)) {
      if (__propIsEnum$1s.call(b, prop))
        __defNormalProp$1s(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$Z = (a, b) => __defProps$Z(a, __getOwnPropDescs$Z(b));
var __objRest$1r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1s)
    for (var prop of __getOwnPropSymbols$1s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const productImpression$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency } = _a, rest = __objRest$1r(_a, ["product", "currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name: productName } = product;
  const total = getProductTotals(product);
  const enhancedParams = __spreadProps$Z(__spreadValues$1s({}, rest), {
    productId,
    productName,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ProductImpression";
  const customData = __spreadValues$1s(__spreadValues$1s({
    value: total.netPrice
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1r = Object.defineProperty;
var __defProps$Y = Object.defineProperties;
var __getOwnPropDescs$Y = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1r = Object.getOwnPropertySymbols;
var __hasOwnProp$1r = Object.prototype.hasOwnProperty;
var __propIsEnum$1r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1r = (obj, key, value) => key in obj ? __defProp$1r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1r.call(b, prop))
      __defNormalProp$1r(a, prop, b[prop]);
  if (__getOwnPropSymbols$1r)
    for (var prop of __getOwnPropSymbols$1r(b)) {
      if (__propIsEnum$1r.call(b, prop))
        __defNormalProp$1r(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$Y = (a, b) => __defProps$Y(a, __getOwnPropDescs$Y(b));
var __objRest$1q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1r)
    for (var prop of __getOwnPropSymbols$1r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const productImpression = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency } = _a, rest = __objRest$1q(_a, ["product", "currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name } = product;
  const enhancedParams = __spreadProps$Y(__spreadValues$1r({}, rest), {
    productId,
    name,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const totals = getProductTotals(product);
  analytics.track("Product Viewed", __spreadValues$1r(__spreadValues$1r({
    price: totals.netPrice
  }, transformedParams), transformedMeta));
};

const logProductImpression = (params) => {
  triageEventToProviders("productImpression", params, {
    googleAnalyticsHandler: productImpression$2,
    facebookPixelHandler: productImpression$1,
    segmentHandler: productImpression
  });
};

var __defProp$1q = Object.defineProperty;
var __defProps$X = Object.defineProperties;
var __getOwnPropDescs$X = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1q = Object.getOwnPropertySymbols;
var __hasOwnProp$1q = Object.prototype.hasOwnProperty;
var __propIsEnum$1q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1q = (obj, key, value) => key in obj ? __defProp$1q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1q.call(b, prop))
      __defNormalProp$1q(a, prop, b[prop]);
  if (__getOwnPropSymbols$1q)
    for (var prop of __getOwnPropSymbols$1q(b)) {
      if (__propIsEnum$1q.call(b, prop))
        __defNormalProp$1q(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$X = (a, b) => __defProps$X(a, __getOwnPropDescs$X(b));
var __objRest$1p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1q)
    for (var prop of __getOwnPropSymbols$1q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchProductSuccess$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$1p(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$X(__spreadValues$1q({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "search_product_success", __spreadValues$1q(__spreadValues$1q({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1p = Object.defineProperty;
var __getOwnPropSymbols$1p = Object.getOwnPropertySymbols;
var __hasOwnProp$1p = Object.prototype.hasOwnProperty;
var __propIsEnum$1p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1p = (obj, key, value) => key in obj ? __defProp$1p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1p.call(b, prop))
      __defNormalProp$1p(a, prop, b[prop]);
  if (__getOwnPropSymbols$1p)
    for (var prop of __getOwnPropSymbols$1p(b)) {
      if (__propIsEnum$1p.call(b, prop))
        __defNormalProp$1p(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1p)
    for (var prop of __getOwnPropSymbols$1p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchProductSuccess$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { query } = _a, rest = __objRest$1o(_a, ["query"]);
  delete rest.userId;
  const enhancedParams = __spreadValues$1p({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "Search";
  const customData = __spreadValues$1p(__spreadValues$1p({
    search_string: query,
    success: 1
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1o = Object.defineProperty;
var __getOwnPropSymbols$1o = Object.getOwnPropertySymbols;
var __hasOwnProp$1o = Object.prototype.hasOwnProperty;
var __propIsEnum$1o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1o = (obj, key, value) => key in obj ? __defProp$1o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1o.call(b, prop))
      __defNormalProp$1o(a, prop, b[prop]);
  if (__getOwnPropSymbols$1o)
    for (var prop of __getOwnPropSymbols$1o(b)) {
      if (__propIsEnum$1o.call(b, prop))
        __defNormalProp$1o(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1o)
    for (var prop of __getOwnPropSymbols$1o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchProductSuccess = (provider, params) => {
  const rest = __objRest$1n(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1o({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Products Searched", __spreadValues$1o(__spreadValues$1o({}, transformedParams), transformedMeta));
};

const logSearchProductSuccess = (params) => {
  triageEventToProviders("searchProductSuccess", params, {
    googleAnalyticsHandler: searchProductSuccess$2,
    facebookPixelHandler: searchProductSuccess$1,
    segmentHandler: searchProductSuccess
  });
};

var __defProp$1n = Object.defineProperty;
var __defProps$W = Object.defineProperties;
var __getOwnPropDescs$W = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1n = Object.getOwnPropertySymbols;
var __hasOwnProp$1n = Object.prototype.hasOwnProperty;
var __propIsEnum$1n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1n = (obj, key, value) => key in obj ? __defProp$1n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1n.call(b, prop))
      __defNormalProp$1n(a, prop, b[prop]);
  if (__getOwnPropSymbols$1n)
    for (var prop of __getOwnPropSymbols$1n(b)) {
      if (__propIsEnum$1n.call(b, prop))
        __defNormalProp$1n(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$W = (a, b) => __defProps$W(a, __getOwnPropDescs$W(b));
var __objRest$1m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1n)
    for (var prop of __getOwnPropSymbols$1n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchProductAttempt$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, query } = _a, rest = __objRest$1m(_a, ["callback", "userId", "query"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$W(__spreadValues$1n({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "search", __spreadValues$1n(__spreadValues$1n({
    send_to: trackingId,
    event_callback: callback,
    search_term: query
  }, transformedParams), transformedMeta));
};

var __defProp$1m = Object.defineProperty;
var __getOwnPropSymbols$1m = Object.getOwnPropertySymbols;
var __hasOwnProp$1m = Object.prototype.hasOwnProperty;
var __propIsEnum$1m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1m = (obj, key, value) => key in obj ? __defProp$1m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1m.call(b, prop))
      __defNormalProp$1m(a, prop, b[prop]);
  if (__getOwnPropSymbols$1m)
    for (var prop of __getOwnPropSymbols$1m(b)) {
      if (__propIsEnum$1m.call(b, prop))
        __defNormalProp$1m(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1m)
    for (var prop of __getOwnPropSymbols$1m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchProductAttempt$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { query } = _a, rest = __objRest$1l(_a, ["query"]);
  delete rest.userId;
  const enhancedParams = __spreadValues$1m({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "Search";
  const customData = __spreadValues$1m(__spreadValues$1m({
    search_string: query
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1l = Object.defineProperty;
var __getOwnPropSymbols$1l = Object.getOwnPropertySymbols;
var __hasOwnProp$1l = Object.prototype.hasOwnProperty;
var __propIsEnum$1l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1l = (obj, key, value) => key in obj ? __defProp$1l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1l.call(b, prop))
      __defNormalProp$1l(a, prop, b[prop]);
  if (__getOwnPropSymbols$1l)
    for (var prop of __getOwnPropSymbols$1l(b)) {
      if (__propIsEnum$1l.call(b, prop))
        __defNormalProp$1l(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1l)
    for (var prop of __getOwnPropSymbols$1l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchProductAttempt = (provider, params) => {
  const rest = __objRest$1k(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1l({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Search Product Attempt", __spreadValues$1l(__spreadValues$1l({}, transformedParams), transformedMeta));
};

const logSearchProductAttempt = (params) => {
  triageEventToProviders("searchProductAttempt", params, {
    googleAnalyticsHandler: searchProductAttempt$2,
    facebookPixelHandler: searchProductAttempt$1,
    segmentHandler: searchProductAttempt
  });
};

var __defProp$1k = Object.defineProperty;
var __defProps$V = Object.defineProperties;
var __getOwnPropDescs$V = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1k = Object.getOwnPropertySymbols;
var __hasOwnProp$1k = Object.prototype.hasOwnProperty;
var __propIsEnum$1k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1k = (obj, key, value) => key in obj ? __defProp$1k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1k.call(b, prop))
      __defNormalProp$1k(a, prop, b[prop]);
  if (__getOwnPropSymbols$1k)
    for (var prop of __getOwnPropSymbols$1k(b)) {
      if (__propIsEnum$1k.call(b, prop))
        __defNormalProp$1k(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$V = (a, b) => __defProps$V(a, __getOwnPropDescs$V(b));
var __objRest$1j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1k)
    for (var prop of __getOwnPropSymbols$1k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchProductNotFound$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$1j(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$V(__spreadValues$1k({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "search_product_not_found", __spreadValues$1k(__spreadValues$1k({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1j = Object.defineProperty;
var __getOwnPropSymbols$1j = Object.getOwnPropertySymbols;
var __hasOwnProp$1j = Object.prototype.hasOwnProperty;
var __propIsEnum$1j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1j = (obj, key, value) => key in obj ? __defProp$1j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1j.call(b, prop))
      __defNormalProp$1j(a, prop, b[prop]);
  if (__getOwnPropSymbols$1j)
    for (var prop of __getOwnPropSymbols$1j(b)) {
      if (__propIsEnum$1j.call(b, prop))
        __defNormalProp$1j(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1j)
    for (var prop of __getOwnPropSymbols$1j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchProductNotFound$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { query } = _a, rest = __objRest$1i(_a, ["query"]);
  delete rest.userId;
  const enhancedParams = __spreadValues$1j({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "Search";
  const customData = __spreadValues$1j(__spreadValues$1j({
    search_string: query,
    success: 0
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1i = Object.defineProperty;
var __getOwnPropSymbols$1i = Object.getOwnPropertySymbols;
var __hasOwnProp$1i = Object.prototype.hasOwnProperty;
var __propIsEnum$1i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1i = (obj, key, value) => key in obj ? __defProp$1i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1i.call(b, prop))
      __defNormalProp$1i(a, prop, b[prop]);
  if (__getOwnPropSymbols$1i)
    for (var prop of __getOwnPropSymbols$1i(b)) {
      if (__propIsEnum$1i.call(b, prop))
        __defNormalProp$1i(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1i)
    for (var prop of __getOwnPropSymbols$1i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const searchProductNotFound = (provider, params) => {
  const rest = __objRest$1h(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1i({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Search Product Not Found", __spreadValues$1i(__spreadValues$1i({}, transformedParams), transformedMeta));
};

const logSearchProductNotFound = (params) => {
  triageEventToProviders("searchProductNotFound", params, {
    googleAnalyticsHandler: searchProductNotFound$2,
    facebookPixelHandler: searchProductNotFound$1,
    segmentHandler: searchProductNotFound
  });
};

var __defProp$1h = Object.defineProperty;
var __defProps$U = Object.defineProperties;
var __getOwnPropDescs$U = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1h = Object.getOwnPropertySymbols;
var __hasOwnProp$1h = Object.prototype.hasOwnProperty;
var __propIsEnum$1h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1h = (obj, key, value) => key in obj ? __defProp$1h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1h.call(b, prop))
      __defNormalProp$1h(a, prop, b[prop]);
  if (__getOwnPropSymbols$1h)
    for (var prop of __getOwnPropSymbols$1h(b)) {
      if (__propIsEnum$1h.call(b, prop))
        __defNormalProp$1h(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$U = (a, b) => __defProps$U(a, __getOwnPropDescs$U(b));
var __objRest$1g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1h)
    for (var prop of __getOwnPropSymbols$1h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectProduct$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, product, currency } = _a, rest = __objRest$1g(_a, ["callback", "userId", "product", "currency"]);
  if (rest.contentType) {
    delete rest.contentType;
  }
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name: productName } = product;
  const enhancedParams = __spreadProps$U(__spreadValues$1h({}, rest), {
    userId: selectedUserId,
    productId,
    productName,
    currency: selectedCurrency
  });
  const total = getProductTotals(product);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "select_content", __spreadValues$1h(__spreadValues$1h({
    send_to: trackingId,
    event_callback: callback,
    content_type: "product",
    value: total.netPrice
  }, transformedParams), transformedMeta));
};

var __defProp$1g = Object.defineProperty;
var __defProps$T = Object.defineProperties;
var __getOwnPropDescs$T = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1g = Object.getOwnPropertySymbols;
var __hasOwnProp$1g = Object.prototype.hasOwnProperty;
var __propIsEnum$1g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1g = (obj, key, value) => key in obj ? __defProp$1g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1g.call(b, prop))
      __defNormalProp$1g(a, prop, b[prop]);
  if (__getOwnPropSymbols$1g)
    for (var prop of __getOwnPropSymbols$1g(b)) {
      if (__propIsEnum$1g.call(b, prop))
        __defNormalProp$1g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$T = (a, b) => __defProps$T(a, __getOwnPropDescs$T(b));
var __objRest$1f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1g)
    for (var prop of __getOwnPropSymbols$1g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectProduct$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency } = _a, rest = __objRest$1f(_a, ["product", "currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name: productName } = product;
  const total = getProductTotals(product);
  const enhancedParams = __spreadProps$T(__spreadValues$1g({}, rest), {
    productId,
    productName,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SelectProduct";
  const customData = __spreadValues$1g(__spreadValues$1g({
    value: total.netPrice
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1f = Object.defineProperty;
var __defProps$S = Object.defineProperties;
var __getOwnPropDescs$S = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1f = Object.getOwnPropertySymbols;
var __hasOwnProp$1f = Object.prototype.hasOwnProperty;
var __propIsEnum$1f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1f = (obj, key, value) => key in obj ? __defProp$1f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1f.call(b, prop))
      __defNormalProp$1f(a, prop, b[prop]);
  if (__getOwnPropSymbols$1f)
    for (var prop of __getOwnPropSymbols$1f(b)) {
      if (__propIsEnum$1f.call(b, prop))
        __defNormalProp$1f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$S = (a, b) => __defProps$S(a, __getOwnPropDescs$S(b));
var __objRest$1e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1f)
    for (var prop of __getOwnPropSymbols$1f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectProduct = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency } = _a, rest = __objRest$1e(_a, ["product", "currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name } = product;
  const enhancedParams = __spreadProps$S(__spreadValues$1f({}, rest), {
    productId,
    name,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const totals = getProductTotals(product);
  analytics.track("Product Clicked", __spreadValues$1f(__spreadValues$1f({
    price: totals.netPrice
  }, transformedParams), transformedMeta));
};

const logSelectProduct = (params) => {
  triageEventToProviders("selectProduct", params, {
    googleAnalyticsHandler: selectProduct$2,
    facebookPixelHandler: selectProduct$1,
    segmentHandler: selectProduct
  });
};

var __defProp$1e = Object.defineProperty;
var __defProps$R = Object.defineProperties;
var __getOwnPropDescs$R = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1e = Object.getOwnPropertySymbols;
var __hasOwnProp$1e = Object.prototype.hasOwnProperty;
var __propIsEnum$1e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1e = (obj, key, value) => key in obj ? __defProp$1e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1e.call(b, prop))
      __defNormalProp$1e(a, prop, b[prop]);
  if (__getOwnPropSymbols$1e)
    for (var prop of __getOwnPropSymbols$1e(b)) {
      if (__propIsEnum$1e.call(b, prop))
        __defNormalProp$1e(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$R = (a, b) => __defProps$R(a, __getOwnPropDescs$R(b));
var __objRest$1d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1e)
    for (var prop of __getOwnPropSymbols$1e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const sortProducts$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$1d(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$R(__spreadValues$1e({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "sort_products", __spreadValues$1e(__spreadValues$1e({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$1d = Object.defineProperty;
var __getOwnPropSymbols$1d = Object.getOwnPropertySymbols;
var __hasOwnProp$1d = Object.prototype.hasOwnProperty;
var __propIsEnum$1d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1d = (obj, key, value) => key in obj ? __defProp$1d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1d.call(b, prop))
      __defNormalProp$1d(a, prop, b[prop]);
  if (__getOwnPropSymbols$1d)
    for (var prop of __getOwnPropSymbols$1d(b)) {
      if (__propIsEnum$1d.call(b, prop))
        __defNormalProp$1d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1d)
    for (var prop of __getOwnPropSymbols$1d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const sortProducts$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$1c(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1d({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SortProducts";
  const customData = __spreadValues$1d(__spreadValues$1d({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1c = Object.defineProperty;
var __getOwnPropSymbols$1c = Object.getOwnPropertySymbols;
var __hasOwnProp$1c = Object.prototype.hasOwnProperty;
var __propIsEnum$1c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1c = (obj, key, value) => key in obj ? __defProp$1c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1c.call(b, prop))
      __defNormalProp$1c(a, prop, b[prop]);
  if (__getOwnPropSymbols$1c)
    for (var prop of __getOwnPropSymbols$1c(b)) {
      if (__propIsEnum$1c.call(b, prop))
        __defNormalProp$1c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1c)
    for (var prop of __getOwnPropSymbols$1c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const sortProducts = (provider, params) => {
  const rest = __objRest$1b(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1c({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Sort Products", __spreadValues$1c(__spreadValues$1c({}, transformedParams), transformedMeta));
};

const logSortProducts = (params) => {
  triageEventToProviders("sortProducts", params, {
    googleAnalyticsHandler: sortProducts$2,
    facebookPixelHandler: sortProducts$1,
    segmentHandler: sortProducts
  });
};

var __defProp$1b = Object.defineProperty;
var __defProps$Q = Object.defineProperties;
var __getOwnPropDescs$Q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1b = Object.getOwnPropertySymbols;
var __hasOwnProp$1b = Object.prototype.hasOwnProperty;
var __propIsEnum$1b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1b = (obj, key, value) => key in obj ? __defProp$1b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1b.call(b, prop))
      __defNormalProp$1b(a, prop, b[prop]);
  if (__getOwnPropSymbols$1b)
    for (var prop of __getOwnPropSymbols$1b(b)) {
      if (__propIsEnum$1b.call(b, prop))
        __defNormalProp$1b(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$Q = (a, b) => __defProps$Q(a, __getOwnPropDescs$Q(b));
var __objRest$1a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1b)
    for (var prop of __getOwnPropSymbols$1b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewProductDetails$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, product, currency } = _a, rest = __objRest$1a(_a, ["callback", "userId", "product", "currency"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name: productName } = product;
  const enhancedParams = __spreadProps$Q(__spreadValues$1b({}, rest), {
    userId: selectedUserId,
    productId,
    productName,
    currency: selectedCurrency
  });
  const total = getProductTotals(product);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_item", __spreadValues$1b(__spreadValues$1b({
    send_to: trackingId,
    event_callback: callback,
    value: total.netPrice
  }, transformedParams), transformedMeta));
};

var __defProp$1a = Object.defineProperty;
var __defProps$P = Object.defineProperties;
var __getOwnPropDescs$P = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1a = Object.getOwnPropertySymbols;
var __hasOwnProp$1a = Object.prototype.hasOwnProperty;
var __propIsEnum$1a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1a = (obj, key, value) => key in obj ? __defProp$1a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1a.call(b, prop))
      __defNormalProp$1a(a, prop, b[prop]);
  if (__getOwnPropSymbols$1a)
    for (var prop of __getOwnPropSymbols$1a(b)) {
      if (__propIsEnum$1a.call(b, prop))
        __defNormalProp$1a(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$P = (a, b) => __defProps$P(a, __getOwnPropDescs$P(b));
var __objRest$19 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1a)
    for (var prop of __getOwnPropSymbols$1a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewProductDetails$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency } = _a, rest = __objRest$19(_a, ["product", "currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name: productName } = product;
  const total = getProductTotals(product);
  const enhancedParams = __spreadProps$P(__spreadValues$1a({}, rest), {
    productId,
    productName,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewContent";
  const customData = __spreadValues$1a(__spreadValues$1a({
    value: total.netPrice
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$19 = Object.defineProperty;
var __defProps$O = Object.defineProperties;
var __getOwnPropDescs$O = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$19 = Object.getOwnPropertySymbols;
var __hasOwnProp$19 = Object.prototype.hasOwnProperty;
var __propIsEnum$19 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$19 = (obj, key, value) => key in obj ? __defProp$19(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$19 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$19.call(b, prop))
      __defNormalProp$19(a, prop, b[prop]);
  if (__getOwnPropSymbols$19)
    for (var prop of __getOwnPropSymbols$19(b)) {
      if (__propIsEnum$19.call(b, prop))
        __defNormalProp$19(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$O = (a, b) => __defProps$O(a, __getOwnPropDescs$O(b));
var __objRest$18 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$19.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$19)
    for (var prop of __getOwnPropSymbols$19(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$19.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewProductDetails = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency } = _a, rest = __objRest$18(_a, ["product", "currency"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name } = product;
  const enhancedParams = __spreadProps$O(__spreadValues$19({}, rest), {
    productId,
    name,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const totals = getProductTotals(product);
  analytics.track("View Product Details", __spreadValues$19(__spreadValues$19({
    price: totals.netPrice
  }, transformedParams), transformedMeta));
};

const logViewProductDetails = (params) => {
  triageEventToProviders("viewProductDetails", params, {
    googleAnalyticsHandler: viewProductDetails$2,
    facebookPixelHandler: viewProductDetails$1,
    segmentHandler: viewProductDetails
  });
};

const events$a = {
  logCustomizeProduct,
  logFilterProducts,
  logProductImpression,
  logSearchProductSuccess,
  logSearchProductAttempt,
  logSearchProductNotFound,
  logSelectProduct,
  logSortProducts,
  logViewProductDetails
};

var __defProp$18 = Object.defineProperty;
var __defProps$N = Object.defineProperties;
var __getOwnPropDescs$N = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$18 = Object.getOwnPropertySymbols;
var __hasOwnProp$18 = Object.prototype.hasOwnProperty;
var __propIsEnum$18 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$18 = (obj, key, value) => key in obj ? __defProp$18(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$18 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$18.call(b, prop))
      __defNormalProp$18(a, prop, b[prop]);
  if (__getOwnPropSymbols$18)
    for (var prop of __getOwnPropSymbols$18(b)) {
      if (__propIsEnum$18.call(b, prop))
        __defNormalProp$18(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$N = (a, b) => __defProps$N(a, __getOwnPropDescs$N(b));
var __objRest$17 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$18.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$18)
    for (var prop of __getOwnPropSymbols$18(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$18.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const purchaseAttempt$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency, shoppingCart } = _a, rest = __objRest$17(_a, ["callback", "userId", "currency", "shoppingCart"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$N(__spreadValues$18({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { total, totalPoints } = getShoppingCartTotal(shoppingCart);
  gtag("event", "purchase_attempt", __spreadValues$18(__spreadValues$18({
    send_to: trackingId,
    event_callback: callback,
    items: mapProductsToGoogleItems(shoppingCart, selectedCurrency),
    value: total,
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta));
};

var __defProp$17 = Object.defineProperty;
var __defProps$M = Object.defineProperties;
var __getOwnPropDescs$M = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$17 = Object.getOwnPropertySymbols;
var __hasOwnProp$17 = Object.prototype.hasOwnProperty;
var __propIsEnum$17 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$17 = (obj, key, value) => key in obj ? __defProp$17(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$17 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$17.call(b, prop))
      __defNormalProp$17(a, prop, b[prop]);
  if (__getOwnPropSymbols$17)
    for (var prop of __getOwnPropSymbols$17(b)) {
      if (__propIsEnum$17.call(b, prop))
        __defNormalProp$17(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$M = (a, b) => __defProps$M(a, __getOwnPropDescs$M(b));
var __objRest$16 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$17.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$17)
    for (var prop of __getOwnPropSymbols$17(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$17.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const purchaseAttempt$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, shoppingCart } = _a, rest = __objRest$16(_a, ["currency", "shoppingCart"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$M(__spreadValues$17({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const productsIds = getProductIdsFromShoppingCart(shoppingCart);
  const { total, totalPoints } = getShoppingCartTotal(shoppingCart);
  const eventName = "PurchaseAttempt";
  const customData = __spreadValues$17(__spreadValues$17({
    content_ids: productsIds,
    contents: getProductContentFromShoppingCart(shoppingCart),
    num_items: productsIds.length,
    value: total,
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData: __spreadProps$M(__spreadValues$17({}, customData), {
      contents: mapProductsToFacebookItems(shoppingCart)
    })
  });
};

var __defProp$16 = Object.defineProperty;
var __defProps$L = Object.defineProperties;
var __getOwnPropDescs$L = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$16 = Object.getOwnPropertySymbols;
var __hasOwnProp$16 = Object.prototype.hasOwnProperty;
var __propIsEnum$16 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$16 = (obj, key, value) => key in obj ? __defProp$16(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$16 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$16.call(b, prop))
      __defNormalProp$16(a, prop, b[prop]);
  if (__getOwnPropSymbols$16)
    for (var prop of __getOwnPropSymbols$16(b)) {
      if (__propIsEnum$16.call(b, prop))
        __defNormalProp$16(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$L = (a, b) => __defProps$L(a, __getOwnPropDescs$L(b));
var __objRest$15 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$16.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$16)
    for (var prop of __getOwnPropSymbols$16(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$16.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const purchaseAttempt = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, shoppingCart } = _a, rest = __objRest$15(_a, ["currency", "shoppingCart"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$L(__spreadValues$16({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const products = getShoppingCartProducts(shoppingCart);
  const { total, totalTaxes, shippingCost, totalPoints } = getShoppingCartTotal(shoppingCart);
  analytics.track("Purchase Attempt", __spreadValues$16(__spreadValues$16({
    total,
    revenue: total - (totalTaxes != null ? totalTaxes : 0) - (shippingCost != null ? shippingCost : 0),
    shipping: shippingCost != null ? shippingCost : 0,
    tax: totalTaxes != null ? totalTaxes : 0,
    products: mapProductsToSegmentProducts(products),
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta));
};

const logPurchaseAttempt = (params) => {
  triageEventToProviders("purchaseAttempt", params, {
    googleAnalyticsHandler: purchaseAttempt$2,
    facebookPixelHandler: purchaseAttempt$1,
    segmentHandler: purchaseAttempt
  });
};

var __defProp$15 = Object.defineProperty;
var __defProps$K = Object.defineProperties;
var __getOwnPropDescs$K = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$15 = Object.getOwnPropertySymbols;
var __hasOwnProp$15 = Object.prototype.hasOwnProperty;
var __propIsEnum$15 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$15 = (obj, key, value) => key in obj ? __defProp$15(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$15 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$15.call(b, prop))
      __defNormalProp$15(a, prop, b[prop]);
  if (__getOwnPropSymbols$15)
    for (var prop of __getOwnPropSymbols$15(b)) {
      if (__propIsEnum$15.call(b, prop))
        __defNormalProp$15(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$K = (a, b) => __defProps$K(a, __getOwnPropDescs$K(b));
var __objRest$14 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$15.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$15)
    for (var prop of __getOwnPropSymbols$15(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$15.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const purchaseFail$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency, shoppingCart } = _a, rest = __objRest$14(_a, ["callback", "userId", "currency", "shoppingCart"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$K(__spreadValues$15({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { total, totalPoints } = getShoppingCartTotal(shoppingCart);
  gtag("event", "purchase_fail", __spreadValues$15(__spreadValues$15({
    send_to: trackingId,
    event_callback: callback,
    items: mapProductsToGoogleItems(shoppingCart, selectedCurrency),
    value: total,
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta));
};

var __defProp$14 = Object.defineProperty;
var __defProps$J = Object.defineProperties;
var __getOwnPropDescs$J = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$14 = Object.getOwnPropertySymbols;
var __hasOwnProp$14 = Object.prototype.hasOwnProperty;
var __propIsEnum$14 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$14 = (obj, key, value) => key in obj ? __defProp$14(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$14 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$14.call(b, prop))
      __defNormalProp$14(a, prop, b[prop]);
  if (__getOwnPropSymbols$14)
    for (var prop of __getOwnPropSymbols$14(b)) {
      if (__propIsEnum$14.call(b, prop))
        __defNormalProp$14(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$J = (a, b) => __defProps$J(a, __getOwnPropDescs$J(b));
var __objRest$13 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$14.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$14)
    for (var prop of __getOwnPropSymbols$14(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$14.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const purchaseFail$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, shoppingCart } = _a, rest = __objRest$13(_a, ["currency", "shoppingCart"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$J(__spreadValues$14({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const productsIds = getProductIdsFromShoppingCart(shoppingCart);
  const { total, totalPoints } = getShoppingCartTotal(shoppingCart);
  const eventName = "PurchaseFail";
  const customData = __spreadValues$14(__spreadValues$14({
    content_ids: productsIds,
    contents: getProductContentFromShoppingCart(shoppingCart),
    num_items: productsIds.length,
    value: total,
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData: __spreadProps$J(__spreadValues$14({}, customData), {
      contents: mapProductsToFacebookItems(shoppingCart)
    })
  });
};

var __defProp$13 = Object.defineProperty;
var __defProps$I = Object.defineProperties;
var __getOwnPropDescs$I = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$13 = Object.getOwnPropertySymbols;
var __hasOwnProp$13 = Object.prototype.hasOwnProperty;
var __propIsEnum$13 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$13 = (obj, key, value) => key in obj ? __defProp$13(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$13 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$13.call(b, prop))
      __defNormalProp$13(a, prop, b[prop]);
  if (__getOwnPropSymbols$13)
    for (var prop of __getOwnPropSymbols$13(b)) {
      if (__propIsEnum$13.call(b, prop))
        __defNormalProp$13(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$I = (a, b) => __defProps$I(a, __getOwnPropDescs$I(b));
var __objRest$12 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$13.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$13)
    for (var prop of __getOwnPropSymbols$13(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$13.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const purchaseFail = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, shoppingCart } = _a, rest = __objRest$12(_a, ["currency", "shoppingCart"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$I(__spreadValues$13({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const products = getShoppingCartProducts(shoppingCart);
  const { total, totalTaxes, shippingCost, totalPoints } = getShoppingCartTotal(shoppingCart);
  analytics.track("Purchase Fail", __spreadValues$13(__spreadValues$13({
    total,
    revenue: total - (totalTaxes != null ? totalTaxes : 0) - (shippingCost != null ? shippingCost : 0),
    shipping: shippingCost != null ? shippingCost : 0,
    tax: totalTaxes != null ? totalTaxes : 0,
    products: mapProductsToSegmentProducts(products),
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta));
};

const logPurchaseFail = (params) => {
  triageEventToProviders("purchaseFail", params, {
    googleAnalyticsHandler: purchaseFail$2,
    facebookPixelHandler: purchaseFail$1,
    segmentHandler: purchaseFail
  });
};

var __defProp$12 = Object.defineProperty;
var __defProps$H = Object.defineProperties;
var __getOwnPropDescs$H = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$12 = Object.getOwnPropertySymbols;
var __hasOwnProp$12 = Object.prototype.hasOwnProperty;
var __propIsEnum$12 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$12 = (obj, key, value) => key in obj ? __defProp$12(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$12 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$12.call(b, prop))
      __defNormalProp$12(a, prop, b[prop]);
  if (__getOwnPropSymbols$12)
    for (var prop of __getOwnPropSymbols$12(b)) {
      if (__propIsEnum$12.call(b, prop))
        __defNormalProp$12(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$H = (a, b) => __defProps$H(a, __getOwnPropDescs$H(b));
var __objRest$11 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$12.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$12)
    for (var prop of __getOwnPropSymbols$12(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$12.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const purchaseSuccess$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, currency, shoppingCart, orderId } = _a, rest = __objRest$11(_a, ["callback", "userId", "currency", "shoppingCart", "orderId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$H(__spreadValues$12({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const { total, shippingCost, totalTaxes, totalPoints } = getShoppingCartTotal(shoppingCart);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "purchase", __spreadValues$12(__spreadValues$12({
    send_to: trackingId,
    event_callback: callback,
    items: mapProductsToGoogleItems(shoppingCart, selectedCurrency),
    value: total,
    points: totalPoints != null ? totalPoints : 0,
    transaction_id: orderId,
    shipping: shippingCost != null ? shippingCost : 0,
    tax: totalTaxes != null ? totalTaxes : 0
  }, transformedParams), transformedMeta));
};

var __defProp$11 = Object.defineProperty;
var __defProps$G = Object.defineProperties;
var __getOwnPropDescs$G = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$11 = Object.getOwnPropertySymbols;
var __hasOwnProp$11 = Object.prototype.hasOwnProperty;
var __propIsEnum$11 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$11 = (obj, key, value) => key in obj ? __defProp$11(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$11 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$11.call(b, prop))
      __defNormalProp$11(a, prop, b[prop]);
  if (__getOwnPropSymbols$11)
    for (var prop of __getOwnPropSymbols$11(b)) {
      if (__propIsEnum$11.call(b, prop))
        __defNormalProp$11(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$G = (a, b) => __defProps$G(a, __getOwnPropDescs$G(b));
var __objRest$10 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$11.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$11)
    for (var prop of __getOwnPropSymbols$11(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$11.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const purchaseSuccess$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, shoppingCart } = _a, rest = __objRest$10(_a, ["currency", "shoppingCart"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$G(__spreadValues$11({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const productsIds = getProductIdsFromShoppingCart(shoppingCart);
  const { total, totalPoints } = getShoppingCartTotal(shoppingCart);
  const eventName = "Purchase";
  const customData = __spreadValues$11(__spreadValues$11({
    content_ids: productsIds,
    contents: getProductContentFromShoppingCart(shoppingCart),
    num_items: productsIds.length,
    value: total,
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData: __spreadProps$G(__spreadValues$11({}, customData), {
      contents: mapProductsToFacebookItems(shoppingCart)
    })
  });
};

var __defProp$10 = Object.defineProperty;
var __defProps$F = Object.defineProperties;
var __getOwnPropDescs$F = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$10 = Object.getOwnPropertySymbols;
var __hasOwnProp$10 = Object.prototype.hasOwnProperty;
var __propIsEnum$10 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$10 = (obj, key, value) => key in obj ? __defProp$10(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$10 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$10.call(b, prop))
      __defNormalProp$10(a, prop, b[prop]);
  if (__getOwnPropSymbols$10)
    for (var prop of __getOwnPropSymbols$10(b)) {
      if (__propIsEnum$10.call(b, prop))
        __defNormalProp$10(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$F = (a, b) => __defProps$F(a, __getOwnPropDescs$F(b));
var __objRest$$ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$10.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$10)
    for (var prop of __getOwnPropSymbols$10(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$10.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const purchaseSuccess = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { currency, shoppingCart } = _a, rest = __objRest$$(_a, ["currency", "shoppingCart"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$F(__spreadValues$10({}, rest), {
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const products = getShoppingCartProducts(shoppingCart);
  const { total, totalTaxes, shippingCost, totalPoints } = getShoppingCartTotal(shoppingCart);
  analytics.track("Order Completed", __spreadValues$10(__spreadValues$10({
    total,
    revenue: total - (totalTaxes != null ? totalTaxes : 0) - (shippingCost != null ? shippingCost : 0),
    shipping: shippingCost != null ? shippingCost : 0,
    tax: totalTaxes != null ? totalTaxes : 0,
    products: mapProductsToSegmentProducts(products),
    points: totalPoints != null ? totalPoints : 0
  }, transformedParams), transformedMeta));
};

const logPurchaseSuccess = (params) => {
  triageEventToProviders("purchaseSuccess", params, {
    googleAnalyticsHandler: purchaseSuccess$2,
    facebookPixelHandler: purchaseSuccess$1,
    segmentHandler: purchaseSuccess
  });
};

const events$9 = { logPurchaseAttempt, logPurchaseFail, logPurchaseSuccess };

var __defProp$$ = Object.defineProperty;
var __defProps$E = Object.defineProperties;
var __getOwnPropDescs$E = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$$ = Object.getOwnPropertySymbols;
var __hasOwnProp$$ = Object.prototype.hasOwnProperty;
var __propIsEnum$$ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$$ = (obj, key, value) => key in obj ? __defProp$$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$$ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$$.call(b, prop))
      __defNormalProp$$(a, prop, b[prop]);
  if (__getOwnPropSymbols$$)
    for (var prop of __getOwnPropSymbols$$(b)) {
      if (__propIsEnum$$.call(b, prop))
        __defNormalProp$$(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$E = (a, b) => __defProps$E(a, __getOwnPropDescs$E(b));
var __objRest$_ = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$$.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$$)
    for (var prop of __getOwnPropSymbols$$(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$$.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewSettings$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$_(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$E(__spreadValues$$({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_settings", __spreadValues$$(__spreadValues$$({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$_ = Object.defineProperty;
var __getOwnPropSymbols$_ = Object.getOwnPropertySymbols;
var __hasOwnProp$_ = Object.prototype.hasOwnProperty;
var __propIsEnum$_ = Object.prototype.propertyIsEnumerable;
var __defNormalProp$_ = (obj, key, value) => key in obj ? __defProp$_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$_ = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$_.call(b, prop))
      __defNormalProp$_(a, prop, b[prop]);
  if (__getOwnPropSymbols$_)
    for (var prop of __getOwnPropSymbols$_(b)) {
      if (__propIsEnum$_.call(b, prop))
        __defNormalProp$_(a, prop, b[prop]);
    }
  return a;
};
var __objRest$Z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$_.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$_)
    for (var prop of __getOwnPropSymbols$_(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$_.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewSettings$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$Z(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$_({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewSettings";
  const customData = __spreadValues$_(__spreadValues$_({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$Z = Object.defineProperty;
var __getOwnPropSymbols$Z = Object.getOwnPropertySymbols;
var __hasOwnProp$Z = Object.prototype.hasOwnProperty;
var __propIsEnum$Z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Z = (obj, key, value) => key in obj ? __defProp$Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Z.call(b, prop))
      __defNormalProp$Z(a, prop, b[prop]);
  if (__getOwnPropSymbols$Z)
    for (var prop of __getOwnPropSymbols$Z(b)) {
      if (__propIsEnum$Z.call(b, prop))
        __defNormalProp$Z(a, prop, b[prop]);
    }
  return a;
};
var __objRest$Y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$Z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Z)
    for (var prop of __getOwnPropSymbols$Z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$Z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewSettings = (provider, params) => {
  const rest = __objRest$Y(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$Z({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("View Settings", __spreadValues$Z(__spreadValues$Z({}, transformedParams), transformedMeta));
};

const logViewSettings = (params = {}) => {
  triageEventToProviders("viewSettings", params, {
    googleAnalyticsHandler: viewSettings$2,
    facebookPixelHandler: viewSettings$1,
    segmentHandler: viewSettings
  });
};

const events$8 = { logViewSettings };

var __defProp$Y = Object.defineProperty;
var __defProps$D = Object.defineProperties;
var __getOwnPropDescs$D = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$Y = Object.getOwnPropertySymbols;
var __hasOwnProp$Y = Object.prototype.hasOwnProperty;
var __propIsEnum$Y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Y = (obj, key, value) => key in obj ? __defProp$Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Y.call(b, prop))
      __defNormalProp$Y(a, prop, b[prop]);
  if (__getOwnPropSymbols$Y)
    for (var prop of __getOwnPropSymbols$Y(b)) {
      if (__propIsEnum$Y.call(b, prop))
        __defNormalProp$Y(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$D = (a, b) => __defProps$D(a, __getOwnPropDescs$D(b));
var __objRest$X = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$Y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Y)
    for (var prop of __getOwnPropSymbols$Y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$Y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addShippingAddress$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$X(_a, ["callback", "userId"]);
  delete rest.identify;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$D(__spreadValues$Y({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "add_shipping_info", __spreadValues$Y(__spreadValues$Y({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$X = Object.defineProperty;
var __getOwnPropSymbols$X = Object.getOwnPropertySymbols;
var __hasOwnProp$X = Object.prototype.hasOwnProperty;
var __propIsEnum$X = Object.prototype.propertyIsEnumerable;
var __defNormalProp$X = (obj, key, value) => key in obj ? __defProp$X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$X = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$X.call(b, prop))
      __defNormalProp$X(a, prop, b[prop]);
  if (__getOwnPropSymbols$X)
    for (var prop of __getOwnPropSymbols$X(b)) {
      if (__propIsEnum$X.call(b, prop))
        __defNormalProp$X(a, prop, b[prop]);
    }
  return a;
};
var __objRest$W = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$X.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$X)
    for (var prop of __getOwnPropSymbols$X(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$X.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addShippingAddress$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$W(params, []);
  delete rest.userId;
  delete rest.identify;
  const enhancedParams = __spreadValues$X({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "AddShippingAddress";
  const customData = __spreadValues$X(__spreadValues$X({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$W = Object.defineProperty;
var __getOwnPropSymbols$W = Object.getOwnPropertySymbols;
var __hasOwnProp$W = Object.prototype.hasOwnProperty;
var __propIsEnum$W = Object.prototype.propertyIsEnumerable;
var __defNormalProp$W = (obj, key, value) => key in obj ? __defProp$W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$W = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$W.call(b, prop))
      __defNormalProp$W(a, prop, b[prop]);
  if (__getOwnPropSymbols$W)
    for (var prop of __getOwnPropSymbols$W(b)) {
      if (__propIsEnum$W.call(b, prop))
        __defNormalProp$W(a, prop, b[prop]);
    }
  return a;
};
var __objRest$V = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$W.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$W)
    for (var prop of __getOwnPropSymbols$W(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$W.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addShippingAddress = (provider, params) => {
  const _a = params, { identify } = _a, rest = __objRest$V(_a, ["identify"]);
  delete rest.userId;
  const enhancedParams = __spreadValues$W({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Add Shipping Address", __spreadValues$W(__spreadValues$W({}, transformedParams), transformedMeta));
  if (!identify)
    return;
  analytics.identify(identify.id, identify);
};

const logAddShippingAddress = (params) => {
  triageEventToProviders("addShippingAddress", params, {
    googleAnalyticsHandler: addShippingAddress$2,
    facebookPixelHandler: addShippingAddress$1,
    segmentHandler: addShippingAddress
  });
};

var __defProp$V = Object.defineProperty;
var __defProps$C = Object.defineProperties;
var __getOwnPropDescs$C = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$V = Object.getOwnPropertySymbols;
var __hasOwnProp$V = Object.prototype.hasOwnProperty;
var __propIsEnum$V = Object.prototype.propertyIsEnumerable;
var __defNormalProp$V = (obj, key, value) => key in obj ? __defProp$V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$V = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$V.call(b, prop))
      __defNormalProp$V(a, prop, b[prop]);
  if (__getOwnPropSymbols$V)
    for (var prop of __getOwnPropSymbols$V(b)) {
      if (__propIsEnum$V.call(b, prop))
        __defNormalProp$V(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$C = (a, b) => __defProps$C(a, __getOwnPropDescs$C(b));
var __objRest$U = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$V.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$V)
    for (var prop of __getOwnPropSymbols$V(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$V.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectShippingAddress$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$U(_a, ["callback", "userId"]);
  delete rest.identify;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$C(__spreadValues$V({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "select_shipping_address", __spreadValues$V(__spreadValues$V({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$U = Object.defineProperty;
var __getOwnPropSymbols$U = Object.getOwnPropertySymbols;
var __hasOwnProp$U = Object.prototype.hasOwnProperty;
var __propIsEnum$U = Object.prototype.propertyIsEnumerable;
var __defNormalProp$U = (obj, key, value) => key in obj ? __defProp$U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$U = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$U.call(b, prop))
      __defNormalProp$U(a, prop, b[prop]);
  if (__getOwnPropSymbols$U)
    for (var prop of __getOwnPropSymbols$U(b)) {
      if (__propIsEnum$U.call(b, prop))
        __defNormalProp$U(a, prop, b[prop]);
    }
  return a;
};
var __objRest$T = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$U.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$U)
    for (var prop of __getOwnPropSymbols$U(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$U.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectShippingAddress$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$T(params, []);
  delete rest.userId;
  delete rest.identify;
  const enhancedParams = __spreadValues$U({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SelectShippingAddress";
  const customData = __spreadValues$U(__spreadValues$U({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$T = Object.defineProperty;
var __getOwnPropSymbols$T = Object.getOwnPropertySymbols;
var __hasOwnProp$T = Object.prototype.hasOwnProperty;
var __propIsEnum$T = Object.prototype.propertyIsEnumerable;
var __defNormalProp$T = (obj, key, value) => key in obj ? __defProp$T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$T = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$T.call(b, prop))
      __defNormalProp$T(a, prop, b[prop]);
  if (__getOwnPropSymbols$T)
    for (var prop of __getOwnPropSymbols$T(b)) {
      if (__propIsEnum$T.call(b, prop))
        __defNormalProp$T(a, prop, b[prop]);
    }
  return a;
};
var __objRest$S = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$T.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$T)
    for (var prop of __getOwnPropSymbols$T(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$T.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectShippingAddress = (provider, params) => {
  const _a = params, { identify } = _a, rest = __objRest$S(_a, ["identify"]);
  delete rest.userId;
  const enhancedParams = __spreadValues$T({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Select Shipping Address", __spreadValues$T(__spreadValues$T({}, transformedParams), transformedMeta));
  if (!identify)
    return;
  analytics.identify(identify.id, identify);
};

const logSelectShippingAddress = (params) => {
  triageEventToProviders("selectShippingAddress", params, {
    googleAnalyticsHandler: selectShippingAddress$2,
    facebookPixelHandler: selectShippingAddress$1,
    segmentHandler: selectShippingAddress
  });
};

var __defProp$S = Object.defineProperty;
var __defProps$B = Object.defineProperties;
var __getOwnPropDescs$B = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$S = Object.getOwnPropertySymbols;
var __hasOwnProp$S = Object.prototype.hasOwnProperty;
var __propIsEnum$S = Object.prototype.propertyIsEnumerable;
var __defNormalProp$S = (obj, key, value) => key in obj ? __defProp$S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$S = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$S.call(b, prop))
      __defNormalProp$S(a, prop, b[prop]);
  if (__getOwnPropSymbols$S)
    for (var prop of __getOwnPropSymbols$S(b)) {
      if (__propIsEnum$S.call(b, prop))
        __defNormalProp$S(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$B = (a, b) => __defProps$B(a, __getOwnPropDescs$B(b));
var __objRest$R = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$S.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$S)
    for (var prop of __getOwnPropSymbols$S(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$S.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateShippingAddress$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$R(_a, ["callback", "userId"]);
  delete rest.identify;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$B(__spreadValues$S({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "update_shipping_info", __spreadValues$S(__spreadValues$S({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$R = Object.defineProperty;
var __getOwnPropSymbols$R = Object.getOwnPropertySymbols;
var __hasOwnProp$R = Object.prototype.hasOwnProperty;
var __propIsEnum$R = Object.prototype.propertyIsEnumerable;
var __defNormalProp$R = (obj, key, value) => key in obj ? __defProp$R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$R = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$R.call(b, prop))
      __defNormalProp$R(a, prop, b[prop]);
  if (__getOwnPropSymbols$R)
    for (var prop of __getOwnPropSymbols$R(b)) {
      if (__propIsEnum$R.call(b, prop))
        __defNormalProp$R(a, prop, b[prop]);
    }
  return a;
};
var __objRest$Q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$R.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$R)
    for (var prop of __getOwnPropSymbols$R(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$R.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateShippingAddress$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$Q(params, []);
  delete rest.userId;
  delete rest.identify;
  const enhancedParams = __spreadValues$R({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "UpdateShippingAddress";
  const customData = __spreadValues$R(__spreadValues$R({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$Q = Object.defineProperty;
var __defProps$A = Object.defineProperties;
var __getOwnPropDescs$A = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$Q = Object.getOwnPropertySymbols;
var __hasOwnProp$Q = Object.prototype.hasOwnProperty;
var __propIsEnum$Q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$Q = (obj, key, value) => key in obj ? __defProp$Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$Q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$Q.call(b, prop))
      __defNormalProp$Q(a, prop, b[prop]);
  if (__getOwnPropSymbols$Q)
    for (var prop of __getOwnPropSymbols$Q(b)) {
      if (__propIsEnum$Q.call(b, prop))
        __defNormalProp$Q(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$A = (a, b) => __defProps$A(a, __getOwnPropDescs$A(b));
var __objRest$P = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$Q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$Q)
    for (var prop of __getOwnPropSymbols$Q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$Q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateShippingAddress = (provider, params) => {
  const _a = params, { fields, identify } = _a, rest = __objRest$P(_a, ["fields", "identify"]);
  delete rest.userId;
  const enhancedParams = __spreadProps$A(__spreadValues$Q({}, rest), { fields: transformArrayParam(fields) });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Update Shipping Address", __spreadValues$Q(__spreadValues$Q({}, transformedParams), transformedMeta));
  if (!identify)
    return;
  analytics.identify(identify.id, identify);
};

const logUpdateShippingAddress = (params) => {
  triageEventToProviders("updateShippingAddress", params, {
    googleAnalyticsHandler: updateShippingAddress$2,
    facebookPixelHandler: updateShippingAddress$1,
    segmentHandler: updateShippingAddress
  });
};

const events$7 = {
  logAddShippingAddress,
  logSelectShippingAddress,
  logUpdateShippingAddress
};

var __defProp$P = Object.defineProperty;
var __defProps$z = Object.defineProperties;
var __getOwnPropDescs$z = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$P = Object.getOwnPropertySymbols;
var __hasOwnProp$P = Object.prototype.hasOwnProperty;
var __propIsEnum$P = Object.prototype.propertyIsEnumerable;
var __defNormalProp$P = (obj, key, value) => key in obj ? __defProp$P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$P = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$P.call(b, prop))
      __defNormalProp$P(a, prop, b[prop]);
  if (__getOwnPropSymbols$P)
    for (var prop of __getOwnPropSymbols$P(b)) {
      if (__propIsEnum$P.call(b, prop))
        __defNormalProp$P(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$z = (a, b) => __defProps$z(a, __getOwnPropDescs$z(b));
var __objRest$O = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$P.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$P)
    for (var prop of __getOwnPropSymbols$P(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$P.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addProductToCart$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, product, currency, store, priceCategory } = _a, rest = __objRest$O(_a, ["callback", "userId", "product", "currency", "store", "priceCategory"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { storeName, storeId } = store;
  const enhancedParams = __spreadProps$z(__spreadValues$P({}, rest), {
    userId: selectedUserId,
    storeId,
    storeName,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  gtag("event", "add_to_cart", __spreadValues$P(__spreadValues$P({
    send_to: trackingId,
    event_callback: callback,
    items: [mapProductToGoogleItem(product, selectedCurrency)],
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

var __defProp$O = Object.defineProperty;
var __defProps$y = Object.defineProperties;
var __getOwnPropDescs$y = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$O = Object.getOwnPropertySymbols;
var __hasOwnProp$O = Object.prototype.hasOwnProperty;
var __propIsEnum$O = Object.prototype.propertyIsEnumerable;
var __defNormalProp$O = (obj, key, value) => key in obj ? __defProp$O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$O = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$O.call(b, prop))
      __defNormalProp$O(a, prop, b[prop]);
  if (__getOwnPropSymbols$O)
    for (var prop of __getOwnPropSymbols$O(b)) {
      if (__propIsEnum$O.call(b, prop))
        __defNormalProp$O(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$y = (a, b) => __defProps$y(a, __getOwnPropDescs$y(b));
var __objRest$N = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$O.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$O)
    for (var prop of __getOwnPropSymbols$O(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$O.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addProductToCart$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { product, store, currency, priceCategory } = _a, rest = __objRest$N(_a, ["product", "store", "currency", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const { storeName, storeId } = store;
  const enhancedParams = __spreadProps$y(__spreadValues$O({}, rest), {
    storeId,
    storeName,
    amount,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  const eventName = "AddToCart";
  const customData = __spreadValues$O(__spreadValues$O({
    content_id: productId,
    content_name: name,
    content: getProductContent(product),
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$N = Object.defineProperty;
var __defProps$x = Object.defineProperties;
var __getOwnPropDescs$x = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$N = Object.getOwnPropertySymbols;
var __hasOwnProp$N = Object.prototype.hasOwnProperty;
var __propIsEnum$N = Object.prototype.propertyIsEnumerable;
var __defNormalProp$N = (obj, key, value) => key in obj ? __defProp$N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$N = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$N.call(b, prop))
      __defNormalProp$N(a, prop, b[prop]);
  if (__getOwnPropSymbols$N)
    for (var prop of __getOwnPropSymbols$N(b)) {
      if (__propIsEnum$N.call(b, prop))
        __defNormalProp$N(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$x = (a, b) => __defProps$x(a, __getOwnPropDescs$x(b));
var __objRest$M = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$N.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$N)
    for (var prop of __getOwnPropSymbols$N(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$N.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addProductToCart = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { product, store, currency, priceCategory } = _a, rest = __objRest$M(_a, ["product", "store", "currency", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const { storeName, storeId } = store;
  const enhancedParams = __spreadProps$x(__spreadValues$N({}, rest), {
    storeId,
    storeName,
    productId,
    quantity: amount,
    name,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const { netPrice } = getProductTotals(product);
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  analytics.track("Product Added", __spreadValues$N(__spreadValues$N({
    price: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

const logAddProductToCart = (params) => {
  triageEventToProviders("addProductToCart", params, {
    googleAnalyticsHandler: addProductToCart$2,
    facebookPixelHandler: addProductToCart$1,
    segmentHandler: addProductToCart
  });
};

var __defProp$M = Object.defineProperty;
var __defProps$w = Object.defineProperties;
var __getOwnPropDescs$w = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$M = Object.getOwnPropertySymbols;
var __hasOwnProp$M = Object.prototype.hasOwnProperty;
var __propIsEnum$M = Object.prototype.propertyIsEnumerable;
var __defNormalProp$M = (obj, key, value) => key in obj ? __defProp$M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$M = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$M.call(b, prop))
      __defNormalProp$M(a, prop, b[prop]);
  if (__getOwnPropSymbols$M)
    for (var prop of __getOwnPropSymbols$M(b)) {
      if (__propIsEnum$M.call(b, prop))
        __defNormalProp$M(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$w = (a, b) => __defProps$w(a, __getOwnPropDescs$w(b));
var __objRest$L = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$M.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$M)
    for (var prop of __getOwnPropSymbols$M(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$M.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addProductToWishlist$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, product, currency, priceCategory } = _a, rest = __objRest$L(_a, ["callback", "userId", "product", "currency", "priceCategory"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$w(__spreadValues$M({}, rest), {
    userId: selectedUserId,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  gtag("event", "add_to_wishlist", __spreadValues$M(__spreadValues$M({
    send_to: trackingId,
    event_callback: callback,
    items: [mapProductToGoogleItem(product, selectedCurrency)],
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

var __defProp$L = Object.defineProperty;
var __defProps$v = Object.defineProperties;
var __getOwnPropDescs$v = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$L = Object.getOwnPropertySymbols;
var __hasOwnProp$L = Object.prototype.hasOwnProperty;
var __propIsEnum$L = Object.prototype.propertyIsEnumerable;
var __defNormalProp$L = (obj, key, value) => key in obj ? __defProp$L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$L = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$L.call(b, prop))
      __defNormalProp$L(a, prop, b[prop]);
  if (__getOwnPropSymbols$L)
    for (var prop of __getOwnPropSymbols$L(b)) {
      if (__propIsEnum$L.call(b, prop))
        __defNormalProp$L(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$v = (a, b) => __defProps$v(a, __getOwnPropDescs$v(b));
var __objRest$K = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$L.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$L)
    for (var prop of __getOwnPropSymbols$L(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$L.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addProductToWishlist$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency, priceCategory } = _a, rest = __objRest$K(_a, ["product", "currency", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const enhancedParams = __spreadProps$v(__spreadValues$L({}, rest), {
    amount,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "AddToWishlist";
  const customData = __spreadValues$L(__spreadValues$L({
    content_id: productId,
    content_name: name,
    content: getProductContent(product),
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingle", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$K = Object.defineProperty;
var __defProps$u = Object.defineProperties;
var __getOwnPropDescs$u = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$K = Object.getOwnPropertySymbols;
var __hasOwnProp$K = Object.prototype.hasOwnProperty;
var __propIsEnum$K = Object.prototype.propertyIsEnumerable;
var __defNormalProp$K = (obj, key, value) => key in obj ? __defProp$K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$K = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$K.call(b, prop))
      __defNormalProp$K(a, prop, b[prop]);
  if (__getOwnPropSymbols$K)
    for (var prop of __getOwnPropSymbols$K(b)) {
      if (__propIsEnum$K.call(b, prop))
        __defNormalProp$K(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$u = (a, b) => __defProps$u(a, __getOwnPropDescs$u(b));
var __objRest$J = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$K.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$K)
    for (var prop of __getOwnPropSymbols$K(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$K.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addProductToWishlist = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency, priceCategory } = _a, rest = __objRest$J(_a, ["product", "currency", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const enhancedParams = __spreadProps$u(__spreadValues$K({}, rest), {
    productId,
    quantity: amount,
    name,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const { netPrice } = getProductTotals(product);
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  analytics.track("Add Product To Wishlist", __spreadValues$K(__spreadValues$K({
    price: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

const logAddProductToWishlist = (params) => {
  triageEventToProviders("addProductToWishlist", params, {
    googleAnalyticsHandler: addProductToWishlist$2,
    facebookPixelHandler: addProductToWishlist$1,
    segmentHandler: addProductToWishlist
  });
};

var __defProp$J = Object.defineProperty;
var __defProps$t = Object.defineProperties;
var __getOwnPropDescs$t = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$J = Object.getOwnPropertySymbols;
var __hasOwnProp$J = Object.prototype.hasOwnProperty;
var __propIsEnum$J = Object.prototype.propertyIsEnumerable;
var __defNormalProp$J = (obj, key, value) => key in obj ? __defProp$J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$J = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$J.call(b, prop))
      __defNormalProp$J(a, prop, b[prop]);
  if (__getOwnPropSymbols$J)
    for (var prop of __getOwnPropSymbols$J(b)) {
      if (__propIsEnum$J.call(b, prop))
        __defNormalProp$J(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$t = (a, b) => __defProps$t(a, __getOwnPropDescs$t(b));
var __objRest$I = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$J.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$J)
    for (var prop of __getOwnPropSymbols$J(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$J.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const clearCart$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$I(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$t(__spreadValues$J({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "clear_cart", __spreadValues$J(__spreadValues$J({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$I = Object.defineProperty;
var __getOwnPropSymbols$I = Object.getOwnPropertySymbols;
var __hasOwnProp$I = Object.prototype.hasOwnProperty;
var __propIsEnum$I = Object.prototype.propertyIsEnumerable;
var __defNormalProp$I = (obj, key, value) => key in obj ? __defProp$I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$I = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$I.call(b, prop))
      __defNormalProp$I(a, prop, b[prop]);
  if (__getOwnPropSymbols$I)
    for (var prop of __getOwnPropSymbols$I(b)) {
      if (__propIsEnum$I.call(b, prop))
        __defNormalProp$I(a, prop, b[prop]);
    }
  return a;
};
var __objRest$H = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$I.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$I)
    for (var prop of __getOwnPropSymbols$I(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$I.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const clearCart$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$H(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$I({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ClearCart";
  const customData = __spreadValues$I(__spreadValues$I({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$H = Object.defineProperty;
var __getOwnPropSymbols$H = Object.getOwnPropertySymbols;
var __hasOwnProp$H = Object.prototype.hasOwnProperty;
var __propIsEnum$H = Object.prototype.propertyIsEnumerable;
var __defNormalProp$H = (obj, key, value) => key in obj ? __defProp$H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$H = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$H.call(b, prop))
      __defNormalProp$H(a, prop, b[prop]);
  if (__getOwnPropSymbols$H)
    for (var prop of __getOwnPropSymbols$H(b)) {
      if (__propIsEnum$H.call(b, prop))
        __defNormalProp$H(a, prop, b[prop]);
    }
  return a;
};
var __objRest$G = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$H.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$H)
    for (var prop of __getOwnPropSymbols$H(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$H.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const clearCart = (provider, params) => {
  const rest = __objRest$G(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$H({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Clear Cart", __spreadValues$H(__spreadValues$H({}, transformedParams), transformedMeta));
};

const logClearCart = (params) => {
  triageEventToProviders("clearCart", params, {
    googleAnalyticsHandler: clearCart$2,
    facebookPixelHandler: clearCart$1,
    segmentHandler: clearCart
  });
};

var __defProp$G = Object.defineProperty;
var __defProps$s = Object.defineProperties;
var __getOwnPropDescs$s = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$G = Object.getOwnPropertySymbols;
var __hasOwnProp$G = Object.prototype.hasOwnProperty;
var __propIsEnum$G = Object.prototype.propertyIsEnumerable;
var __defNormalProp$G = (obj, key, value) => key in obj ? __defProp$G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$G = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$G.call(b, prop))
      __defNormalProp$G(a, prop, b[prop]);
  if (__getOwnPropSymbols$G)
    for (var prop of __getOwnPropSymbols$G(b)) {
      if (__propIsEnum$G.call(b, prop))
        __defNormalProp$G(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$s = (a, b) => __defProps$s(a, __getOwnPropDescs$s(b));
var __objRest$F = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$G.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$G)
    for (var prop of __getOwnPropSymbols$G(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$G.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const removeProductFromCart$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, product, currency, store, priceCategory } = _a, rest = __objRest$F(_a, ["callback", "userId", "product", "currency", "store", "priceCategory"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name: productName } = product;
  const { storeName, storeId } = store;
  const enhancedParams = __spreadProps$s(__spreadValues$G({}, rest), {
    userId: selectedUserId,
    productId,
    productName,
    storeId,
    storeName,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  gtag("event", "remove_product_from_cart", __spreadValues$G(__spreadValues$G({
    send_to: trackingId,
    event_callback: callback,
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

var __defProp$F = Object.defineProperty;
var __defProps$r = Object.defineProperties;
var __getOwnPropDescs$r = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$F = Object.getOwnPropertySymbols;
var __hasOwnProp$F = Object.prototype.hasOwnProperty;
var __propIsEnum$F = Object.prototype.propertyIsEnumerable;
var __defNormalProp$F = (obj, key, value) => key in obj ? __defProp$F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$F = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$F.call(b, prop))
      __defNormalProp$F(a, prop, b[prop]);
  if (__getOwnPropSymbols$F)
    for (var prop of __getOwnPropSymbols$F(b)) {
      if (__propIsEnum$F.call(b, prop))
        __defNormalProp$F(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$r = (a, b) => __defProps$r(a, __getOwnPropDescs$r(b));
var __objRest$E = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$F.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$F)
    for (var prop of __getOwnPropSymbols$F(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$F.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const removeProductFromCart$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { product, store, currency, priceCategory } = _a, rest = __objRest$E(_a, ["product", "store", "currency", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const { storeName, storeId } = store;
  const enhancedParams = __spreadProps$r(__spreadValues$F({}, rest), {
    storeId,
    storeName,
    amount,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  const eventName = "RemoveProductFromCart";
  const customData = __spreadValues$F(__spreadValues$F({
    content_id: productId,
    content_name: name,
    content: getProductContent(product),
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$E = Object.defineProperty;
var __defProps$q = Object.defineProperties;
var __getOwnPropDescs$q = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$E = Object.getOwnPropertySymbols;
var __hasOwnProp$E = Object.prototype.hasOwnProperty;
var __propIsEnum$E = Object.prototype.propertyIsEnumerable;
var __defNormalProp$E = (obj, key, value) => key in obj ? __defProp$E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$E = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$E.call(b, prop))
      __defNormalProp$E(a, prop, b[prop]);
  if (__getOwnPropSymbols$E)
    for (var prop of __getOwnPropSymbols$E(b)) {
      if (__propIsEnum$E.call(b, prop))
        __defNormalProp$E(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$q = (a, b) => __defProps$q(a, __getOwnPropDescs$q(b));
var __objRest$D = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$E.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$E)
    for (var prop of __getOwnPropSymbols$E(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$E.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const removeProductFromCart = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { product, store, currency, priceCategory } = _a, rest = __objRest$D(_a, ["product", "store", "currency", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const { storeName, storeId } = store;
  const enhancedParams = __spreadProps$q(__spreadValues$E({}, rest), {
    storeId,
    storeName,
    productId,
    quantity: amount,
    name,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const { netPrice } = getProductTotals(product);
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  analytics.track("Product Removed", __spreadValues$E(__spreadValues$E({
    price: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

const logRemoveProductFromCart = (params) => {
  triageEventToProviders("removeProductFromCart", params, {
    googleAnalyticsHandler: removeProductFromCart$2,
    facebookPixelHandler: removeProductFromCart$1,
    segmentHandler: removeProductFromCart
  });
};

var __defProp$D = Object.defineProperty;
var __defProps$p = Object.defineProperties;
var __getOwnPropDescs$p = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$D = Object.getOwnPropertySymbols;
var __hasOwnProp$D = Object.prototype.hasOwnProperty;
var __propIsEnum$D = Object.prototype.propertyIsEnumerable;
var __defNormalProp$D = (obj, key, value) => key in obj ? __defProp$D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$D = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$D.call(b, prop))
      __defNormalProp$D(a, prop, b[prop]);
  if (__getOwnPropSymbols$D)
    for (var prop of __getOwnPropSymbols$D(b)) {
      if (__propIsEnum$D.call(b, prop))
        __defNormalProp$D(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$p = (a, b) => __defProps$p(a, __getOwnPropDescs$p(b));
var __objRest$C = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$D.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$D)
    for (var prop of __getOwnPropSymbols$D(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$D.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const removeProductFromWishlist$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, product, currency, priceCategory } = _a, rest = __objRest$C(_a, ["callback", "userId", "product", "currency", "priceCategory"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name: productName } = product;
  const enhancedParams = __spreadProps$p(__spreadValues$D({}, rest), {
    userId: selectedUserId,
    productId,
    productName,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  gtag("event", "remove_product_from_wishlist", __spreadValues$D(__spreadValues$D({
    send_to: trackingId,
    event_callback: callback,
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

var __defProp$C = Object.defineProperty;
var __defProps$o = Object.defineProperties;
var __getOwnPropDescs$o = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$C = Object.getOwnPropertySymbols;
var __hasOwnProp$C = Object.prototype.hasOwnProperty;
var __propIsEnum$C = Object.prototype.propertyIsEnumerable;
var __defNormalProp$C = (obj, key, value) => key in obj ? __defProp$C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$C = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$C.call(b, prop))
      __defNormalProp$C(a, prop, b[prop]);
  if (__getOwnPropSymbols$C)
    for (var prop of __getOwnPropSymbols$C(b)) {
      if (__propIsEnum$C.call(b, prop))
        __defNormalProp$C(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$o = (a, b) => __defProps$o(a, __getOwnPropDescs$o(b));
var __objRest$B = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$C.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$C)
    for (var prop of __getOwnPropSymbols$C(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$C.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const removeProductFromWishlist$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency, priceCategory } = _a, rest = __objRest$B(_a, ["product", "currency", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const enhancedParams = __spreadProps$o(__spreadValues$C({}, rest), {
    amount,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  const eventName = "RemoveProductFromWishlist";
  const customData = __spreadValues$C(__spreadValues$C({
    content_id: productId,
    content_name: name,
    content: getProductContent(product),
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$B = Object.defineProperty;
var __defProps$n = Object.defineProperties;
var __getOwnPropDescs$n = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$B = Object.getOwnPropertySymbols;
var __hasOwnProp$B = Object.prototype.hasOwnProperty;
var __propIsEnum$B = Object.prototype.propertyIsEnumerable;
var __defNormalProp$B = (obj, key, value) => key in obj ? __defProp$B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$B = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$B.call(b, prop))
      __defNormalProp$B(a, prop, b[prop]);
  if (__getOwnPropSymbols$B)
    for (var prop of __getOwnPropSymbols$B(b)) {
      if (__propIsEnum$B.call(b, prop))
        __defNormalProp$B(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$n = (a, b) => __defProps$n(a, __getOwnPropDescs$n(b));
var __objRest$A = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$B.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$B)
    for (var prop of __getOwnPropSymbols$B(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$B.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const removeProductFromWishlist = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency, priceCategory } = _a, rest = __objRest$A(_a, ["product", "currency", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const enhancedParams = __spreadProps$n(__spreadValues$B({}, rest), {
    productId,
    quantity: amount,
    name,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const { netPrice } = getProductTotals(product);
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  analytics.track("Remove Product From Wishlist", __spreadValues$B(__spreadValues$B({
    price: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

const logRemoveProductFromWishlist = (params) => {
  triageEventToProviders("removeProductFromWishlist", params, {
    googleAnalyticsHandler: removeProductFromWishlist$2,
    facebookPixelHandler: removeProductFromWishlist$1,
    segmentHandler: removeProductFromWishlist
  });
};

var __defProp$A = Object.defineProperty;
var __defProps$m = Object.defineProperties;
var __getOwnPropDescs$m = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$A = Object.getOwnPropertySymbols;
var __hasOwnProp$A = Object.prototype.hasOwnProperty;
var __propIsEnum$A = Object.prototype.propertyIsEnumerable;
var __defNormalProp$A = (obj, key, value) => key in obj ? __defProp$A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$A = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$A.call(b, prop))
      __defNormalProp$A(a, prop, b[prop]);
  if (__getOwnPropSymbols$A)
    for (var prop of __getOwnPropSymbols$A(b)) {
      if (__propIsEnum$A.call(b, prop))
        __defNormalProp$A(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$m = (a, b) => __defProps$m(a, __getOwnPropDescs$m(b));
var __objRest$z = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$A.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$A)
    for (var prop of __getOwnPropSymbols$A(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$A.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateProductInCart$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, product, currency, store, priceCategory } = _a, rest = __objRest$z(_a, ["callback", "userId", "product", "currency", "store", "priceCategory"]);
  const { productId, name: productName } = product;
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { storeName, storeId } = store;
  const enhancedParams = __spreadProps$m(__spreadValues$A({}, rest), {
    userId: selectedUserId,
    storeId,
    storeName,
    productId,
    productName,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  gtag("event", "update_product_in_cart", __spreadValues$A(__spreadValues$A({
    send_to: trackingId,
    event_callback: callback,
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

var __defProp$z = Object.defineProperty;
var __defProps$l = Object.defineProperties;
var __getOwnPropDescs$l = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$z = Object.getOwnPropertySymbols;
var __hasOwnProp$z = Object.prototype.hasOwnProperty;
var __propIsEnum$z = Object.prototype.propertyIsEnumerable;
var __defNormalProp$z = (obj, key, value) => key in obj ? __defProp$z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$z = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$z.call(b, prop))
      __defNormalProp$z(a, prop, b[prop]);
  if (__getOwnPropSymbols$z)
    for (var prop of __getOwnPropSymbols$z(b)) {
      if (__propIsEnum$z.call(b, prop))
        __defNormalProp$z(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$l = (a, b) => __defProps$l(a, __getOwnPropDescs$l(b));
var __objRest$y = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$z.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$z)
    for (var prop of __getOwnPropSymbols$z(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$z.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateProductInCart$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { product, store, currency, priceCategory } = _a, rest = __objRest$y(_a, ["product", "store", "currency", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const { storeName, storeId } = store;
  const enhancedParams = __spreadProps$l(__spreadValues$z({}, rest), {
    storeId,
    storeName,
    amount,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  const eventName = "UpdateProductInCart";
  const customData = __spreadValues$z(__spreadValues$z({
    content_id: productId,
    content_name: name,
    content: getProductContent(product),
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$y = Object.defineProperty;
var __defProps$k = Object.defineProperties;
var __getOwnPropDescs$k = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$y = Object.getOwnPropertySymbols;
var __hasOwnProp$y = Object.prototype.hasOwnProperty;
var __propIsEnum$y = Object.prototype.propertyIsEnumerable;
var __defNormalProp$y = (obj, key, value) => key in obj ? __defProp$y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$y = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$y.call(b, prop))
      __defNormalProp$y(a, prop, b[prop]);
  if (__getOwnPropSymbols$y)
    for (var prop of __getOwnPropSymbols$y(b)) {
      if (__propIsEnum$y.call(b, prop))
        __defNormalProp$y(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$k = (a, b) => __defProps$k(a, __getOwnPropDescs$k(b));
var __objRest$x = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$y.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$y)
    for (var prop of __getOwnPropSymbols$y(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$y.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateProductInCart = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { product, store, currency, fields, priceCategory } = _a, rest = __objRest$x(_a, ["product", "store", "currency", "fields", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const { storeName, storeId } = store;
  const enhancedParams = __spreadProps$k(__spreadValues$y({}, rest), {
    storeId,
    storeName,
    productId,
    quantity: amount,
    name,
    currency: selectedCurrency,
    fields: transformArrayParam(fields)
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const { netPrice } = getProductTotals(product);
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  analytics.track("Update Product In Cart", __spreadValues$y(__spreadValues$y({
    price: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

const logUpdateProductInCart = (params) => {
  triageEventToProviders("updateProductInCart", params, {
    googleAnalyticsHandler: updateProductInCart$2,
    facebookPixelHandler: updateProductInCart$1,
    segmentHandler: updateProductInCart
  });
};

var __defProp$x = Object.defineProperty;
var __defProps$j = Object.defineProperties;
var __getOwnPropDescs$j = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$x = Object.getOwnPropertySymbols;
var __hasOwnProp$x = Object.prototype.hasOwnProperty;
var __propIsEnum$x = Object.prototype.propertyIsEnumerable;
var __defNormalProp$x = (obj, key, value) => key in obj ? __defProp$x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$x = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$x.call(b, prop))
      __defNormalProp$x(a, prop, b[prop]);
  if (__getOwnPropSymbols$x)
    for (var prop of __getOwnPropSymbols$x(b)) {
      if (__propIsEnum$x.call(b, prop))
        __defNormalProp$x(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$j = (a, b) => __defProps$j(a, __getOwnPropDescs$j(b));
var __objRest$w = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$x.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$x)
    for (var prop of __getOwnPropSymbols$x(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$x.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateProductInWishlist$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { callback, userId, product, currency, priceCategory } = _a, rest = __objRest$w(_a, ["callback", "userId", "product", "currency", "priceCategory"]);
  const { productId, name: productName } = product;
  const selectedUserId = userId != null ? userId : providerUserId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const enhancedParams = __spreadProps$j(__spreadValues$x({}, rest), {
    userId: selectedUserId,
    productId,
    productName,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  gtag("event", "update_product_in_wishlist", __spreadValues$x(__spreadValues$x({
    send_to: trackingId,
    event_callback: callback,
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

var __defProp$w = Object.defineProperty;
var __defProps$i = Object.defineProperties;
var __getOwnPropDescs$i = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$w = Object.getOwnPropertySymbols;
var __hasOwnProp$w = Object.prototype.hasOwnProperty;
var __propIsEnum$w = Object.prototype.propertyIsEnumerable;
var __defNormalProp$w = (obj, key, value) => key in obj ? __defProp$w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$w = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$w.call(b, prop))
      __defNormalProp$w(a, prop, b[prop]);
  if (__getOwnPropSymbols$w)
    for (var prop of __getOwnPropSymbols$w(b)) {
      if (__propIsEnum$w.call(b, prop))
        __defNormalProp$w(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$i = (a, b) => __defProps$i(a, __getOwnPropDescs$i(b));
var __objRest$v = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$w.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$w)
    for (var prop of __getOwnPropSymbols$w(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$w.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateProductInWishlist$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency, priceCategory } = _a, rest = __objRest$v(_a, ["product", "currency", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const enhancedParams = __spreadProps$i(__spreadValues$w({}, rest), {
    amount,
    currency: selectedCurrency
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { netPrice } = getProductTotals(product);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  const eventName = "UpdateProductInWishlist";
  const customData = __spreadValues$w(__spreadValues$w({
    content_id: productId,
    content_name: name,
    content: getProductContent(product),
    value: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$v = Object.defineProperty;
var __defProps$h = Object.defineProperties;
var __getOwnPropDescs$h = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$v = Object.getOwnPropertySymbols;
var __hasOwnProp$v = Object.prototype.hasOwnProperty;
var __propIsEnum$v = Object.prototype.propertyIsEnumerable;
var __defNormalProp$v = (obj, key, value) => key in obj ? __defProp$v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$v = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$v.call(b, prop))
      __defNormalProp$v(a, prop, b[prop]);
  if (__getOwnPropSymbols$v)
    for (var prop of __getOwnPropSymbols$v(b)) {
      if (__propIsEnum$v.call(b, prop))
        __defNormalProp$v(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$h = (a, b) => __defProps$h(a, __getOwnPropDescs$h(b));
var __objRest$u = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$v.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$v)
    for (var prop of __getOwnPropSymbols$v(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$v.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateProductInWishlist = (provider, params) => {
  const { currency: providerCurrency } = provider;
  const _a = params, { product, currency, fields, priceCategory } = _a, rest = __objRest$u(_a, ["product", "currency", "fields", "priceCategory"]);
  delete rest.userId;
  const selectedCurrency = currency != null ? currency : providerCurrency;
  const { productId, name, amount } = product;
  const enhancedParams = __spreadProps$h(__spreadValues$v({}, rest), {
    productId,
    quantity: amount,
    name,
    currency: selectedCurrency,
    fields: transformArrayParam(fields)
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const { priceCategory: productPriceCategory } = product;
  const finalPriceCategory = priceCategory != null ? priceCategory : productPriceCategory;
  const { netPrice } = getProductTotals(product);
  const totalPrice = finalPriceCategory === "NORMAL" ? netPrice : 0;
  const totalPoints = finalPriceCategory === "POINTS" ? netPrice : 0;
  analytics.track("Update Product In Wishlist", __spreadValues$v(__spreadValues$v({
    price: totalPrice,
    points: totalPoints
  }, transformedParams), transformedMeta));
};

const logUpdateProductInWishlist = (params) => {
  triageEventToProviders("updateProductInWishlist", params, {
    googleAnalyticsHandler: updateProductInWishlist$2,
    facebookPixelHandler: updateProductInWishlist$1,
    segmentHandler: updateProductInWishlist
  });
};

var __defProp$u = Object.defineProperty;
var __defProps$g = Object.defineProperties;
var __getOwnPropDescs$g = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$u = Object.getOwnPropertySymbols;
var __hasOwnProp$u = Object.prototype.hasOwnProperty;
var __propIsEnum$u = Object.prototype.propertyIsEnumerable;
var __defNormalProp$u = (obj, key, value) => key in obj ? __defProp$u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$u = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$u.call(b, prop))
      __defNormalProp$u(a, prop, b[prop]);
  if (__getOwnPropSymbols$u)
    for (var prop of __getOwnPropSymbols$u(b)) {
      if (__propIsEnum$u.call(b, prop))
        __defNormalProp$u(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$g = (a, b) => __defProps$g(a, __getOwnPropDescs$g(b));
var __objRest$t = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$u.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$u)
    for (var prop of __getOwnPropSymbols$u(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$u.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewCart$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$t(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$g(__spreadValues$u({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "view_cart", __spreadValues$u(__spreadValues$u({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$t = Object.defineProperty;
var __getOwnPropSymbols$t = Object.getOwnPropertySymbols;
var __hasOwnProp$t = Object.prototype.hasOwnProperty;
var __propIsEnum$t = Object.prototype.propertyIsEnumerable;
var __defNormalProp$t = (obj, key, value) => key in obj ? __defProp$t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$t = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$t.call(b, prop))
      __defNormalProp$t(a, prop, b[prop]);
  if (__getOwnPropSymbols$t)
    for (var prop of __getOwnPropSymbols$t(b)) {
      if (__propIsEnum$t.call(b, prop))
        __defNormalProp$t(a, prop, b[prop]);
    }
  return a;
};
var __objRest$s = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$t.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$t)
    for (var prop of __getOwnPropSymbols$t(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$t.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewCart$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$s(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$t({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ViewCart";
  const customData = __spreadValues$t(__spreadValues$t({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$s = Object.defineProperty;
var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
var __hasOwnProp$s = Object.prototype.hasOwnProperty;
var __propIsEnum$s = Object.prototype.propertyIsEnumerable;
var __defNormalProp$s = (obj, key, value) => key in obj ? __defProp$s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$s = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$s.call(b, prop))
      __defNormalProp$s(a, prop, b[prop]);
  if (__getOwnPropSymbols$s)
    for (var prop of __getOwnPropSymbols$s(b)) {
      if (__propIsEnum$s.call(b, prop))
        __defNormalProp$s(a, prop, b[prop]);
    }
  return a;
};
var __objRest$r = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$s.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$s)
    for (var prop of __getOwnPropSymbols$s(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$s.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const viewCart = (provider, params) => {
  const _a = params, { products } = _a, rest = __objRest$r(_a, ["products"]);
  delete rest.userId;
  const enhancedParams = __spreadValues$s({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Cart Viewed", __spreadValues$s(__spreadValues$s({
    products: mapProductsToSegmentProducts(products)
  }, transformedParams), transformedMeta));
};

const logViewCart = (params) => {
  triageEventToProviders("viewCart", params, {
    googleAnalyticsHandler: viewCart$2,
    facebookPixelHandler: viewCart$1,
    segmentHandler: viewCart
  });
};

const events$6 = {
  logAddProductToCart,
  logAddProductToWishlist,
  logClearCart,
  logRemoveProductFromCart,
  logRemoveProductFromWishlist,
  logUpdateProductInCart,
  logUpdateProductInWishlist,
  logViewCart
};

var __defProp$r = Object.defineProperty;
var __defProps$f = Object.defineProperties;
var __getOwnPropDescs$f = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
var __hasOwnProp$r = Object.prototype.hasOwnProperty;
var __propIsEnum$r = Object.prototype.propertyIsEnumerable;
var __defNormalProp$r = (obj, key, value) => key in obj ? __defProp$r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$r = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$r.call(b, prop))
      __defNormalProp$r(a, prop, b[prop]);
  if (__getOwnPropSymbols$r)
    for (var prop of __getOwnPropSymbols$r(b)) {
      if (__propIsEnum$r.call(b, prop))
        __defNormalProp$r(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$f = (a, b) => __defProps$f(a, __getOwnPropDescs$f(b));
var __objRest$q = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$r.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$r)
    for (var prop of __getOwnPropSymbols$r(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$r.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const share$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, shareTarget, itemId } = _a, rest = __objRest$q(_a, ["callback", "userId", "shareTarget", "itemId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$f(__spreadValues$r({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "share", __spreadValues$r(__spreadValues$r({
    send_to: trackingId,
    event_callback: callback,
    method: shareTarget,
    content_id: itemId
  }, transformedParams), transformedMeta));
};

var __defProp$q = Object.defineProperty;
var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
var __hasOwnProp$q = Object.prototype.hasOwnProperty;
var __propIsEnum$q = Object.prototype.propertyIsEnumerable;
var __defNormalProp$q = (obj, key, value) => key in obj ? __defProp$q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$q = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$q.call(b, prop))
      __defNormalProp$q(a, prop, b[prop]);
  if (__getOwnPropSymbols$q)
    for (var prop of __getOwnPropSymbols$q(b)) {
      if (__propIsEnum$q.call(b, prop))
        __defNormalProp$q(a, prop, b[prop]);
    }
  return a;
};
var __objRest$p = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$q.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$q)
    for (var prop of __getOwnPropSymbols$q(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$q.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const share$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$p(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$q({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "Share";
  const customData = __spreadValues$q(__spreadValues$q({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$p = Object.defineProperty;
var __defProps$e = Object.defineProperties;
var __getOwnPropDescs$e = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
var __hasOwnProp$p = Object.prototype.hasOwnProperty;
var __propIsEnum$p = Object.prototype.propertyIsEnumerable;
var __defNormalProp$p = (obj, key, value) => key in obj ? __defProp$p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$p = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$p.call(b, prop))
      __defNormalProp$p(a, prop, b[prop]);
  if (__getOwnPropSymbols$p)
    for (var prop of __getOwnPropSymbols$p(b)) {
      if (__propIsEnum$p.call(b, prop))
        __defNormalProp$p(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$e = (a, b) => __defProps$e(a, __getOwnPropDescs$e(b));
var __objRest$o = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$p.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$p)
    for (var prop of __getOwnPropSymbols$p(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$p.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const share = (provider, params) => {
  const _a = params, { shareTarget } = _a, rest = __objRest$o(_a, ["shareTarget"]);
  delete rest.userId;
  const enhancedParams = __spreadProps$e(__spreadValues$p({}, rest), { shareVia: shareTarget });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Share", __spreadValues$p(__spreadValues$p({}, transformedParams), transformedMeta));
};

const logShare = (params) => {
  triageEventToProviders("share", params, {
    googleAnalyticsHandler: share$2,
    facebookPixelHandler: share$1,
    segmentHandler: share
  });
};

const events$5 = { logShare };

var __defProp$o = Object.defineProperty;
var __defProps$d = Object.defineProperties;
var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
var __hasOwnProp$o = Object.prototype.hasOwnProperty;
var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
var __defNormalProp$o = (obj, key, value) => key in obj ? __defProp$o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$o = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$o.call(b, prop))
      __defNormalProp$o(a, prop, b[prop]);
  if (__getOwnPropSymbols$o)
    for (var prop of __getOwnPropSymbols$o(b)) {
      if (__propIsEnum$o.call(b, prop))
        __defNormalProp$o(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$d = (a, b) => __defProps$d(a, __getOwnPropDescs$d(b));
var __objRest$n = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$o.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$o)
    for (var prop of __getOwnPropSymbols$o(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$o.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changeStore$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, previousStore, nextStore } = _a, rest = __objRest$n(_a, ["callback", "userId", "previousStore", "nextStore"]);
  const { storeId: previousStoreId } = previousStore;
  const { storeName: previousStoreName } = previousStore;
  const { storeId: nextStoreId, storeName: nextStoreName } = nextStore;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$d(__spreadValues$o({}, rest), {
    userId: selectedUserId,
    previousStoreId,
    previousStoreName,
    nextStoreId,
    nextStoreName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "change_store", __spreadValues$o(__spreadValues$o({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$n = Object.defineProperty;
var __defProps$c = Object.defineProperties;
var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
var __hasOwnProp$n = Object.prototype.hasOwnProperty;
var __propIsEnum$n = Object.prototype.propertyIsEnumerable;
var __defNormalProp$n = (obj, key, value) => key in obj ? __defProp$n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$n = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$n.call(b, prop))
      __defNormalProp$n(a, prop, b[prop]);
  if (__getOwnPropSymbols$n)
    for (var prop of __getOwnPropSymbols$n(b)) {
      if (__propIsEnum$n.call(b, prop))
        __defNormalProp$n(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$c = (a, b) => __defProps$c(a, __getOwnPropDescs$c(b));
var __objRest$m = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$n.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$n)
    for (var prop of __getOwnPropSymbols$n(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$n.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changeStore$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { previousStore, nextStore } = _a, rest = __objRest$m(_a, ["previousStore", "nextStore"]);
  delete rest.userId;
  const { storeId: previousStoreId } = previousStore;
  const { storeName: previousStoreName } = previousStore;
  const { storeId: nextStoreId, storeName: nextStoreName } = nextStore;
  const enhancedParams = __spreadProps$c(__spreadValues$n({}, rest), {
    previousStoreId,
    previousStoreName,
    nextStoreId,
    nextStoreName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ChangeStore";
  const customData = __spreadValues$n(__spreadValues$n({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$m = Object.defineProperty;
var __defProps$b = Object.defineProperties;
var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
var __hasOwnProp$m = Object.prototype.hasOwnProperty;
var __propIsEnum$m = Object.prototype.propertyIsEnumerable;
var __defNormalProp$m = (obj, key, value) => key in obj ? __defProp$m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$m = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$m.call(b, prop))
      __defNormalProp$m(a, prop, b[prop]);
  if (__getOwnPropSymbols$m)
    for (var prop of __getOwnPropSymbols$m(b)) {
      if (__propIsEnum$m.call(b, prop))
        __defNormalProp$m(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$b = (a, b) => __defProps$b(a, __getOwnPropDescs$b(b));
var __objRest$l = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$m.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$m)
    for (var prop of __getOwnPropSymbols$m(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$m.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changeStore = (provider, params) => {
  const _a = params, { previousStore, nextStore } = _a, rest = __objRest$l(_a, ["previousStore", "nextStore"]);
  delete rest.userId;
  const { storeId: previousStoreId } = previousStore;
  const { storeName: previousStoreName } = previousStore;
  const { storeId: nextStoreId, storeName: nextStoreName } = nextStore;
  const enhancedParams = __spreadProps$b(__spreadValues$m({}, rest), {
    previousStoreId,
    previousStoreName,
    nextStoreId,
    nextStoreName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Change Store", __spreadValues$m(__spreadValues$m({}, transformedParams), transformedMeta));
};

const logChangeStore = (params) => {
  triageEventToProviders("changeStore", params, {
    googleAnalyticsHandler: changeStore$2,
    facebookPixelHandler: changeStore$1,
    segmentHandler: changeStore
  });
};

var __defProp$l = Object.defineProperty;
var __defProps$a = Object.defineProperties;
var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
var __hasOwnProp$l = Object.prototype.hasOwnProperty;
var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$l = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$l.call(b, prop))
      __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$l)
    for (var prop of __getOwnPropSymbols$l(b)) {
      if (__propIsEnum$l.call(b, prop))
        __defNormalProp$l(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$a = (a, b) => __defProps$a(a, __getOwnPropDescs$a(b));
var __objRest$k = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$l.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$l)
    for (var prop of __getOwnPropSymbols$l(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$l.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setStore$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId, store } = _a, rest = __objRest$k(_a, ["callback", "userId", "store"]);
  const { storeId, storeName } = store;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$a(__spreadValues$l({}, rest), {
    userId: selectedUserId,
    storeId,
    storeName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "set_store", __spreadValues$l(__spreadValues$l({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$k = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
var __hasOwnProp$k = Object.prototype.hasOwnProperty;
var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$k = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$k.call(b, prop))
      __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$k)
    for (var prop of __getOwnPropSymbols$k(b)) {
      if (__propIsEnum$k.call(b, prop))
        __defNormalProp$k(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$9 = (a, b) => __defProps$9(a, __getOwnPropDescs$9(b));
var __objRest$j = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$k.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$k)
    for (var prop of __getOwnPropSymbols$k(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$k.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setStore$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const _a = params, { store } = _a, rest = __objRest$j(_a, ["store"]);
  delete rest.userId;
  const { storeId, storeName } = store;
  const enhancedParams = __spreadProps$9(__spreadValues$k({}, rest), {
    storeId,
    storeName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SetStore";
  const customData = __spreadValues$k(__spreadValues$k({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$j = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$j.call(b, prop))
      __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(b)) {
      if (__propIsEnum$j.call(b, prop))
        __defNormalProp$j(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$8 = (a, b) => __defProps$8(a, __getOwnPropDescs$8(b));
var __objRest$i = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$j.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$j.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setStore = (provider, params) => {
  const _a = params, { store } = _a, rest = __objRest$i(_a, ["store"]);
  delete rest.userId;
  const { storeId, storeName } = store;
  const enhancedParams = __spreadProps$8(__spreadValues$j({}, rest), {
    storeId,
    storeName
  });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Set Store", __spreadValues$j(__spreadValues$j({}, transformedParams), transformedMeta));
};

const logSetStore = (params) => {
  triageEventToProviders("setStore", params, {
    googleAnalyticsHandler: setStore$2,
    facebookPixelHandler: setStore$1,
    segmentHandler: setStore
  });
};

const events$4 = { logChangeStore, logSetStore };

var __defProp$i = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$i.call(b, prop))
      __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(b)) {
      if (__propIsEnum$i.call(b, prop))
        __defNormalProp$i(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
var __objRest$h = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$i.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$i.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setUserInfo$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$h(_a, ["callback", "userId"]);
  delete rest.identify;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$7(__spreadValues$i({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "set_user_info", __spreadValues$i(__spreadValues$i({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$h = Object.defineProperty;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$h.call(b, prop))
      __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(b)) {
      if (__propIsEnum$h.call(b, prop))
        __defNormalProp$h(a, prop, b[prop]);
    }
  return a;
};
var __objRest$g = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$h.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$h.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setUserInfo$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$g(params, []);
  delete rest.userId;
  delete rest.identify;
  const enhancedParams = __spreadValues$h({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SetUserInfo";
  const customData = __spreadValues$h(__spreadValues$h({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$g = Object.defineProperty;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$g.call(b, prop))
      __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(b)) {
      if (__propIsEnum$g.call(b, prop))
        __defNormalProp$g(a, prop, b[prop]);
    }
  return a;
};
var __objRest$f = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$g.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$g.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setUserInfo = (provider, params) => {
  const _a = params, { identify } = _a, rest = __objRest$f(_a, ["identify"]);
  delete rest.userId;
  const enhancedParams = __spreadValues$g({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Set User Info", __spreadValues$g(__spreadValues$g({}, transformedParams), transformedMeta));
  if (!identify)
    return;
  analytics.identify(identify.id, identify);
};

const logSetUserInfo = (params) => {
  triageEventToProviders("setUserInfo", params, {
    googleAnalyticsHandler: setUserInfo$2,
    facebookPixelHandler: setUserInfo$1,
    segmentHandler: setUserInfo
  });
};

var __defProp$f = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(b)) {
      if (__propIsEnum$f.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
var __objRest$e = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$f.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$f.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateUserInfo$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$e(_a, ["callback", "userId"]);
  delete rest.identify;
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$6(__spreadValues$f({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "update_user_info", __spreadValues$f(__spreadValues$f({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$e = Object.defineProperty;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
var __objRest$d = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$e.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$e.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateUserInfo$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$d(params, []);
  delete rest.userId;
  delete rest.identify;
  const enhancedParams = __spreadValues$e({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "UpdateUserInfo";
  const customData = __spreadValues$e(__spreadValues$e({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$d = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
var __objRest$c = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$d.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$d.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateUserInfo = (provider, params) => {
  const _a = params, { fields, identify } = _a, rest = __objRest$c(_a, ["fields", "identify"]);
  delete rest.userId;
  const enhancedParams = __spreadProps$5(__spreadValues$d({}, rest), { fields: transformArrayParam(fields) });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Update User Info", __spreadValues$d(__spreadValues$d({}, transformedParams), transformedMeta));
  if (!identify)
    return;
  analytics.identify(identify.id, identify);
};

const logUpdateUserInfo = (params) => {
  triageEventToProviders("updateUserInfo", params, {
    googleAnalyticsHandler: updateUserInfo$2,
    facebookPixelHandler: updateUserInfo$1,
    segmentHandler: updateUserInfo
  });
};

const events$3 = { logSetUserInfo, logUpdateUserInfo };

var __defProp$c = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
var __objRest$b = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changeVendor$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$b(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$4(__spreadValues$c({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "change_vendor", __spreadValues$c(__spreadValues$c({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$a = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changeVendor$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$a(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$b({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "ChangeVendor";
  const customData = __spreadValues$b(__spreadValues$b({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$a = Object.defineProperty;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
var __objRest$9 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const changeVendor = (provider, params) => {
  const rest = __objRest$9(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$a({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Change Vendor", __spreadValues$a(__spreadValues$a({}, transformedParams), transformedMeta));
};

const logChangeVendor = (params) => {
  triageEventToProviders("changeVendor", params, {
    googleAnalyticsHandler: changeVendor$2,
    facebookPixelHandler: changeVendor$1,
    segmentHandler: changeVendor
  });
};

var __defProp$9 = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
var __objRest$8 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$9.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$9.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setVendor$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$8(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$3(__spreadValues$9({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "set_vendor", __spreadValues$9(__spreadValues$9({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$8.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$8.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setVendor$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$7(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$8({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SetVendor";
  const customData = __spreadValues$8(__spreadValues$8({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$7 = Object.defineProperty;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const setVendor = (provider, params) => {
  const rest = __objRest$6(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$7({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Set Vendor", __spreadValues$7(__spreadValues$7({}, transformedParams), transformedMeta));
};

const logSetVendor = (params) => {
  triageEventToProviders("setVendor", params, {
    googleAnalyticsHandler: setVendor$2,
    facebookPixelHandler: setVendor$1,
    segmentHandler: setVendor
  });
};

const events$2 = { logChangeVendor, logSetVendor };

var __defProp$6 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
var __objRest$5 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectWorkflow$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$5(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$2(__spreadValues$6({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "select_workflow", __spreadValues$6(__spreadValues$6({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectWorkflow$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$4(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$5({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "SelectWorkflow";
  const customData = __spreadValues$5(__spreadValues$5({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const selectWorkflow = (provider, params) => {
  const rest = __objRest$3(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$4({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Select Workflow", __spreadValues$4(__spreadValues$4({}, transformedParams), transformedMeta));
};

const logSelectWorkflow = (params) => {
  triageEventToProviders("selectWorkflow", params, {
    googleAnalyticsHandler: selectWorkflow$2,
    facebookPixelHandler: selectWorkflow$1,
    segmentHandler: selectWorkflow
  });
};

var __defProp$3 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateWorkflow$2 = (provider, params) => {
  const { trackingId, userId: providerUserId } = provider;
  const _a = params, { callback, userId } = _a, rest = __objRest$2(_a, ["callback", "userId"]);
  const selectedUserId = userId != null ? userId : providerUserId;
  const enhancedParams = __spreadProps$1(__spreadValues$3({}, rest), { userId: selectedUserId });
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  gtag("event", "update_workflow", __spreadValues$3(__spreadValues$3({
    send_to: trackingId,
    event_callback: callback
  }, transformedParams), transformedMeta));
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateWorkflow$1 = (provider, params) => {
  const { trackingId, conversionsApiConfig } = provider;
  const { isTrackingAllowed, withConversionsAPI } = provider;
  const rest = __objRest$1(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$2({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  const eventName = "UpdateWorkflow";
  const customData = __spreadValues$2(__spreadValues$2({}, transformedParams), transformedMeta);
  if (isTrackingAllowed) {
    fbq("trackSingleCustom", trackingId, eventName, customData);
    return;
  }
  sendFacebookConversionEvent({
    withConversionsAPI: !!withConversionsAPI,
    eventName,
    conversionsApiConfig,
    customData
  });
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const updateWorkflow = (provider, params) => {
  const rest = __objRest(params, []);
  delete rest.userId;
  const enhancedParams = __spreadValues$1({}, rest);
  const transformedParams = eventParamsToSnakeCase(enhancedParams);
  const { meta } = State().state;
  const transformedMeta = eventParamsToSnakeCase(meta);
  analytics.track("Update Workflow", __spreadValues$1(__spreadValues$1({}, transformedParams), transformedMeta));
};

const logUpdateWorkflow = (params) => {
  triageEventToProviders("updateWorkflow", params, {
    googleAnalyticsHandler: updateWorkflow$2,
    facebookPixelHandler: updateWorkflow$1,
    segmentHandler: updateWorkflow
  });
};

const events$1 = { logSelectWorkflow, logUpdateWorkflow };

const events = {
  auth: events$p,
  banner: events$o,
  billing: events$n,
  booking: events$m,
  category: events$l,
  checkout: events$k,
  coupon: events$j,
  credit: events$i,
  fulfillment: events$h,
  geo: events$g,
  help: events$f,
  logCustomEvent,
  loyalty: events$e,
  order: events$d,
  other: events$c,
  payment: events$b,
  product: events$a,
  purchase: events$9,
  settings: events$8,
  shipping: events$7,
  shoppingCart: events$6,
  social: events$5,
  store: events$4,
  user: events$3,
  vendor: events$2,
  workflow: events$1
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const updateActiveVendor = (vendor) => {
  const vendorType = typeof vendor;
  if (vendorType !== "string" && vendor !== -1 && vendorType !== "object" && vendorType !== "undefined") {
    return logMessage("The type of vendor must be a string, -1 or Vendor type", "severe");
  }
  const oldState = State().state;
  if (typeof vendor === "string" || typeof vendor === "undefined" || vendor === -1) {
    State().setState(__spreadProps(__spreadValues({}, oldState), {
      activeVendor: vendor,
      meta: __spreadProps(__spreadValues({}, oldState.meta), { vendorName: void 0, vendorId: vendor })
    }));
  } else {
    const { id, name } = vendor;
    State().setState(__spreadProps(__spreadValues({}, oldState), {
      activeVendor: id,
      meta: __spreadProps(__spreadValues({}, oldState.meta), { vendorName: name, vendorId: id })
    }));
  }
};

const identifyUser = (identify) => {
  analytics.identify(identify.id, identify);
};

export { Providers, checkInit, events, identifyUser, initAnalytics, updateActiveVendor };
//# sourceMappingURL=bundle.mjs.map
